export const newsIndexData = {
  bannerData: {
    title: '资源库',
    desc: '作为客户拥护者，我们为您提供Crane Worldwide Logistics专家的最新行业信息',
    image: require("@/assets/images/news/banner-01.jpg")
  },
  navList: [
    {
      name: '市场更新',
      desc: '我们的专家全天候安全工作，提供有关空运、海运、陆运、铁路和供应链其他领域的最新信息。',
      path: '/news?type=market',
    },
    {
      name: '行业洞察新闻',
      desc: 'Crane Worldwide Logistics提供最新的“ Industry Insight”信息，以使您随时了解当前问题，并及时了解最新的行业趋势和物流新闻。',
      path: '/news?type=industry',
    },
    {name: '贸易咨询公告', desc: '来自我们的贸易咨询专家的所有最新信息', path: '/news?type=trade',},
    {
      name: '客户案例',
      desc: '从最新的案例研究中了解有关我们如何解决客户的物流挑战的更多信息。',
      path: '/news?type=case',
    },
    {name: '播客', desc: '', path: '/news?type=podcast',},
    {
      name: 'Incoterms® - 运输条款指南',
      desc: '11 条 Incoterms 概述，请在此处下载免费的 Incoterms 图表。',
      path: '/news?type=guide',
    },
    {
      name: '新闻中心',
      desc: '新闻中心包括Crane Worldwide Logistics发布的所有最新外部版本。 对于所有媒体查询，请联系Kate.Yates@craneww.com',
      path: '/news?type=press',
    },
    {
      name: '英国脱欧和欧盟',
      desc: '英国脱离欧盟的持续挑战？ 在此处获取有关英国退欧的最新信息。',
      path: '/news?type=exit',
    },
  ]
}

export const marketData = {
  list: [
    {
      id: '1',
      time: '2024 年 8 月 20 日',
      image: require("@/assets/images/news/market-banner-01.png"),
      title: '所有最新货运新闻 - 空运、海运和陆运更新',
      desc: '',
      detail: `
          <p>2024 年 8 月 20 日</p>
          <h1>全球货运市场新闻 - 2024 年 XNUMX 月</h1>
          <p>我们的物流专家团队提供的最新货运市场更新内容现已提供 PDF 格式供下载。&nbsp;</p>
          <ul>
            <li>欲了解更多信息，您可以详细了解&nbsp;<strong>加拿大铁路货运中断</strong>
              在我们的行业洞察更新中。&nbsp;
            </li>
            <li>Crane Worldwide Logistics 的业务遍布全球，提供仓储和配送服务，满足您的国际需求。我们的 <strong><a
                href="/address">全球货运和物流地点</a></strong> 可以支持您的业务。
            </li>
            <li>我们的 <strong><a href="/service?type=contract">合同物流</a></strong>
              我们的足迹正在不断扩大，我们有仓库空间来支持您
              温哥华至 波士顿 至 约翰内斯堡，如果您需要3PL库存管理和增值服务，请与团队联系。&nbsp;
            </li>
            <li>别忘了，你可以在我们的 <strong><a href="/news?type=podcast">“与
              Crane 一起喝咖啡”播客</a></strong> 可以在您最喜欢的播客播放器上收听：&nbsp;<strong><a
                href="https://open.spotify.com/show/3PV6j3xuM59hR3060mdO9Z">Spotify</a>,&nbsp;</strong><strong><a
                href="https://www.google.com/podcasts?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy8xNDg0ZDMwYy9wb2RjYXN0L3Jzcw==">Google播客</a>,&nbsp;</strong><strong><a
                href="https://podcasts.apple.com/us/podcast/coffee-with-crane/id1508247853">Apple播客</a></strong></li>
          </ul>
          <hr>
          <h2>空运新闻</h2>
          <ul>
            <li>货运力（以可用货运吨公里 (ACTKs) 表示）与 8.8 年 2023 月相比增长了 10.8%，其中国际业务增长了 XNUMX%。</li>
            <li>总体而言，今年上半年（H1）的需求较 13.4 年上半年增长 1%，比 2023 年上半年增长 4.3%。</li>
          </ul>
          <p class="gt-block" style="text-align: center;">
            <a class="button button_size_lg button_color_secondary"
               href="https://www.craneww.com/site/assets/files/4067/marketupdate_air_august2024.pdf"
               left="">下载空运更新</a></p>
          <hr>
          <h2>海运新闻</h2>
          <ul>
            <li>尽管人们担心经济降温，但洛杉矶港和长滩港 2021 月份经历了有史以来最繁忙的月份之一，接近 XNUMX 年 XNUMX
              月份的历史最高纪录。&nbsp;
            </li>
            <li>9 月 60 日星期五，一艘阳明海运船只发生爆炸，导致宁波北仑三期码头关闭 12 小时。XNUMX 月 XNUMX
              日星期一午夜重新开放
            </li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4067/market_update_ocean_august2024.pdf"
                                                             left="">下载海运更新</a></p>
          <hr>
          <h2>陆运新闻</h2>
          <ul>
            <li>过去 30 天里，合约 TL 费率略有下降，同比下降约 7%，因为它们与现货市场费率的价差继续缩小，而现货市场费率似乎自
              2023 年中期以来一直在触底。
            </li>
            <li>根据 Cass Systems 的数据，所有国内运输方式的货运量同比下降约 1%，但环比增长 3%</li>
          </ul>
          <p class="gt-block" style="text-align: center;">
            <a class="button button_size_lg button_color_secondary"
               href="https://www.craneww.com/site/assets/files/4067/marketupdate_ground_august2024.pdf"
               left="">下载陆运更新</a></p>
          <p style="text-align: center;">&nbsp;</p>
          <blockquote><p class="gt-block" style="text-align: center;">联系您当地的 Crane Worldwide Logistics 代表或
            <strong><a href="/quotation">咨询报价</a>&nbsp;</strong>如果您想讨论即将到来的装运要求。
            我们随时为您提供帮助！</p></blockquote>`
    },
    {
      id: '2',
      time: '2024 年 7 月 23 日',
      image: require("@/assets/images/news/market-banner-02.png"),
      title: '国际货运市场新闻，下载最新的 PDF 更新',
      desc: '我们的物流专家提供的 2024 年 XNUMX 月最新信息 - 空运、海运和陆运更新。',
      detail: ` 
          <p>2024 年 7 月 23 日</p>
          <h1>最新货运市场新闻 - 2024 年 XNUMX 月</h1>
          <p class="gt-block">最新的国际货运市场更新现已提供 PDF 格式下载。如果您对当前市场情况有任何疑问，请随时联系
            Crane Worldwide Logistics 团队的成员。在 Crane Worldwide Logistics，我们拥有遍布全球的物流专家，为您的业务提供支持，</p>
          <ul>
            <li>Crane Worldwide Logistics 的业务遍布全球，提供仓储和配送服务，满足您的国际需求，请查看我们的全球网点</li>
            <li>红狮控制推荐使用 美国运输杂志
              最近指出，长滩港在 2024 年 XNUMX 月创下了有史以来最强劲的业绩。如果您要向西部进口，请查看我们位于奇诺的仓库设施的可用空间
            </li>
            <li>您是否知道 Crane Worldwide Logistics 现已在马来西亚新山开业，了解更多信息
            </li>
            <li>不要忘记，您可以通过您最喜爱的播客播放器或在线收听我们的“Coffee with Crane”播客的所有最新市场动态</li>
          </ul>
          <hr>
          <h2>空运新闻</h2>
          <ul>
            <li>国际运输量同比增长 15.5%，得益于所有地区和主要贸易航线。非洲和亚太地区的航空公司年增长率最高，非洲-亚洲贸易航线的需求同比增长了
              40.6%。
            </li>
            <li>运力方面，全行业可用货运吨公里（ACTK）同比增长6.7%，创下全球月度运力水平新高。</li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4049/marketupdate_air_july2024.pdf"
                                                             left="">下载空运更新</a></p>
          <hr>
          <h2>海运新闻</h2>
          <ul>
            <li>1 月 2 日，新加坡大士港开放了一个泊位，并计划今年秋季再开放两个泊位，因为世界第二繁忙的全球集装箱港口的拥堵情况开始缓解。此次开放加上承运人改道并停靠其他港口作为替代，新加坡的船舶等待时间已从
              3 月底的 1 周以上缩短至 XNUMX-XNUMX 天。&nbsp;
            </li>
            <li>&nbsp;9 月 12 日至 9 日，德国主要港口进行了“警告性罢工”，严重扰乱了运营，导致海运延误和停留时间增加（罢工期间增加了
              XNUMX%）
            </li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4049/market_update_ocean_july_2024.pdf"
                                                             left="">下载海运更新</a></p>
          <hr>
          <h2>陆运新闻</h2>
          <ul>
            <li><p>
              第二季度运力流失放缓……承运商退出数量始终超过市场新增数量。联邦数据显示，第二季度退出该行业的卡车运输企业数量多于进入该行业的企业数量</p>
            </li>
            <li><p>&nbsp;根据美国联邦汽车运输安全管理局的数据，9,000 月份约有 XNUMX 家卡车运输企业退出市场，但 XNUMX 月和
              XNUMX 月退出率有所下降。</p></li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4049/marketupdate_ground_july2024.pdf"
                                                             left="">下载陆运更新</a></p>
          <p style="text-align: center;">&nbsp;</p>
          <blockquote><p class="gt-block" style="text-align: center;">联系您当地的 Crane Worldwide Logistics 代表或直接联系
             如果您想讨论即将到来的装运要求。
            我们随时为您提供帮助！</p></blockquote>
         `
    },
    {
      id: '3',
      time: '2024 年 6 月 19 日',
      image: require("@/assets/images/news/market-banner-03.png"),
      title: '货运市场新闻 | 2024 年 XNUMX 月',
      desc: '',
      detail: `
          <p>2024 年 6 月 19 日</p>
          <h1>最新货运市场新闻</h1>
          <p class="gt-block">最新的国际货运市场更新现已提供 PDF 格式下载。如果您对当前市场情况有任何疑问，请随时联系
            Crane Worldwide Logistics 团队的成员。在 Crane Worldwide Logistics，我们拥有遍布全球的物流专家，为您的业务提供支持，
            </p>
          <ul>
            <li>Crane Worldwide Logistics 的业务遍布全球，提供仓储和配送服务，满足您的国际需求，请查看我们的全球网点
              </li>
            <li>南加州是美国入境货物的核心枢纽，你知道我们有可用的仓库空间吗？更多信息
            </li>
            <li>不要忘记，您可以通过您最喜爱的播客播放器或在线收听我们的“Coffee with Crane”播客的所有最新市场动态</li>
          </ul>
          <hr>
          <h2>空运新闻</h2>
          <ul>
            <li>航空货运业连续五个月实现两位数需求增长，同比增长11.1%。（右图）</li>
            <li>全球国际客运量也增长了
              11.6%，得益于所有地区和主要贸易航线的推动。亚太地区和欧洲的航空公司增长率最高，结束了中东航空公司连续七个月领先地区年度扩张的局面
            </li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4040/marketupdate_air_june2024.pdf"
                                                             left="">下载空运更新</a></p>
          <hr>
          <h2>海运新闻</h2>
          <ul>
            <li>跨太平洋集装箱航运航线抓住旺季需求的早期迹象，提前实施季节性附加费，收费明显高于平时。&nbsp;</li>
            <li>
              &nbsp;本周合同谈判破裂后，跨大西洋贸易的托运人和货运代理人今年秋天可能会在美国东部和墨西哥湾沿岸的港口采取罢工行动。
            </li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4040/market_update_ocean_june2024.pdf"
                                                             left="">下载海运更新</a></p>
          <hr>
          <h2>陆运新闻</h2>
          <ul>
            <li><p>&nbsp;过去 30 天里，合约 TL 汇率环比下跌 1%，同比下跌约 6%，因为它们与现货市场汇率的价差继续缩小。</p>
            </li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4040/marketupdate_ground_june2024.pdf"
                                                             left="">下载陆运更新</a></p>
          <p style="text-align: center;">&nbsp;</p>
          <blockquote><p class="gt-block" style="text-align: center;">联系您当地的 Crane Worldwide Logistics 代表或直接联系
            <strong><a href="/quotation">点击这里</a></strong> 如果您想讨论 2024
            年即将到来的发货要求。我们随时为您提供帮助！</p></blockquote>
        `
    },
    {
      id: '4',
      time: '2024 年 5 月 20 日',
      image: require("@/assets/images/news/market-banner-04.png"),
      title: '国际货运代理市场动态| 2024年XNUMX月',
      desc: '',
      detail: `
          <p>2024 年 5 月 20 日</p>
          <h1>国际货运市场 - 空运、海运和陆运更新&nbsp;</h1>
          <p>最新的货运市场动态现在可以 PDF 格式下载。如果您对当前市场状况有任何疑问，请随时与 Crane Worldwide Logistics
            团队成员联系。&nbsp;</p>
          <p class="gt-block">Crane Worldwide Logistics 专家整理了以下更新内容，让您了解最新的市场信息。我们的全球货运网络可以支持您的国际配送需求。我们提供了我们地点的完整列表
          </p>
          <ul>
            <li>CARM 更新 - 所有进口到加拿大的企业都可以了解 CARM 实施的新日期 <strong><a
                href="/news?type=trade">这里。</a></strong>.&nbsp;
            </li>
            <li>由于最近发生的事件，共同海损运输规则成为新闻焦点 巴尔的摩
              但这是什么？它什么时候发生？
            </li>
            <li>Crane Worldwide Logistics 可在客户需要的地方提供仓库可用性！您可以查看我们的仓库
              <strong>辛辛那提</strong>&nbsp;和
              <strong>哥伦布</strong>
              举个典型的例子，这两个仓库设施都地理位置优越，旨在服务美国国内市场，并有可用空间。&nbsp;
            </li>
            <li>不要忘记，您可以通过您最喜爱的播客播放器或在线收听我们的“Coffee with Crane”播客的所有最新市场动态</li>
          </ul>
          <hr>
          <h2>空运新闻</h2>
          <ul>
            <li>受国际旅客腹舱运力持续扩张的推动，全行业可用货运吨公里（ACTK）（代表全球运力）同比增长 7.3%。</li>
            <li>流量的同比增长明显超过了贸易和生产指标的增长。</li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4022/may_market_update_air_freight.pdf"
                                                             left="">下载空运更新</a></p>
          <hr>
          <h2>海运新闻</h2>
          <ul>
            <li>跨太平洋集装箱承运商正在大幅减少（在某些情况下甚至取消）对无船承运人（NVO）固定费率预订的分配，因为他们专注于以利润更高的即期费率获取货物，而即期费率已飙升超过自四月初以来已增长
              50%。
            </li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4022/may_market_update_ocean_freight-1.pdf"
                                                             left="">下载海运更新</a></p>
          <hr>
          <h2>陆运新闻</h2>
          <ul>
            <li><p>&nbsp;卡车现货市场需求仍然同比下降，并稳定在 4
              周追踪平均值上，渠道评论强调有机需求疲软和库存水平正常化。</p></li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4022/may_market_update_ground_freight.pdf"
                                                             left="">下载陆运更新</a></p>
          <p style="text-align: center;">&nbsp;</p>
          <blockquote><p class="gt-block" style="text-align: center;">联系您当地的 Crane Worldwide Logistics 代表或直接联系
            <strong><a href="/quotation">点击这里</a></strong> 如果您想讨论 2024
            年即将到来的发货要求。我们随时为您提供帮助！</p></blockquote>
         `
    },
    {
      id: '5',
      time: '2024 年 4 月 22 日',
      image: require("@/assets/images/news/market-banner-05.png"),
      title: '2024 年 XNUMX 月 |货运市场动态',
      desc: '',
      detail: `<p>2024 年 4 月 22 日</p>
          <h1>货运市场动态 - 2024 年 XNUMX 月</h1>
          <p>最新的货运市场 PDF 现已可供下载。有关空运、海运和陆运市场的最新信息由我们的物流服务专家整理，涵盖四月份的最新消息。&nbsp;</p>
          <p class="gt-block">随着对全球货运业务和仓库足迹的投资不断增加，克瑞全球物流在客户需要的地方不断发展。与我们自己的
            <a href="/service?type=index">美国国内货运服务</a>，我们可以提供完整的综合物流解决方案，包括
            <a href="/service?type=contract">合同物流</a>
            和货运代理专业知识。</p>
          <ul>
            <li>CARM 更新 - 所有进口到加拿大的企业都可以了解 CARM 实施的新日期 .&nbsp;
            </li>
            <li>由于最近发生的事件，共同海损运输规则成为新闻焦点 巴尔的摩
              但这是什么？它什么时候发生？
            </li>
            <li>MSC Aries，请阅读我们的客户咨询
            </li>
            <li>Crane Worldwide Logistics 可在客户需要的地方提供仓库可用性！您可以查看我们的仓库 辛辛那提&nbsp;和
              哥伦布
              举个典型的例子，这两个仓库设施都地理位置优越，旨在服务美国国内市场，并有可用空间。&nbsp;
            </li>
            <li>不要忘记，您可以通过您最喜爱的播客播放器或在线收听我们的“Coffee with Crane”播客的所有最新市场动态</li>
          </ul>
          <hr>
          <h2>空运新闻</h2>
          <ul>
            <li>&nbsp;从全球来看，国际 CTK 同比大幅增长
              12.4%，所有地区都对这一增长做出了贡献，特别是来自非洲和中东的航空公司引领了年度增长
            </li>
            <li>&nbsp;来自中国的贸易航线是上个月运价上涨的主要推动力。</li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4012/market_update_air_april_2024.pdf"
                                                             left="">下载空运更新</a></p>
          <hr>
          <h2>海运新闻</h2>
          <ul>
            <li>随着旱季结束，巴拿马运河管理局 (ACP) 正在调整其运营以适应当前的气候条件。&nbsp;</li>
            <li>与前两年相比，集装箱承运商在跨太平洋航线上实施的空白航班数量有所减少。&nbsp;</li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4012/market_update_ocean_apr_2024.pdf"
                                                             left="">下载海运更新</a></p>
          <hr>
          <h2>陆运新闻</h2>
          <ul>
            <li><p>去年，经纪商非常积极地降低利率，但现在经纪费率似乎已经触底。</p></li>
          </ul>
          <p class="gt-block" style="text-align: center;"><a class="button button_size_lg button_color_secondary"
                                                             href="https://www.craneww.com/site/assets/files/4012/market_update_ground_apr_2024.pdf"
                                                             left="">下载陆运更新</a></p>
          <p style="text-align: center;">&nbsp;</p>
          <blockquote><p class="gt-block" style="text-align: center;">联系您当地的 Crane Worldwide Logistics 代表或直接联系
            <strong><a href="/quotation">点击这里</a></strong> 如果您想讨论 2024
            年即将到来的发货要求。我们随时为您提供帮助！</p></blockquote>`
    },
  ]
}

export const industryData = {
  list: [
    {
      id: '1',
      time: '2024 年 8 月 23 日',
      image: require("@/assets/images/news/industry-banner-01.jpg"),
      title: '加拿大铁路罢工——您需要了解的信息。',
      desc: '',
      detail: ` <p>2024 年 8 月 23 日</p>
          <h1>更新</h1>
          <p>由于谈判未能达成，加拿大太平洋堪萨斯城铁路公司和加拿大国家铁路公司的工人于周四凌晨 12:01 被停工。不到 24
            小时后，加拿大政府结束了铁路停工，并命令各方进行具有约束力的仲裁。</p>
          <hr>
          <h1>加拿大铁路货运 - 运输中断影响物流运营</h1>
          <p class="gt-block">请参阅以下有关加拿大铁路货运可能中断的当前情况的常见问题解答。根据 <strong><a
              href="https://www.msn.com/en-ae/money/companies/factbox-canadian-rail-stoppage-set-to-squeeze-north-american-industries/ar-AA1pdTcN?ocid=BingNewsSerp">路透社</a>,</strong>&nbsp;“铁路每年运输价值约
            380 亿加元（277 亿美元）的货物和商品，预计铁路停运的影响将波及整个北美。”</p>
          <p class="gt-block"><em>请随时关注并联系 Crane Worldwide Logistics 团队，如果我们可以提供支持，我们在温哥华、卡尔加里和多伦多均设有设施。&nbsp;</em>
          </p>
          <h2>加拿大会发生铁路罢工吗？&nbsp;</h2>
          <p>两家铁路公司——加拿大国家铁路公司 (CN Rail) 和加拿大铁路公司 (CPKC) 目前正在与 9,000
            多名工人就劳工协议进行谈判。协议尚未最终确定。如果谈判未能最终达成协议，潜在的罢工行动或网络关闭可能迫在眉睫。&nbsp;</p>
          <h2>铁路罢工何时开始、持续多久？&nbsp;</h2>
          <p>行动可能于 22 月 XNUMX 日星期四开始，持续到各方通过调解达成解决方案。这可能需要两到三周的时间。&nbsp;</p>
          <h2>这将对加拿大的物流运营产生什么影响？&nbsp;</h2>
          <p>停止铁路货运业务的影响将波及整个加拿大。加拿大的物流系统和北美都将受到明显影响。这是因为两家铁路公司都将货物运往美国和墨西哥。&nbsp;</p>
          <h2>铁路罢工是否会导致供应链中断？会持续多久？&nbsp;</h2>
          <p>不可避免的是，我们可以预计，由于缺乏铁路货运服务，供应链运营将受到严重干扰。 &nbsp;</p>
          <p>虽然卡车运输服务和转运能力可以在短期内提供支持，但铁路运输是加拿大经济的重要组成部分。中断的影响将取决于各方达成解决方案所需的时间。&nbsp;</p>
          <p>轮船公司已经停止接受前往多伦多等加拿大内陆港口的订舱，目前前往蒙特利尔的订舱是一个可行的选择，但这种情况持续的时间越长，预计蒙特利尔可能很快就会不堪重负。&nbsp;</p>
          <p>此时，其他选择可能是哈利法克或美国港口以及通过卡车将货物运往加拿大。&nbsp;</p>
          <h2>Crane Worldwide Logistics 加拿大公司能提供什么帮助？&nbsp;</h2>
          <p class="gt-block">加拿大起重机环球物流公司
            在加拿大各地都有仓库空间，特别是我们在温哥华的仓库可以提供 转运服务
            如果情况升级，这可能会有用。&nbsp;</p>
          <p class="gt-block">Crane Worldwide Logistics 还在整个 美国 并完全拥有 国内运输服务
            用于卡车运输至加拿大。&nbsp;</p>
          <p>请随时联系我们在加拿大的物流专家。&nbsp;</p>
          <div class="card card_size_lg bg_primary-dark">
            <div class="card__body c_white">
              <div class="grid grid_md m_0 align-items_center">
                <div class="grid__item spacing"><h2 class="h3 c_white">与全球物流专家取得联系</h2>
                  <p class="text_size_lg">立即联系我们，索取报价！</p></div>
                <div class="grid__item size_auto spacing text_align_center">
                  <div><a class="button button_size_lg button_color_secondary"
                          href="/quotation">联系我们</a>&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div> `
    },
    {
      id: '2',
      time: '2024 年 7 月 30 日',
      image: require("@/assets/images/news/industry-banner-02.jpg"),
      title: '客户咨询：阿联酋货运市场更新',
      desc: '请留意阿联酋的最新信息。',
      detail: `<p>2024 年 7 月 30 日</p>
          <h1>客户咨询：阿联酋市场动态</h1>
          <p class="gt-block">阿拉伯联合酋长国的货运市场目前正在经历挑战 - 请注意以下事项， <a
              href="/quotation">联系您的 Crane Worldwide 代表</a> 您此时是否需要任何额外的支持。
            &nbsp;</p>
          <h2>海运延误</h2>
          <p>据报道，杰贝阿里港 1 号和 2 号航站楼出现严重延误，影响了进出港货物。多艘船只在正常班次中避开该港口。例如，MSC
            利用阿布扎比港进行转运，导致集装箱被省略。同样，转运至 GCC 港口的货物也遇到了同样的问题。</p>
          <h2>空运限制</h2>
          <p>杰贝阿里港拥堵之际，迪拜的托运人正将紧急货物的运输方式改为空运。因此，空中交通变得拥堵，导致在短时间内获得舱位受到一些限制。请注意，从预订之日起，目前需要
            3-4 天才能收到预订确认书。</p>
          <p>由于假期原因，客运货物优先运输，导致常规货物运输进一步延误。高价货物和易腐货物将优先运输。</p>
          <h2>陆运&nbsp;</h2>
          <p class="gt-block">获得 FASAH 预约也存在一些延迟，导致阿联酋边境司机延误。<br>发往沙特的 OOG
            货物必须在护送或护送下运往达曼港进行扫描。由于达曼港拥堵，通过巴沙边境的替代路线也会出现类似的延误。&nbsp;</p>
          <blockquote><p>请注意阿联酋当前面临的市场挑战，如需任何支持，请联系 Crane Worldwide Logistics，我们随时为您提供帮助！&nbsp;</p>
          </blockquote> `
    },
    {
      id: '3',
      time: '2024 年 7 月 26 日',
      image: require("@/assets/images/news/industry-banner-03.jpg"),
      title: '圣保罗的 3PL 格局',
      desc: '利用 Crane 的圣保罗仓储解决方案增强您在巴西的物流流程 利用 Crane 的圣保罗仓储解决方案增强您在巴西的物流流程',
      detail: `
          <p>2024 年 7 月 26 日</p>
          <h1>巴西的 3PL 物流</h1>
          <p class="gt-block">As 圣保罗
            巩固其作为巴西主要物流枢纽的地位，大都市区在供应链基础设施方面面临显著挑战。在 Crane Worldwide
            Logistics，我们了解这些挑战，并提供量身定制的仓储解决方案，以确保为客户提供高效、安全且经济高效的物流运营。事实上，该地区预计会实现增长，而这种增长意味着战略合作伙伴对于成功至关重要。
          </p>
          <p class="gt-block">根据 <a
              href="https://www.mordorintelligence.com/industry-reports/south-american-freight-and-logistics-market/market-size">魔多情报</a>,
            <em>“南美货运和物流市场规模预计在 231.2 年为 2024 亿美元，预计到 311.7 年将达到 2030 亿美元，预测期内（5.10-2024
              年）的复合年增长率为 2030%。”</em> 以下是我们如何利用全面的物流和强大的仓储解决方案解决圣保罗的关键供应链问题。
          </p>
          <h2>克服基础设施瓶颈</h2>
          <p class="gt-block"><strong>挑战：</strong> 圣保罗广泛的物流基础设施经常出现港口和道路拥堵的情况，导致运输延误和成本增加。
          </p>
          <p class="gt-block"><strong>我们的解决方案：</strong>
            我们位于圣保罗的仓库地理位置优越，与主要海运和机场交通便利，大大缩短了运输时间，提高了整体供应链效率。这一优越的地理位置有助于缓解基础设施瓶颈的影响，确保运营顺畅。
          </p>
          <h2>克服监管障碍</h2>
          <p class="gt-block"><strong>挑战：</strong> 海关法规的复杂性和频繁变化可能会延误货物运输并增加企业的行政负担。
          </p>
          <p class="gt-block"><strong>我们的解决方案：</strong>
            我们提供内部报关服务以及集成的海关和运输系统。这种无缝集成可确保快速合规地清关货物，减少延误和行政麻烦，并为我们的客户提高海关流程的效率。我们经验丰富的团队随时了解最新法规，确保您的货物得到最谨慎和合规的处理。
          </p>
          <h2>通过完整的货物安全解决方案增强安全措施</h2>
          <p class="gt-block"><strong>挑战：</strong> 货物盗窃和破坏的风险很高，对运输和储存过程中货物的安全和完整性构成了重大威胁。
          </p>
          <p class="gt-block"><strong>我们的解决方案： </strong>我们的设施配备最先进的安全系统，包括 24 多个摄像头、7
            个报警点和严格的门禁协议，实现全天候监控。这些先进的安全措施确保为客户的货物提供最高级别的保护，让客户安心无忧，并保护宝贵的资产。
          </p>
          <h2>全面的服务产品</h2>
          <p>在 Crane Worldwide Logistics，我们提供全方位的物流服务，包括托管运输，旨在满足不同的业务需求：</p>
          <ul>
            <li><strong>全程货运代理服务</strong>：我们管理整个物流过程，确保货物运输顺畅、高效。</li>
            <li><strong>国内分布： </strong>我们在巴西境内可靠、及时的配送服务可确保产品及时到达目的地。</li>
            <li><strong>专业服务</strong>：我们提供独特的服务，包括在仓库内将客户设立为法人实体以促进发票交易，以及筛选、测试、包装和交叉转运服务。
            </li>
          </ul>
          <h2>灵活且可定制的基础设施</h2>
          <p>
            我们的仓库基础设施设计灵活且可定制，能够根据客户的特定需求构建额外的货架位置并配置存储解决方案。这种适应性使我们能够满足客户的增长和不断变化的需求，确保他们的物流运营保持无缝和高效。</p>
          <h2>激进的定价</h2>
          <p>
            通过拥有和运营我们自己的设施以及我们自己的结构和员工，我们提供极具竞争力的价格。这种成本效益使我们能够提供极具竞争力的价格，使我们的客户能够有效地管理他们的物流预算，同时享受优质服务。</p>
          <h2>可持续实践</h2>
          <p>
            我们的仓库运营反映了行业趋势，采用了减少碳排放、水再利用和使用可再生能源等可持续做法。这些举措支持环境目标，并与优先考虑可持续发展的客户产生共鸣，表明我们致力于负责任和环保的物流解决方案。</p>
          <h2>利用 Crane Worldwide 的圣保罗物流仓储解决方案增强您的巴西供应链</h2>
          <p>在 Crane Worldwide
            Logistics，我们致力于创新和卓越，提供灵活、高效和可持续的供应链解决方案。我们的圣保罗仓库体现了我们致力于满足物流行业最高标准的决心。对于潜在客户和行业合作伙伴，我们提供专业知识、最先进的基础设施和尖端服务的强大组合。我们的战略定位和全面的产品使我们成为希望在巴西市场扩张的企业的首选合作伙伴。</p>
          <blockquote><p class="gt-block">如需进一步了解行业趋势和我们的服务， <strong><a
              href="/quotation">与巴西的 Crane Worldwide Logistics 专家联系</a>.</strong>
            &nbsp;让我们的团队在不断发展的圣保罗市场推动您的业务向前发展。</p></blockquote>
          `
    },
    {
      id: '4',
      time: '2024 年 7 月 25 日',
      image: require("@/assets/images/news/industry-banner-03.jpg"),
      title: '转运：提供运输、仓储和最后一英里交付支持',
      desc: '您是否知道转运解决方案是缓解繁忙港口进出口限制的最佳方式？立即了解 Crane Worldwide Logistics 的交叉转运和转运选项',
      detail: ` 
          <p>2024 年 7 月 25 日</p>
          <h1>为现代托运人讲解转运基础知识</h1>
          <p class="gt-block">物流格局在不断发展，尤其是对可扩展运输解决方案的需求不断增加。根据 <a
              href="https://www.ceicdata.com/en/indicator/united-states/total-imports-growth">CEIC
            美国进口总额增长数据</a>, “5.7 年 2024 月总进口同比增长 3.7%，而上个月同比下降
            XNUMX%。”这一增长凸显了转运等先进物流解决方案的必要性，以确保及时且经济高效地交付货物。进口活动的激增需要增加转运专业知识来管理港口和核心坡道附近的频繁活动，确保高效处理和分配货物。托运人需要了解转运的真正含义、其好处和风险，以及正确利用它的几个步骤。&nbsp;
          </p>
          <h2>什么是转载？</h2>
          <p class="gt-block">货物转运发生在货物交付时，是从一种运输方式转移到另一种运输方式的过程。例如， 海运 到达后，集装箱在港口被提走并运往当地仓库，集装箱内物品被转运（卸载和装载）到一辆或多辆卡车上，最后运送到配送中心。每次转运都代表着又一次出错的机会；然而，适当的护理和处理以及周密的计划可以降低转运过程中的这种风险。
          </p>
          <p>
            一般来说，当一种运输方式不能用于货物的全部交付，而集装箱内的物品需要用卡车分配到多个地点进行最终交付时，就会发生转运。</p>
          <p class="gt-block">在大多数情况下，出于运输要求，转运过程通常在仓库进行，即 转运仓库设施
            使用适合货物处理的装载设备。</p>
          <p class="gt-block">注意：转运一词经常与“交叉转运”一词互换。这取决于货物在运往最终目的地之前是否在仓库的码头上存储、分类或整合。交叉转运或转运服务都可以提高您的上市速度，尤其是在 南加州的
              3PL 物流仓储.</p>
          <p>
            当货物运往多个地点时，将收取“转运费”，其中包括在仓库拆箱、将货物码垛并将其装入卡车以进行最终交付的人工费用。</p>
          <p>物流中的转运对于无缝供应链转运操作至关重要，并可为您的供应链战略提供额外的好处，包括：</p>
          <ul>
            <li>通过优化运输路线降低运输成本。</li>
            <li>最大限度地减少存储延迟并加快交付流程。</li>
            <li>增加运输方式和选择的灵活性。</li>
            <li>加强库存管理，降低仓储成本。</li>
            <li>通过更好的资源配置来提高供应链效率。</li>
            <li>减轻与长途运输相关的风险。</li>
            <li>通过提供通往多个目的地的便利来扩大市场范围。<br>&nbsp;</li>
          </ul>
          <h2>您的货物可能需要转载的原因有多种</h2>
          <p>
            当货物抵达拥堵的港口并需要快速运输以避免仓储费时，通常会使用转运。例如，一批电子产品可能会从集装箱船上卸下，转移到仓库进行分类，然后装上卡车，快速运送到各个零售点。</p>
          <ul>
            <li>如果您的货物通过卡车从目的地出发很远，可能需要转运以避免昂贵的底盘和滞期费，将货物从一种运输方式转移到另一种运输方式以节省成本。
              多式联运可能是您的选择。
            </li>
            <li>我们为客户提供 CFS（集装箱货运服务），以帮助他们加快生产所需的材料。
              集装箱上的其他材料可以通过延期服务运输。
            </li>
            <li>一些 SSL 要求他们的容器不能比到达港口更远。</li>
          </ul>
          <p><a href="/site/assets/files/3162/copy_of_untitled.png"><img alt="转运过程" class="align_center"
                                                                         src="https://www.craneww.com/site/assets/files/3162/copy_of_untitled.png"
                                                                         width="1080"></a></p>
          <h2>转运之旅</h2>
          <p>
            结合多种运输方式进行转运可以为托运人节省成本、提高灵活性，并有机会扩大业务和市场范围，将货物运送到需要的地方！这通常需要以下内容：</p>
          <ul>
            <li>货物由卡车从其原产地提取到转运设施。</li>
            <li>从那里，我们将货物装载到轨道车上。</li>
            <li>然后，我们用轨道车将货物运送到目的地附近的转运设施。</li>
            <li>接下来，我们从轨道车上卸下货物。</li>
            <li>最后，我们用卡车将货物运送到目的地。</li>
          </ul>
          <h2>在美国转运</h2>
          <p>在美国，当船舶满载货物的集装箱靠港时，转运是物流提供商经常进行的一项活动。它促进了货物运输到全国不同州和地点。&nbsp;</p>
          <p class="gt-block">通过我们的转运设施提供替代路线，为客户节省成本，Crane Worldwide Logistics 在许多地点拥有转运仓库能力，包括
            萨凡纳, 休斯顿, 纽瓦克,
            西雅图及&nbsp;长滩.</p>
          <h2>通过 Crane Worldwide Logistics 获得转运解决方案</h2>
          <p class="gt-block">
            港口拥堵日益严重地增加了我们客户的美国供应链延误。通过投资我们的转运服务，我们的目标是提供尽可能最好的服务。最终，我们努力保持供应链的运转并确保您的产品及时到达最终目的地。您是否有最有效的货运路线？您是否需要经济高效的美国转运服务？&nbsp;<br>&nbsp;
          </p>
          <center>
            <blockquote><p class="gt-block"><strong>你准备好开始了吗？</strong></p>
              <p class="gt-block">详细了解我们的专家如何为您工作， <strong>联系我们</strong>.</p></blockquote>
          </center>`,
    },
    {
      id: '5',
      time: '2024 年 7 月 18 日',
      image: require("@/assets/images/news/industry-banner-03.jpg"),
      title: '2025年农历新年',
      desc: '现在考虑您的货运可能遇到的中断还为时不晚，在本文中，我们将探讨 2025 年农历新年及其对您的物流运营的影响。',
      detail: `<p>2024 年 7 月 18 日</p>
          <h1><strong>2025 年农历新年 - 蛇年</strong></h1>
          <p>本文讨论了 2025
            年农历新年期间办公室和工厂关闭的准备工作。提前规划这些关闭事宜可以帮助您有效地管理全球供应链的运输计划。</p>
          <h2>什么是农历新年（通常称为农历新年）？</h2>
          <p>农历新年，又称春节，是庆祝中国传统农历新年的开始。亚洲许多国家都会庆祝农历新年，不仅中国，新加坡、香港等地也庆祝农历新年。例如，在越南，这个节日被称为
            Tet，全名为“Tet Nguyen Dan”。</p>
          <h2>2025 年农历新年是什么时候？</h2>
          <p class="gt-block">随着元宵节的结束，农历新年的日期以中国农历 2025 年为准，目前已宣布的日期是 2025 年农历新年将于
            29 年 2025 月 XNUMX 日星期三开始，而公众假期将从前一天开始，这比在 2024.
          </p>
          <h2>2025 年农历新年假期有多久？</h2>
          <p>各个国家的农历新年假期因不同的庆祝活动而有所不同。中华人民共和国的公共假期通常持续整整七天，提供一周的假期。一般来说，庆祝活动从除夕（也称为春节除夕）开始，一直持续到正月初六。实际上，这意味着从
            28 月 3 日星期二开始，劳动者将享受国庆假期，以庆祝晚间的庆祝活动，直到 2025 年 XNUMX 月 XNUMX 日。</p>
          <p>往年，一些公司允许员工额外休假，延长假期，通常在核心地点仅保留精干人员。工厂和货运公司也会在公众假期正式开始前提前释放工人和司机。这通常在假期前一周就开始了。在此期间，货运资源变得有限，因此运输成本会上升。&nbsp;
            &nbsp; &nbsp;</p>
          <h2>2025 年的农历新年假期是哪一天？</h2>
          <p><img alt="2025 年农历新年的蛇像" class="align_right"
                  src="https://www.craneww.com/site/assets/files/4058/gettyimages-166055042.320x0-is.jpg" width="320">2025
            年中国农历新年公共假期从 28 年 3 月 2025 日开始，一直持续到 XNUMX 年 XNUMX 月 XNUMX 日。有时，工人可能有机会在假期期间休息更长时间。
          </p>
          <p>假期日期根据公司不同而有所差异，因此最好提前与您的核心供应商核实他们预计的假期开始时间，并提前准备好您的订单。&nbsp;</p>
          <p>请记住，农历新年假期还会影响越南、马来西亚和泰国等亚洲许多地区的制造业中心。&nbsp;</p>
          <h2>2025年农历新年假期将对物流和运输服务产生什么影响？</h2>
          <p>春节旅游高峰，又称春运，出现在农历新年假期，因为这是家人团聚和庆祝的时节。许多人会回到家乡探望父母和亲戚。在很多情况下，您可能会收到在此期间停止运营的生产基地发来的办公室关闭通知。&nbsp;</p>
          <p>
            农历新年来临之际，运输和物流成为航运业的高峰期，因为货物运输需求增加。一般来说，订单会提前下达，以弥补假期的影响，这确实给国内外运输和物流框架带来了压力，以满足运输时间。</p>
          <h2>2025 年农历新年：物流行业摘要</h2>
          <p>2025
            年农历新年期间，物流行业可能会出现中断，尤其是在中国大陆，制造工厂会关闭，以便员工与亲人一起庆祝。提前规划对于优化节日期间的空运、海运和整体物流运营至关重要。请记住，高峰时段的需求增加会显著影响运费。假期前和假期期间的停工也会导致货物运输延误。</p>
          <p>
            由于节日期间现场工作的员工减少，生产时间可能会延长。重要的是要考虑到更长的生产时间和收到报价的延迟。生产通常会放缓，订单可能会积压，工厂会优先考虑他们的老客户和重要客户。预计在公众假期前后一周，卡车运输和短途运输的运力有限，成本也会上升。远洋运输公司将调整时间表，取消航班，航空公司可能会取消航班。建议提前计划并预测节日期间的这些挑战。</p>
          <p>我们建议您在供应链规划中尽早通知我们您的货运预订要求，以避免任何中断，并提前计划收货。由于农历新年比往年早，并且更接近
            2025 年的圣诞节，请尽早联系您当地的 Crane Worldwide 代表，以确保我们能为您提供最佳解决方案来应对这一繁忙时期。&nbsp;</p>
          <p class="gt-block">我们的客户支持人员现在可以为您服务，需要为您即将发货的货物提供支持吗？ <strong><a
              href="/quotation">请求报价！</a></strong></p>
          <h2>Crane Worldwide Logistics 在亚太地区</h2>
          <p class="gt-block"><strong>你知道吗...？</strong> Crane Worldwide 在全球 130 个国家设有 30
            个办事处，能够提供全方位的国际物流服务。</p>
          <p class="gt-block">在亚洲，我们在各地拥有强大的影响力 中國 以及 Malaysia, Singapore, Korea, 日本, Thailand, 越南&nbsp;和 Indonesia. 我们也位于 澳大利亚。为圣诞节和农历新年期间的繁忙时期开始规划永远不会太早，我们的物流专家将通过尽早开始对话为您提供指导和预见，帮助您克服任何潜在的干扰。
          </p>
          <p class="gt-block">您可以查看我们的全球目录 查看
            Crane 全球各地的完整位置列表。由于地缘政治复杂性导致全球贸易中断加剧，我们期待与您讨论您的要求并与您合作提供物流解决方案
            <strong>提前。&nbsp;</strong></p>
          <p>请随时联系亚洲的货运报价/物流支持。</p>
        `,
    }
  ]
}


export const tradeData = {
  list: [
    {
      id: '1',
      time: '2024 年 8 月 19 日',
      title: '电子出口信息禁止使用模糊的货物描述',
      desc: '最近，美国海关边境保护局 (CBP) 在全国范围内实施了货物信息传递系统，以便与入境申报人沟通货物描述不明确的不合规货物。',
      detail: ` <h1>所需货物的精确描述</h1>
          <p>最近，美国海关边境保护局 (CBP) 在全国范围内实施了货物信息传递，以便与报关员沟通货物描述不明确的违规情况。承运人和其他选择向
            CBP 提交电子货物信息的各方必须提供货物的准确描述。&nbsp;</p>
          <p>不遵守规定最终可能导致罚款、检查次数增加和货物延误。对于提交不准确或虚假信息的行为，美国海关及边境保卫局可能会对每次违规行为处以
            16,971 美元的违约金。&nbsp;</p>
          <p class="gt-block"><strong><a
              href="https://www.ecfr.gov/current/title-15/part-30/section-30.6#p-30.6(a)(13)">15 美国联邦法规
            30.6(a)(13)</a>,</strong> 商品描述。请用英文详细报告所装运货物的描述，以便核实附表 B 或 HTS 编号。&nbsp;<br>从协调关税表或附表
            B 自动填充的商品描述不再可用于描述货物。&nbsp;</p>
          <h2>模糊的货物描述包括：&nbsp;</h2>
          <ul>
            <li>礼物&nbsp;</li>
            <li>日用品&nbsp;</li>
            <li>配件&nbsp;</li>
            <li>零件&nbsp;</li>
            <li>合并（仅在主帐单级别可接受）&nbsp;</li>
          </ul>
          <h2>这对您来说意味着什么？&nbsp;</h2>
          <p>请在托运人指示函 (SLI) 或商业发票上提供需要在 EEI 上备案的商品的精确描述。</p>`
    },
    {
      id: '2',
      time: '2024 年 5 月 31 日',
      title: '墨西哥关税上调',
      desc: '墨西哥政府下令对超过 5 种商品的关税上调 50% 至 544%。',
      detail: `<h1>墨西哥政府下令对超过 5 种商品的关税上调 50% 至 544%。</h1><p>22年2024月23日，《修改一般进出口税法关税的法令》在联邦官方公报上公布。本临时措施的施行期限为2024年23月2026日至XNUMX年XNUMX月XNUMX日。</p><h2>该法令的目的</h2><ul><li>为国内工业部门提供公平的市场条件</li><li>重申行业促进计划 (PROSEC) 的关税优惠，该计划促进电气、电子、汽车和汽车零部件行业的副标题。</li></ul><h2>受该法令影响的产品</h2><table border="1" cellpadding="1" cellspacing="1" style="width:800px;"><tbody><tr><td>铁件</td><td>木材</td><td>玻璃及其制造商</td></tr><tr><td>铝材料</td><td>塑料及其制造商</td><td>电气(材料)</td></tr><tr><td>纺织品</td><td>化学产品</td><td>交通运输设备制造业</td></tr><tr><td>服装</td><td>纸和纸板</td><td>乐器</td></tr><tr><td>鞋类</td><td>陶瓷制品</td><td>家具</td></tr></tbody></table><p class="gt-block">有关受此变更影响的 HS 代码的完整列表以及阅读完整的法令，请访问此链接： <strong><a href="https://www.dof.gob.mx/nota_detalle.php?codigo=5724207&amp;fecha=22/04/2024#gsc.tab=0">联合会官方公报</a></strong></p><h2>该法令对您意味着什么？</h2><p>墨西哥进口商应仔细检查受影响产品清单，并了解利用特殊外贸促进计划的机会。</p><blockquote><p class="gt-block">联系克瑞全球贸易合规团队： <a href="mailto:globaltradecompliance@craneww.com">globaltradecompliance@craneww.com</a> 如果您对国际贸易法规有任何疑问。</p></blockquote>`,
    },
    {
      id: '3',
      time: '2024 年 5 月 28 日',
      title: '第 232 条钢铁和铝关税排除流程的修订',
      desc: '了解 Crane Worldwide 国际贸易咨询团队的更多信息。',
      detail: `<h1>客户咨询：第 232 条钢铁和铝关税排除流程的修订</h1><p>17 年 2024 月 232 日，美国商务部工业与安全局 (BIS) 发布了最终规则，修订了针对美国钢铁和铝进口的 XNUMX 条款排除程序。</p><p class="gt-block">这些修改有效 <strong>2024 年 7 月 01 日</strong>，并打算改进可以请求排除钢铁和铝关税的结构，以保证更加公平和明显的程序。</p><p>此次修订删除了以下 6 项一般批准排除 (GAE) – 6 项针对钢，XNUMX 项针对铝：</p><table border="1" cellpadding="1" cellspacing="1" style="width:800px;"><thead><tr><th scope="col">用于钢铁的 GAE</th><th scope="col">用于铝的 GAE</th></tr></thead><tbody><tr><td><ul><li>GAE.24.S：7211.29.0060</li><li>GAE.43.S：7209.90.0000</li><li>GAE.46.S：7216.33.0090</li><li>GAE.84.S：7209.27.0000</li><li>GAE.90.S：7216.10.0010</li><li>GAE.93.S：7208.38.0015</li></ul></td><td><ul><li>GAE.1.A：7609.00.0000</li><li>GAE.4.A：7604.21.0010</li><li>GAE.5.A：7604.29.1010</li><li>GAE.9.A：7601.20.9080</li><li>GAE.10.A：7607.11.6010</li><li>GAE.13.A：7604.29.5090</li></ul></td></tr></tbody></table><p>取消这些 GAE 可支持第 232 条关税的有效性，从而支持美国的国家安全。</p><p>GAE 最初建立的目的是简化针对在美国境内生产的数量或质量始终未达到合理足够数量或质量的产品或商务部长基于特定国家安全考虑而认为应排除在外的产品的排除程序。</p><p>上述 12 个 GAE 中列出的钢铁和铝制品将恢复先前根据总统公告 9704 和 9705 以及后来的公告规定的关税和待遇。</p><p>必须指出的是，如果未来对这些 GAE 的分析发生变化，BIS 可能会按照以下规则重新发布全部或部分 GAE。</p><p>根据总统公告 9704 和 9705：所有铝制品进口应额外征收 10% 的从价税或从价税、税率，钢制品进口应额外征收 25% 从价税率关税——与进入或从仓库取出供消费的货物有关的条款。</p><p>这些关税税率是对适用于此类进口铝或钢制品的任何其他关税、费用、征收和收费的补充，适用于从加拿大和墨西哥以外的所有国家进口的铝和钢制品。</p><h2>这对你意味着什么？</h2><p>请美国进口商了解情况，尽早做好应对变化的准备。</p><blockquote><p class="gt-block">如有任何疑问，请联系 Crane Worldwide 的全球贸易合规团队： <a href="mailto:Globaltradecompliance@craneww.com">Globaltradecompliance@craneww.com</a></p></blockquote>`,
    },
    {
      id: '4',
      time: '2024 年 5 月 14 日',
      title: '客户咨询：拜登总统宣布对中国征收新关税',
      desc: '拜登总统 14 月 XNUMX 日宣布关于新的中国关税的最新贸易咨询',
      detail: `<h1>美国总统拜登宣布对中国电动汽车、太阳能、芯片等征收新关税</h1><p class="gt-block">14 年 2024 月 XNUMX 日，拜登总统 <a href="https://www.whitehouse.gov/briefing-room/statements-releases/2024/05/14/fact-sheet-president-biden-takes-action-to-protect-american-workers-and-businesses-from-chinas-unfair-trade-practices/">宣布新关税</a> 价值18亿美元的中国进口产品。关税目标包括：电动汽车（EV）、太阳能电池、钢铁、铝、半导体、先进电池、关键矿物、太阳能和医疗产品。</p><table align="left" border="1" cellpadding="1" cellspacing="1" style="width:800px;"><thead><tr><th scope="col">产品</th><th scope="col">关税增加百分比及时间安排</th></tr></thead><tbody><tr><td>电池零部件（非锂离子电池&nbsp;</td><td>25 年增长 2024%&nbsp;</td></tr><tr><td>电动汽车（EV）&nbsp;</td><td>100 年增长 2024%</td></tr><tr><td>口罩&nbsp;</td><td>25 年增长 2024%</td></tr><tr><td>锂离子电动汽车电池</td><td>25 年增长 2024%</td></tr><tr><td>非电动汽车锂离子电池</td><td>25 年增长 2026%</td></tr><tr><td>医用手套</td><td>25 年增长 2026%</td></tr><tr><td>天然石墨</td><td>25 年增长 2026%</td></tr><tr><td>其他重要矿物</td><td>25 年增长 2024%</td></tr><tr><td>永磁体</td><td>25 年增长 2026%</td></tr><tr><td>半导体</td><td>50 年增长 2025%</td></tr><tr><td>船岸起重机</td><td>25 年增长 2024%</td></tr><tr><td>太阳能电池（无论是否组装成模块）</td><td>50 年增长 2024%</td></tr><tr><td>钢铁及铝制品</td><td>25 年增长 2024%</td></tr><tr><td>注射器和针头</td><td>50 年增长 2024%</td></tr></tbody></table><p class="gt-block"><br><br><br>2025 年和 2026 年将对半导体以及 <a href="/service?type=battery">锂离子电池</a> 不用于电动汽车、石墨和永磁体以及橡胶医疗和手术手套。</p><h2>这对出口商/进口商意味着什么？</h2><p>我们。请进口商/出口商了解情况，并尽早为即将到来的变化做好准备。</p><blockquote><p class="gt-block">如果您对上述内容有任何疑问，请随时联系我们的贸易咨询团队，或联系我们 <a href="mailto:cwtsconsulting@craneww.com"><strong>这里。</strong></a></p></blockquote>`,
    },
    {
      id: '5',
      time: '2024 年 4 月 26 日',
      title: 'OFAC 委内瑞拉新通用许可证 44A',
      desc: '44 号通用许可证授权与委内瑞拉石油或天然气行业运营相关的交易，该许可证于 12 年 01 月 18 日中午 2024:XNUMX 到期。',
      detail: `<h1>OFAC 委内瑞拉新通用许可证 44A</h1><p class="gt-block">美国财政部外国资产控制办公室 (OFAC) 已发布&nbsp;<a href="https://ofac.treasury.gov/media/932826/download?inline">通用许可证号 44A</a> 授权自 17 年 2024 月 44 日起逐步结束与委内瑞拉石油和天然气行业运营相关的交易。授权与委内瑞拉石油和天然气行业运营相关的交易的 12 号通用许可证已于 01 年 18 月 2024 日凌晨 XNUMX:XNUMX 到期。&nbsp;</p><p class="gt-block"><strong>一般牌照 44A </strong>– 授权以下非详尽交易清单在东部夏令时间 12 年 01 月 31 日中午 2024:XNUMX 之前完成：&nbsp;</p><ol><li>委内瑞拉石油或天然气的生产、开采、销售和出口，以及提供相关商品和服务&nbsp;</li><li>支付与委内瑞拉石油或天然气部门运营相关的商品或服务的发票&nbsp;</li><li>出于偿还债务的目的，从委内瑞拉向委内瑞拉政府债权人交付石油和天然气，包括委内瑞拉石油公司 (PdVSA) 直接或间接拥有 50% 或以上权益的实体的债权人。&nbsp;</li></ol><p class="gt-block">此外，OFAC 建议进入之前根据通用许可证 44 授权的新业务不应被视为逐步结束活动。 OFAC 发布了新的 <a href="https://ofac.treasury.gov/media/932821/download?inline">常见问题</a> 与通用许可证 44A 相关以提供澄清。&nbsp;</p><p class="gt-block">此外，请访问委内瑞拉制裁链接，获取更全面的委内瑞拉制裁常见问题解答列表：&nbsp;<a href="https://ofac.treasury.gov/faqs/topic/1581">外国资产控制办公室 (treasury.gov)</a></p><h2>这对您来说意味着什么？&nbsp;</h2><p>请熟悉新的通用许可 44A 条款。</p>`,
    },
    {
      id: '6',
      time: '2024 年 4 月 22 日',
      title: '客户咨询：加拿大评估和收入管理 (CARM) - 更新',
      desc: '加拿大边境服务局 (CBSA) 评估和收入管理 (CARM) 数字计划正在改变 CBSA 对进口到加拿大的商品评估和征收关税的方式。',
      detail: `<h1>CARM更新</h1><p>加拿大边境服务局 (CBSA) 周五下午通报了其启动 CBSA 评估和收入管理 (CARM) 计划的最新情况。贸易链合作伙伴的启动日期被重新安排为 2024 年 2024 月，以适应加拿大公共服务联盟投票赞成时对该机构运营可能产生的影响。将面向贸易链合作伙伴的 CARM 启动日期推迟至 XNUMX 年 XNUMX 月，可确保贸易伙伴获得 CBSA 的全力支持。</p><hr><p>加拿大边境服务局 (CBSA) 评估和收入管理 (CARM) 数字计划正在改变 CBSA 对进口到加拿大的商品评估和征收关税的方式。&nbsp;</p><p class="gt-block"><strong>13 年 2024 月 XNUMX 日</strong>，CARM 将成为进口商和其他贸易链合作伙伴用于支付关税和税款的官方记录系统。 CARM 第 2 版是 CBSA 努力实现海关和贸易流程现代化和简化的一个重要里程碑，旨在提高加拿大货物进口的效率和安全性。</p><h3>CARM Release 2 实施需要记住的要点：</h3><p class="gt-block">1. <strong>实施日期</strong>：CARM 第 2 版计划于 13 年 2024 月 XNUMX 日发布，届时所有进口商都必须遵守新系统。</p><p class="gt-block">2. 注册 <a href="https://ccp-pcc.cbsa-asfc.cloud-nuage.canada.ca/en/auth/login"><strong>CARM 客户端</strong></a>：如果您尚未注册，请确保您已注册 CARM 客户端门户帐户。您将需要此帐户来访问新系统并完成与进口相关的交易。企业必须在 CARM 第 2 版发布日期之前在 CARM 门户上注册，以避免服务中断。请访问 CBSA 网站，了解注册的详细说明。&nbsp;</p><p class="gt-block">3. <strong>权力下放</strong>：如果您还没有这样做，请确保您已向组织内需要访问 CARM 门户的任何员工以及需要继续提供报关或贸易服务的报关行和其他服务提供商分配授权。</p><p class="gt-block">4. <strong>教育资源</strong>：CBSA 提供了丰富的教育资源，包括网络研讨会、指南和常见问题解答，以帮助您了解这些变化以及它们将如何影响您的进口流程。这些资源可在 CBSA 网站上获取 <a href="https://www.cbsa-asfc.gc.ca/services/carm-gcra/menu-eng.html">https://www.cbsa-asfc.gc.ca/services/carm-gcra/menu-eng.html</a></p><p class="gt-block">5. <strong>测试</strong>：建议测试 CARM Release 2 功能以确保平稳过渡。您可以在实施日期之前参与CARM Release 2沙箱环境来练习使用系统。</p><p class="gt-block">6.<strong>与服务提供商合作</strong>：如果您与报关行或其他服务提供商合作，请确保他们消息灵通并为过渡到 CARM 第 2 版做好准备。与您的服务提供商的协作对于无缝过渡至关重要。</p><p class="gt-block">7.<strong>最新资讯</strong>：继续关注 CBSA 的更新，包括实施日期之前的任何变更或附加信息。</p><h3>卡姆来了。不要拖延。今天注册。</h3><p>确保您的企业在 13 年 2024 月 XNUMX 日做好准备非常简单：</p><ul><li><strong>海关保税仓库持牌人</strong>&nbsp;需要提交仓库库存。在 29 年 2024 月 XNUMX 日之前确认您将如何提交此信息。&nbsp;<a href="https://www.cbsa-asfc.gc.ca/services/carm-gcra/start-passer-eng.html#s5">为海关保税仓库持牌人提供更多信息</a></li><li><strong>进口商</strong>&nbsp;现在应该在 CARM 中注册他们的企业并将权力委托给他们的报关行。&nbsp;<a href="https://www.cbsa-asfc.gc.ca/services/carm-gcra/start-passer-eng.html#s1">为进口商提供更多信息</a></li><li><strong>报关行</strong>&nbsp;应继续与进口商合作，确保他们已注册并已授予必要的访问权限。&nbsp;<a href="https://www.cbsa-asfc.gc.ca/services/carm-gcra/start-passer-eng.html#s2">针对报关行的更多信息</a></li><li><strong>贸易顾问、金融安全提供商</strong>或&nbsp;<strong>其他贸易链合作伙伴</strong>&nbsp;可以找出他们可以做什么&nbsp;<a href="https://www.cbsa-asfc.gc.ca/services/carm-gcra/start-passer-eng.html">开始使用 CARM</a>.</li></ul><h3>这对你来说意味着什么？</h3><p class="gt-block">预先登记于 <strong><a href="https://ccp-pcc.cbsa-asfc.cloud-nuage.canada.ca/en/auth/login">CARM 客户端</a></strong>，进行测试并向您的员工和/或您的经纪人授予访问权限。</p><blockquote><p class="gt-block">联系克瑞的加拿大海关团队： <a href="mailto:canada.customs@craneww.com">canada.customs@craneww.com</a>&nbsp;如果需要任何帮助和支持！</p></blockquote>`,
    },
    {
      id: '7',
      time: '2024 年 4 月 14 日',
      title: '客户咨询：对尼加拉瓜的出口限制',
      desc: '新规则限制对尼加拉瓜的多种出口',
      detail: `<h1>美国商务部和国务院于 14 年 2024 月 XNUMX 日宣布限制对尼加拉瓜的一系列出口的规则。</h1><p class="gt-block">工业和安全局 (BIS) 发布了一项最终规则，要求该国根据《出口管理条例》(EAR)、15 CFR 第 730 和 774 部分采取更严格的措施。《国际武器贸易条例》(ITAR) 发布了一项规则：通过将尼加拉瓜添加到§中，进行监管改革，反映美国政府反对与尼加拉瓜进行武器贸易<a href="https://www.ecfr.gov/current/title-22/part-126/section-126.1#p-126.1(p)">126.1（页）</a> ITAR，22 CFR 第 120 至 130 部分。&nbsp;</p><h2>新规则带来的变化</h2><p>美国商务部 (DOC) 的 BIS 正在对 EAR 进行四组变更，这将使尼加拉瓜受到更严格的出口、再出口和转让（国内）控制，涉及受 EAR 约束的物品。</p><ol><li>BIS 将尼加拉瓜添加到国家组 D:5（美国武器禁运国家）中。 1 至 EAR 第 740 部分。</li><li>国际清算银行正在将尼加拉瓜从 B 国家组转移到 D 国家组，这是一组引起国家安全担忧的国家。</li><li>尼加拉瓜被添加到受§中规定的严格许可政策约束的国家中<a href="https://www.ecfr.gov/current/title-15/part-742/section-742.4#p-742.4(b)(7)(i)">742.4</a> （国家安全控制）与转移到确定的军事最终用途和最终用户的风险有关。</li><li>该规则使该国受到§中的军事最终用途和军事最终用户限制<a href="https://www.ecfr.gov/current/title-15/section-744.21">744.21</a>。这将影响到尼加拉瓜的 EAR 600 系列监管设备。</li></ol><p>美国国务院 (DOS) 正在修订《ITAR》，将尼加拉瓜列入美国政策拒绝为其国防服务和国防物品进出口发放许可证或其他批准的国家名单中。</p><ol><li>但对于仅用于人道主义援助（包括自然灾害救援）的非致命军事装备，可以根据具体情况颁发许可证或其他批准。</li><li>此外，根据 ITAR §<a href="https://www.ecfr.gov/current/title-22/section-129.7">129.7</a>，无经纪人，如 ITAR § 中所述<a href="https://www.ecfr.gov/current/title-22/section-129.2">129.2</a>，可以在未经国防贸易管制局批准的情况下从事或建议从事受 ITAR 约束的涉及尼加拉瓜的经纪活动。</li></ol><h3>这对你来说意味着什么？</h3><ul><li>运往尼加拉瓜的货物可能受到出口许可证管制。</li><li>如果您有出口货物前往尼加拉瓜，出口商应了解这一新的出口要求。</li></ul>`,
    },
    {
      id: '8',
      time: '2024 年 3 月 30 日',
      title: '碳边境调整机制（CBAM）——欧盟进口',
      desc: '欧盟委员会于13年2023月31日首次通过的碳边界调整机制（CBAM）将在过渡阶段生效，第一个报告期定为2024年XNUMX月XNUMX日。',
      detail: `<h1>碳边界调整机制（CBAM）</h1><p>欧盟委员会于13年2023月31日首次通过的碳边界调整机制（CBAM）将在过渡阶段生效，第一个报告期定为2024年XNUMX月XNUMX日。&nbsp;</p><h2>谁会受到 CBAM 的影响？</h2><p>向欧盟 (EU) 进口商品的企业，其生产会产生大量碳泄漏。当高碳排放生产转移到不太注重控制碳排放的国家时，就会发生碳泄漏。水泥、铁、钢、铝、化肥、电力和碳氢化合物商品的进口商将受到影响。</p><h2>这将如何影响交易者？</h2><p>在1年2023月31日至2025年XNUMX月XNUMX日的过渡阶段，申报进口商或提交进口报关单的报关人有义务每季度提交CBAM报告。报告应包含报告期内范围内所有商品的以下信息：</p><ul><li>各类货物的总数量；</li><li>总嵌入排放量；</li><li>间接排放总量；</li><li>原产国针对进口货物中的内含排放量应缴纳的碳价，考虑到任何可用的回扣或其他形式的补偿。</li></ul><p>CBAM 报告是使用 CBAM 过渡登记处提交的，该登记处将从 1 年 2023 月 XNUMX 日起部署供欧盟经济运营商使用。</p><p>如果报关行以间接代表的身份行事，并且进口商未在欧盟境内设立，则报关行有义务进行 CBAM 备案，而直接代表或欧盟境内的情况则不然。进口商在欧盟境内设立的情况。</p><p>从过渡期开始，进口商和报关员无需获得授权即可进口本立法范围内的货物。</p><p>一旦 1 年 2026 月 2 日过渡期结束，CBAM 进入最终期限，进口商或代表将需要在 CBAM 注册后购买由欧盟成员国通过集中平台出售的 CBAM 证书。证书将根据欧盟 ETS（排放交易系统）配额的每周平均拍卖价格定价，以每吨二氧化碳当量排放的欧元表示。</p><p>如果来源国采用类似的方法征收排放税，则可以进行抵消。在这种情况下，这将以回扣的形式进行核算。</p><h3>哪些商品属于范围以及需要报告什么？</h3><p>水泥、电力、化肥、铁/钢、铝、化学品。</p><p>下表概述了哪些商品将受到影响以及需要报告的内容：</p><p><img alt="" class="align_center" src="https://www.craneww.com/site/assets/files/3855/cbam-2.988x0-is.png" width="988"></p><h4><strong>相关立法：</strong></h4><p class="gt-block">海关代表第 18 条， <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A02013R0952-20221212#tocId24">（欧盟）952/2013</a><br>报告要求第 32 条， <a href="https://eur-lex.europa.eu/eli/reg/2023/956/oj#d1e2957-52-1">（欧盟）2023/956</a></p><p><br>&nbsp;</p>`,
    },
    {
      id: '9',
      time: '2024 年 3 月 12 日',
      title: '没有再出口到俄罗斯条款更新',
      desc: '12年833月2014日发布的理事会第22/2024号条例第XNUMXg条旨在打击规避欧盟出口禁令的行为；更具体地说，是出口到第三方国家的货物然后再出口到俄罗斯的情况。',
      detail: `<h1>欧盟未更新俄罗斯条款</h1><p class="gt-block"><a href="https://finance.ec.europa.eu/document/download/7f54341b-2bf1-4142-b5d4-b1b09c93d03e_en?filename=faqs-sanctions-russia-no-re-export_en.pdf">理事会第 12/833 号条例第 2014g 条</a> 22年2024月XNUMX日发布，旨在打击规避欧盟出口禁令的行为；更具体地说，是出口到第三方国家的货物然后再出口到俄罗斯的情况。一些欧盟出口商/进口商将被要求在其合同中实施“禁止俄罗斯条款”。而其他国家在与第三方国家打交道时则需要通过合同禁止将某些商品再出口到俄罗斯或在俄罗斯使用。&nbsp;</p><p class="gt-block">受影响的商品清单仅限于特别敏感的商品。即，附件十一所列的适用于航空或航天工业的货物（包括刹车片和刹车片以及天线）、附件二十所列的喷气燃料和燃料添加剂、附件三十五所列的枪械和其他武器 <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=OJ:L_202302878">监管833 / 2014</a> 或附件一 <a href="https://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2012:094:0001:0015:En:PDF">枪支法规（欧盟）第 258/2012 号</a>。重要的是，该义务还适用于新引入的法规 833/2014 附件 XL 中列出的所谓共同高优先级物品的贸易，其中涵盖了一系列不同的物品，特别是某些电子零件。</p><h3>哪些商品不能从欧盟出口到俄罗斯？</h3><ul><li>尖端技术（例如量子计算机和先进半导体、电子元件和软件）</li><li>某些类型的机械和运输设备</li><li>炼油所需的特定商品和技术。</li><li>能源工业设备、技术和服务</li><li>航空航天工业产品和技术（例如飞机、飞机发动机、备件或任何类型的飞机和直升机设备、喷气燃料）</li><li>海上导航产品和无线电通信技术</li><li>一些双重用途商品（可用于民用和军事用途的商品），例如无人机和无人机软件或加密设备。</li><li>奢侈品（例如豪华汽车、手表、珠宝）</li><li>民用枪支及其零件和其他军用物资</li><li>化学品、锂电池和恒温器</li><li>其他可以增强俄罗斯工业能力的商品。</li></ul><h3>哪些商品不能从俄罗斯进口到欧盟？</h3><ul><li>原油（自 2022 年 XNUMX 月起）和精炼石油产品。</li><li>煤炭和其他固体化石燃料。</li><li>钢、钢制品和铁。</li><li>黄金和钻石，包括珠宝。</li><li>水泥、沥青、木材、纸张、合成橡胶和塑料</li><li>海鲜和酒（例如鱼子酱、伏特加）</li><li>香烟和化妆品</li><li>钻石</li></ul><p>在合同中包含“禁止俄罗斯条款”的义务从20年2024月19日开始，但不影响2023年20月2024日之前签订的合同的执行，直至12年3月833日或到期日（以较早者为准）。然而，这个过渡期也意味着期限较长的合同可能需要重新谈判。第 2014/XNUMX 号法规第 XNUMXg (XNUMX) 条进一步规定，如果合同伙伴违反“禁止俄罗斯条款”，出口商的合同必须提供“充分的补救措施”。这可能导致包括合同罚款或规定在违约情况下终止合同。此外，出口商还必须向国家当局通报此类违反合同的行为。</p><h2>这对你来说意味着什么？</h2><p class="gt-block">• 从事从欧盟国家出口任何所列限制商品的出口商/进口商需要了解在销售合同中添加“禁止俄罗斯条款”的要求。&nbsp;<br>• 出口商/进口商在处理欧盟原产地进口产品时必须保持警惕，确保在可行的情况下进口后不会被转运至被禁止的国家。&nbsp;</p><blockquote><p class="gt-block">如有任何疑问，请联系您当地的团队或发送电子邮件至： <a href="mailto:globaltradecompliance@craneww.com">globaltradecompliance@craneww.com</a>.</p></blockquote>`,
    },
    {
      id: '10',
      time: '2024 年 3 月 4 日',
      title: '阿联酋 NAIC HS 代码要求',
      desc: '自 29 年 2024 月 6 日起，阿联酋国家预先信息中心 (NAIC) 强制要求所有进口空运货物必须提供 XNUMX 位协调制度 (HS) 代码，作为预先货物信息 (ACI) 备案的一部分进入、出口或过境阿拉伯联合酋长国。',
      detail: `<h1>阿联酋 NAIC HS 代码要求&nbsp;</h1><p>自 29 年 2024 月 6 日起，阿联酋国家预先信息中心 (NAIC) 强制要求所有进口空运货物必须提供 XNUMX 位协调制度 (HS) 代码，作为预先货物信息 (ACI) 备案的一部分进入、出口或过境阿拉伯联合酋长国。&nbsp;</p><p>HS编码应提供如下：</p><ul><li>货物交付至克瑞/克瑞代理工厂时，应向克瑞/克瑞代理提供 6 位 HS 代码。</li><li>6 位 HS 代码应根据世界海关组织 (WCO) HS 代码列表进行验证。</li><li>8 位或 10 位代码也可接受，但仅需要验证这些 HS 代码的前 6 位数字。</li></ul><p>&nbsp;所需信息应按以下格式提供：</p><p>1.&nbsp;&nbsp; &nbsp;<strong>直接发货：</strong> HS 代码应在主航空运单（FWB 消息的 RTD 部分，使用标识符“NH”）中提供。<br>RTD/1/P6/K45/CQ/W142/R14.88/T2112.96&nbsp;<br>/NG/鲜花&nbsp;<br>/2/ND/K100/CMT105-52-26/10&nbsp;<br>/3/NV/MC0.85&nbsp;<br>/4/NH/060311&nbsp;<br>/5/NH/060313&nbsp;<br>/6/NH/060314&nbsp;<br>&nbsp;<br>2.&nbsp;&nbsp; &nbsp;<strong>合并发货：</strong> HS 代码应在分运单中提供（FHL 消息使用标识符“HTS”）<br>FHL/4&nbsp;<br>MBI/000-000000DUMDUM/T1K9&nbsp;<br>HBS/0000000000/DUMDUM/1/K9/1/伊维菌素 MEDI&nbsp;<br>医院用TXT/伊维菌素药物&nbsp;<br>HTS/293890&nbsp;</p><p>如果 HS 代码多于 FWB 或 FHL 上可记录的数量，则应提供按重量或体积计算最重要货物的 HS 代码。</p><p class="gt-block">有关此要求和其他海关要求的详细指南，请查看 <strong><a href="https://www.craneww.com/site/assets/files/3965/uae_harmonizedcoderequirements.pdf">NAIC ACI 海关要求</a></strong>.</p><p class="gt-block"><strong>如果在出发前未收到必填信息会怎样？</strong><br>未能提供 HS 编码将导致违规并可能受到处罚。</p><h2>这对你来说意味着什么？&nbsp;</h2><p>在从阿联酋出口、运往阿联酋或途经阿联酋的货物出发之前，必须向 Crane 提供上述信息，以避免货运延误或取消。</p><blockquote><p class="gt-block">如有任何疑问，请联系克瑞全球贸易合规部，或发送电子邮件至： <a href="mailto:globaltradecompliance@craneww.com">globaltradecompliance@craneww.com</a>.</p></blockquote>`,
    },
  ]
}


export const caseData = {
  list: [
    {
      id: '1',
      title: '大型矿业公司扩大与 Crane Worldwide Logistics 的合作关系以开展高优先级项目',
      desc: '过去几年，全球物流受到干扰和风险的影响。随着该行业开始应对可能成为流行病的风险，......',
      descHtml: ` <p>过去几年，全球物流受到干扰和风险的影响。随着该行业开始应对可能成为流行病及其带来的风险，克瑞环球物流与一家大型矿业公司签订了项目物流运输合同。&nbsp;</p>
            <p>该计划是为一个大型项目提供物流服务，以扩大现有矿山的规模。</p>
            <p class="gt-block">该项目包括超过 <strong>170,000万吨收入</strong> (RT)
              来自世界各地的材料。涉及大量规划，但需要灵活性和敏捷性，因为供应链中断会产生很大影响，特别是在处理来自中国和韩国的项目货物时。
            </p>
            <p> 航运能力日益匮乏，港口拥堵程度达到历史最高水平。需要租用超大型货物的船只来接运大部分货物，并且在整个项目过程中需要与客户进行无缝沟通。</p>`,
      bannerImage: require("@/assets/images/news/case-01-banner.jpg"),
      image1: require("@/assets/images/news/case-01-01.jpg"),
      image2: require("@/assets/images/news/case-01-02.jpg"),
      image3: require("@/assets/images/news/case-01-03.jpg"),
      itemHtml1: `<h2>存在哪些挑战？</h2>
                <p></p>
                <p>租船和制定运输 170,000 R/T 货物的计划并不是一件小事。几个核心设备使事情变得更加复杂，除了典型的项目物流搬迁之外，这些设备还需要额外的维护和规划。</p>
                <p>Crane Worldwide 精心策划了货物运输并制定了详细的装载计划。这是一个耗时数月处理项目货物的详尽过程。项目团队的全球准备工作是完成该项目的众多举措的关键。</p>
                <p>然而，一些挑战很快影响了最初的计划，并导致需要更强的弹性。这些挑战包括：</p>
                <ul>
                  <li>
                    始发港的外国国旗限制导致预期停泊时间立即延迟。这些限制正值中国零新冠政策的高峰期，并影响了现有的时间表。
                  </li>
                  <li>确保制定新计划来管理中国大陆许多供应商的合并负载。其中还包括通过驳船从制造商的私人码头运输六批超大货物，即“冷箱”，每批重量超过
                    175 吨，并在船边装载，同时适应双重银行限制。
                  </li>
                  <li>
                    联系潜在的驳船运营商，寻找那些不受船旗限制影响的驳船运营商，同时评估所有装载和绑扎要求，以确保驳船、包租船只的稳定性并确保安全运输。
                  </li>
                  <li>由于季风威胁再次延迟装载时出现额外中断，因此调整了这些“B 计划”步骤。</li>
                </ul>
                <p></p>`,
      itemHtml2: `<h2>克瑞环球物流如何兑现其承诺。</h2><p></p><p>尽管面临挑战，Crane Worldwide Logistics 的团队仍然能够找到驳船，重新设计从驳船到船舶的装载计划，遵守港口的所有双重堆放和装载要求，并制定明确的成本规避策略。</p><p>在找到了避免因船旗限制、港口延误以及寻找驳船运营商方面的挑战而产生额外成本的方法后，Crane Worldwide 必须重新评估各种情况并制定替代计划，以避免执行过程中出现的季风。行动已经开始。</p><p>这需要让驳船躲起来以度过风暴。尽管如此，Crane Worldwide 仍然成功地完成了包租船舶的完全装载，其效率和速度改进了最初的计划，以确保成功运营。</p> <p>在进行项目物流活动时，特别是在出现超出范围的挑战时，灵活性和适应运营环境至关重要。&nbsp;</p><p>我们的全球项目团队与客户并肩工作，实现了无缝沟通，以确保实现最佳结果。</p><p></p>`,
      itemHtml3: ` <h2>结果</h2><p class="gt-block">Crane Worldwide Logistics 通过灵活的方法来处理发生的物流中断并寻找额外的成本规避机会，从而加强了现有的客户关系。这包括识别核心风险并制定可以提前交付的运输策略，同时克服项目运输初始计划的关键障碍。<br>结果是：</p><ul><li>成功协调中国东南部 18 家供应商的负载。</li><li>随着时间的推移，随着中断的发生，调整策略，避免潜在的超过 1 万美元的拘留费用。</li><li>放电 项目货物 准时到达现场，并且不会因意外事件而产生额外费用。</li><li>随着接下来几个月中断情况的发展，继续满足客户的需求，并确保全面、灵活的运输管理。&nbsp;</li></ul>`,

    },
    {
      id: '2',
      title: '海上物流 - 海上钻井平台管理',
      desc: '离岸物流 - 能源行业……离岸钻机管理需要量身定制的物流解决方案，以满足持续的过程...',
      descHtml: ` <h1>离岸物流 - 能源行业</h1><p>海上钻井平台管理需要量身定制的物流解决方案，以满足保持钻井平台全面维护和运营的持续过程。 认识到对灵活和适应性强的供应链流程的需求，Crane Worldwide Logistics 在澳大利亚建立了供应基地，以支持海上钻井组织，以便为全国的能源行业提供积极的服务。&nbsp;&nbsp;</p>`,
      bannerImage: require("@/assets/images/news/case-02-banner.jpg"),
      image1: require("@/assets/images/news/case-02-01.jpg"),
      image2: require("@/assets/images/news/case-02-02.jpg"),
      image3: require("@/assets/images/news/case-02-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>海上钻井平台从世界各地抵达澳大利亚，经过严格的检疫和海关流程，进港钻井平台的管理是一个复杂的入境过程，需要全面的物流和海关支持。 到达澳大利亚后，钻井平台需要持续维护、物资管理、设备操作和船员管理（例如物流）。 保持海上钻井平台正常运转的持续过程需要卓越的支持来维持运营。 当钻机停机时，企业的成本是巨大的，因此持续运营对于成功至关重要。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>Crane Worldwide Logistics 在布鲁姆、墨尔本港和卡拉萨设有功能齐全的独特供应基地，为海上钻井平台管理提供支持。 钻机供应商提供的物资进入我们的仓库，并由我们的物流专家进行审查。 还提供盘点和收货、质量控制、检查和其他增值服务。 鉴于 Crane Worldwide 与澳大利亚能源行业之间的独特关系，还提供供应商支持，并向供应基地提供国内卡车运输。 还提供废物管理、船员服务和停放/仓库空间服务。 &nbsp;</p><p>供应基地不仅满足钻机的日常货运代理和物流需求，还满足 24/7 的紧急需求，包括时间敏感的手提物流服务。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>在澳大利亚各地建立核心供应基地中心为许多能源客户提供了支持，以确保海上钻井平台的有效维护和持续供应。 当能源行业出现紧急停线情况时，成本可能在每天 200,000 至 300,000 美元之间。 通过澳大利亚关键地点的专用供应基地中心为我们的客户提供持续的量身定制的解决方案，使客户能够专注于海上活动，因为他们知道他们的钻井平台的供应链由 Crane Worldwide Logistics 能源专家控制。&nbsp;&nbsp;</p>`,
    },
    {
      id: '3',
      title: '采矿设备 - 澳大利亚的物流解决方案',
      desc: '采矿业：物流服务……采矿设备有各种形状和尺寸，通常设备可能很重并且超标。',
      descHtml: ` <h1>采矿业 : 物流服务</h1><p>采矿设备有各种形状和尺寸，通常设备可能很重且超出规格。 确保设备在正确的时间以正确的成本放置在正确的位置可能是行业供应商面临的物流挑战。&nbsp;</p>`,
      bannerImage: require("@/assets/images/news/case-03-banner.jpg"),
      image1: require("@/assets/images/news/case-03-01.jpg"),
      image2: require("@/assets/images/news/case-03-02.jpg"),
      image3: require("@/assets/images/news/case-03-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>我们的客户为采矿业提供重型起重管道，而现有的操作效率低下且成本高昂。 管道的存放地点在一个居民区，既不能到达，也不能靠近供应商。 该解决方案成本高昂，原因是设备未充分利用、未按时完成，而且劳动力和场地租金增加了运营的复杂性。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>通过分析客户的工作流程，位于布里斯班的 Crane Worldwide Logistics 团队立即意识到供应链流程效率低下。 效率低下产生了额外的成本，可以通过将存储位置移近供应商来降低成本。 很快，该团队将管道场迁至工业区，并调整了定价模型以将成本与产出联系起来。 通过了解我们客户的工作流程，可以简化操作以消除降低效率的不必要步骤。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>新的堆场位置每年可减少 218,000 澳元的直接成本。 通过分析可用数据来整合供应链流程中的活动，从而提高了效率。 这包括改进材料处理、运输和劳动效率。 Crane Worldwide Logistics 与我们的客户合作，了解现有工作流程并改进流程以降低成本。&nbsp;&nbsp;</p>`,
    },
    {
      id: '4',
      title: '澳大利亚货运服务：重型货物运输',
      desc: '获得重要的重型运输船...作为澳大利亚经济的主要贡献者之一，采矿业长期以来一直是一个关键的...',
      descHtml: ` <h2>获得重要的重型货物运输</h2><p>作为澳大利亚经济的主要贡献者之一，采矿业长期以来一直是一个重要的行业，不仅提供出口收入，而且在全国重要地区提供就业机会。 我们的客户是矿产和石油市场中领先的全球资源公司。 在处理关键运输需求并提供专家建议和帮助多年之后，Crane Worldwide 已被委托为首选供应商。</p>`,
      bannerImage: require("@/assets/images/news/case-04-banner.jpg"),
      image1: require("@/assets/images/news/case-04-01.jpg"),
      image2: require("@/assets/images/news/case-04-02.jpg"),
      image3: require("@/assets/images/news/case-04-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>我们的客户联系了 Crane Worldwide Logistics 的澳大利亚分公司，以运输采矿过程中使用的多个零件，并且需要敏锐的紧迫感。 32 月初，澳大利亚需要起重机桁架和组件，其中一些长度超过 XNUMX 米，来自斯洛伐克和奥地利。</p><p>在始发地，这种专用设备的运输需要多个当局签发的适当文件才能从斯洛伐克和奥地利跨境进入德国，并需要在始发港提供专门的装载文件。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>Crane Worldwide Logistics 澳大利亚与我们在德国的物流专家合作。 我们制定了一个项目计划，旨在为运输超大设备和零件提供经济高效且时间敏感的解决方案。</p><p>获得了在欧洲跨境以及在港口驳船装载超大型设备的许可证。 然后使用起重机将驳船上的材料装载到等待的船只中。 由于集装箱长度较长，无法使用港口的短车道进行装卸，因此它们是从水边装载的。 额外的零件通过散装运输。 一周前，整箱货物为客户装载到九个集装箱中。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p class="gt-block">设备按照 Crane Worldwide 提出的时间表和解决方案运抵阿德莱德。 与客户的持续沟通、提供照片、装载计划和时间框架有助于进一步发展&nbsp;<strong>信任与合作</strong>. 此外，将集装箱船用于超大设备有助于为客户提供额外的好处，不仅在考虑成本方面，而且由于更频繁的航行。</p><p class="gt-block"><strong>在 Crane Worldwide，我们相信信任、协作和团队合作</strong></p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“这是一个大放异彩的绝佳机会，向我们的客户展示了 Crane Worldwide Logistics 如何超越一切以创建有效的解决方案。”</p><footer><h3 class="c_white">克里斯·米切尔（Chris Mitchell），全球专业服务副总裁</h3><p class="c_white">Crane Worldwide Logistics</p></footer></blockquote></div></div>`
    },
    {
      id: '5',
      title: '白手套物流：保持资本设备的质量和控制',
      bannerDesc: '在及时的环境中运输昂贵且敏感的设备。',
      desc: '白手套物流……资本设备是数据存储和许多制造场景的关键组成部分。 这些工具的使用寿命...',
      descHtml: `<h1>白手套物流</h1><p>资本设备是数据存储和许多制造场景的关键组件。 这些工具和数据机架的使用寿命可以跨越数年，支持世界各地的技术基础设施。</p>`,
      bannerImage: require("@/assets/images/news/case-04-banner.jpg"),
      image1: require("@/assets/images/news/case-04-01.jpg"),
      image2: require("@/assets/images/news/case-04-02.jpg"),
      image3: require("@/assets/images/news/case-04-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>资本工具和集成服务器机架庞大、笨重、精致且异常密集。 这些特征并不总是与通常的托盘货运运动一致。 因此，创建用于处理设备运输的网络至关重要。 在这种情况下，使用了多个服务提供商，潜在的损坏可能导致机架完全故障（估计成本为 250 万美元到 400 万美元）。 与多个供应商的程序不一致导致沟通不畅，从而导致错过交付窗口，导致延误并要求重新安排交付。 面临的挑战是召集所有客户的不同职能部门和 Crane Worldwide 专家来确定最佳解决方案。 需要加强各方之间的沟通和可见性，才能获得有关货物的准确信息。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p class="gt-block">Crane Worldwide Logistics 开发了一种直接单元装载设备 (ULD) 模型，可建立从提货到交付的可视性和控制。 部署了一支由资本设备专家组成的专门团队，以确保每笔货运交易的无缝通信。 预订和航班验证由团队管理，以确保清晰的沟通路径并确保交付人员提前协调一致。<br>制定了标准操作程序 (SOP)，以确保每批货物从装载到交付的过程和控制。 Crane 团队提供一致的沟通和照片，订单状态每天更新两到三次。 每日更新也发送给所有参与运输的内部各方以及 Crane Worldwide 的 C-View 仪表板提供的可见性。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p paraeid="{f731314f-c66e-438d-8cdb-653ce202bc4e}{2}" paraid="1720397574">Crane Worldwide Logistics 使用精简的、与一流服务提供商直接联系的团队，促进并支持解决方案。 开发了一个可行且记录在案的流程，为交钥匙交付解决方案注入了干净的责任交接。 我们的客户之前曾在 94.7% 的准时率的 99.3 台已发货服务器中遇到过四个损坏的集成机架和三个“运输途中丢失”的情况。 在与集成机架供应商合作的五年多时间里，Crane Worldwide 在全球范围内将准时性能提高到 15,000%，并且由于可见性和过程控制，超过 XNUMX 个集成机架实现了零损失。&nbsp;</p><p paraeid="{f731314f-c66e-438d-8cdb-653ce202bc4e}{76}" paraid="1030475545" class="gt-block"><strong>在 Crane Worldwide，我们相信信任、协作和团队合作。</strong></p><p paraeid="{f731314f-c66e-438d-8cdb-653ce202bc4e}{76}" paraid="1030475545" class="gt-block">如果您需要支持 白手套物流服务，请联系下方。</p>`,
    },
    {
      id: '6',
      title: '采购订单管理 - 控制上游采购订单 - 可见性和供应商管理',
      desc: '采购订单管理……全球供应链中断往往是公司检查其供应链的催化剂。 当我们的其中一位...',
      descHtml: `<h1>采购订单管理</h1><p>全球供应链中断通常是公司检查其供应链的催化剂。 当我们的一位汽车制造客户向我们提出上游进口供应链问题时，我们深入了解问题并提供解决方案。 我们发现大多数问题都与订单和项目级别缺乏可见性、采购订单流程控制以及供应商管理有关。</p><p>我们提出了 Crane 的 PinPoint 解决方案来帮助客户控制他们的采购订单流程和供应商管理。 这带来了可衡量的节省、新的效率和更高水平的客户满意度。</p>`,
      bannerImage: require("@/assets/images/news/case-06-banner.jpg"),
      image1: require("@/assets/images/news/case-06-01.jpg"),
      image2: require("@/assets/images/news/case-06-02.jpg"),
      image3: require("@/assets/images/news/case-06-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>面临的挑战是将不同的职能部门（包括采购、运输、分销、合规和财务）聚集在一起，以找到可行的解决方案。 该测试旨在通过使用 Crane 的订单管理技术、PinPoint、Crane 的客户管理团队和全球网络来促进和支持解决方案。 我们的客户指出了他们的供应链中出现的问题，特别是与供应商和可见性有关的问题。 例如，供应商没有按照出厂/DC 日期及时发货； 供应商运送不正确的采购订单和物品。 能见度是一个关键的问题领域，因为在货物被确认上船之前缺乏与货物相关的信息。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>通过接收所有客户采购订单的副本，启用我们的全球网络，并使用 Pinpoint 的技术，我们将上游管理和可见性提升到了前所未有的新水平。 改进包括供应商管理：基于规则的预订自动化、出厂和发货窗口合规性、订单以及发货以匹配 PO 数量的项目。 可见性改进包括：仪表板视图、从 PO 开始的订单和项目详细信息视图、基于规则的自动预订和异常管理、里程碑异常管理、到客户的 EDI ASN、订单和项目到达仪表板，供 DC 管理入站流程。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>我们的客户能够看到可量化的证据，通过优化集装箱利用率和模式控制，节省了 10% 的库存支出，减少了 5% 的入站接收劳动力，减少了 5% 的运输。 最终，这导致了高水平的客户满意度，这是最终目标。</p><p class="gt-block"><strong>在 Crane Worldwide，我们相信信任、协作和团队合作。</strong></p><p class="gt-block">了解有关 PO 管理工具的更多信息</p><p>&nbsp;</p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“Crane Worldwide 能够通过 PinPoint、我们的帐户管理和全球网络来促进和支持解决方案。”</p><footer><h3 class="c_white">John Jergens，销售副总裁</h3><p class="c_white">Crane Worldwide Logistics</p></footer></blockquote></div></div>`
    },
    {
      id: '7',
      title: '向爱尔兰医院运送呼吸机的最后一英里快递 - COVID-19 冠状病毒反应',
      desc: '最后一英里交付……COVID-19 冠状病毒大流行改变了许多服务的运作方式，成为提供医疗服务的挑战……',
      descHtml: `<h1>最后一英里交付</h1><p class="gt-block">COVID-19 冠状病毒大流行改变了许多服务的运作方式，因为在世界各地提供医疗用品的挑战成为许多负责任的制造商和服务提供商关注的焦点。 Wisetek 是 IT 资产处置、再利用和制造服务的全球解决方案提供商，也是重要的客户和合作伙伴 <a href="/%E5%9C%B0%E7%82%B9/%E7%88%B1%E5%B0%94%E5%85%B0/">Crane Worldwide 在爱尔兰</a>. 近日，Wisetek处理了一批来自中国的呼吸机，并在爱尔兰完成了零件的完整组装过程以完成成品。 医院迫切需要呼吸机来支持越来越多的冠状病毒受害者。</p>`,
      bannerImage: require("@/assets/images/news/case-07-banner.jpg"),
      image1: require("@/assets/images/news/case-07-01.jpg"),
      image2: require("@/assets/images/news/case-07-02.jpg"),
      image3: require("@/assets/images/news/case-07-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p class="gt-block">在世界各地，克瑞全球物流正在支持冠状病毒大流行，以支持医疗设备供应链。&nbsp;<br>呼吸机完全组装完毕后，Wisetek 需要一个合作伙伴将产品紧急交付给爱尔兰各地缺乏必要设备的医院。<br>作为制造、履行和生命周期管理服务的一站式解决方案，Wisetek 与我们的爱尔兰团队合作，在呼吸机的最后一英里交付中与他们合作，因为他们需要一个反应灵敏且灵活的合作伙伴来确保按时交付。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>随着爱尔兰在爱尔兰政府的指导下开始封锁，我们在爱尔兰的仓库和运营中心的关键基础设施工作人员继续专注于医疗物资的分配和运输的重要工作，以确保医疗物资及时到达医院. 我们敬业的司机和运营团队带着紧迫感工作，以确保在产品完全组装后立即交付。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>Crane Worldwide 以敏锐的紧迫感为 Wisetek 提供灵活可靠的服务，成功地将第一批组装好的呼吸机直接分发到医院病房。&nbsp;</p><p>作为关键基础设施的工作人员，我们很自豪能够保持供应链的运转并为我们的客户提供紧急货运请求。 我们将尽一切可能帮助您在这些不确定的时期实现您的物流目标。</p><p class="gt-block"><strong>在 Crane Worldwide，我们相信信任、协作和团队合作。</strong></p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“我们很自豪能够在冠状病毒 COVID-19 大流行期间为我们的客户提供支持，感谢我们在爱尔兰的运营人员做出的改变。”</p><footer><h3 class="c_white">Crane Worldwide Logistics 董事总经理 Chris Deans</h3></footer></blockquote></div></div>`
    },
    {
      id: '8',
      title: 'Channels Medical Solutions 是神经诊断和呼吸系统专业解决方案的分销商。 他们还分配电子医疗...',
      desc: '白手套物流……资本设备是数据存储和许多制造场景的关键组成部分。 这些工具的使用寿命...',
      descHtml: `<p>Channels Medical Solutions 是神经诊断和呼吸系统专业解决方案的分销商。 他们还分发电子医疗产品、配件和耗材。 随着冠状病毒 COVID-19 大流行到达南非，制氧机的进口激增，因为南非的医疗保健系统需要更多产品来支持全国各地的社区。 随着航空公司开始取消飞往约翰内斯堡的服务，客户向 Crane Worldwide 提出了从中国和美国进口的紧急货运请求。</p>`,
      bannerImage: require("@/assets/images/news/case-08-banner.jpg"),
      image1: require("@/assets/images/news/case-08-01.jpg"),
      image2: require("@/assets/images/news/case-08-02.jpg"),
      image3: require("@/assets/images/news/case-08-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>由于 COVID-19 大流行影响了全球的航空服务，由于需求不足，客运航班大幅减少。 在某些情况下，航空公司已经停飞了所有业务。 就货物空间而言，这意味着客机货运代理通常可用的“腹部”货物存储空间显着减少。 有限的容量给客户寻找负担得起的货物空间带来了挑战。 此外，缺乏支持卡车运输业务的劳动力进一步使交付时间表复杂化。 目前，在南非，国内交通也需要驾驶证，以确保严格遵守居家政策。 该国对封锁进行了严格控制，以限制病毒的传播。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>带着紧迫感，约翰内斯堡团队努力工作，为我们的客户寻找紧急空运解决方案。 冠状病毒大流行表明，全球伙伴关系和关系对于确保全球供应链继续运作至关重要。 目前，医疗用品是当务之急。 在需要的时候，与合作伙伴的团队合作、信任和协作至关重要。 约翰内斯堡团队联系了 Crane Worldwide 办事处的全球物流专家，以确保尽快找到解决方案。 我们的全球专家与我们的航空公司合作伙伴合作，确保了最高效的空运选择，以实现制氧机的国际运输。 不断变化的航班时刻表，包括取消以及有限的空间挑战，并没有阻止该团队确保将关键医疗用品安全及时地运送到南非。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>制氧机从美国和中国从众多供应商处进口，并安全交付给我们的客户。 在全球因冠状病毒而需要必要设备的时候，Crane Worldwide 全球团队提供的紧迫感和灵活性确保我们在客户最需要我们时作为可信赖的合作伙伴站在他们身边。 使用这种基本设备将支持南非正在进行的帮助冠状病毒病患者的努力。 作为关键的基础设施工人，我们很自豪能够保持供应链的运转并为我们的客户提供紧急货运请求。 在这些不确定的时期，我们将尽一切可能帮助您实现物流目标。</p><p class="gt-block"><strong>在 Crane Worldwide，我们相信信任、协作和团队合作。</strong></p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“Crane Worldwide Logistics 在南非从未停止超越我们的期望。 你有一支优秀的团队。”</p><footer><h3 class="c_white">Loraine du Bois | 销售经理</h3><p class="c_white">渠道医疗解决方案</p></footer></blockquote></div></div>`
    },
    {
      id: '9',
      title: '白手套物流：保持资本设备的质量和控制',
      bannerDesc: '在及时的环境中运输昂贵且敏感的设备。',
      desc: '白手套物流……资本设备是数据存储和许多制造场景的关键组成部分。 这些工具的使用寿命...',
      descHtml: `<h1>白手套物流</h1><p>资本设备是数据存储和许多制造场景的关键组件。 这些工具和数据机架的使用寿命可以跨越数年，支持世界各地的技术基础设施。</p><p>一家财富 100 强技术系统行业领导者联系 Crane Worldwide Logisitic 的资本设备专家，请求在集成数据服务器机架（其 IT 基础设施的关键组件）的全球运输方面提供帮助。发货错误、产品处理不当和损坏以及不可靠的空运和交货时间是客户面临的一些挑战。白手套物流需要专业护理。</p>`,
      bannerImage: require("@/assets/images/news/case-09-banner.jpg"),
      image1: require("@/assets/images/news/case-09-01.jpg"),
      image2: require("@/assets/images/news/case-09-02.jpg"),
      image3: require("@/assets/images/news/case-09-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>资本工具和集成服务器机架庞大、笨重、精致且异常密集。 这些特征并不总是与通常的托盘货运运动一致。 因此，创建用于处理设备运输的网络至关重要。 在这种情况下，使用了多个服务提供商，潜在的损坏可能导致机架完全故障（估计成本为 250 万美元到 400 万美元）。 与多个供应商的程序不一致导致沟通不畅，从而导致错过交付窗口，导致延误并要求重新安排交付。 面临的挑战是召集所有客户的不同职能部门和 Crane Worldwide 专家来确定最佳解决方案。 需要加强各方之间的沟通和可见性，才能获得有关货物的准确信息。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p class="gt-block">Crane Worldwide Logistics 开发了一种直接单元装载设备 (ULD) 模型，可建立从提货到交付的可视性和控制。 部署了一支由资本设备专家组成的专门团队，以确保每笔货运交易的无缝通信。 预订和航班验证由团队管理，以确保清晰的沟通路径并确保交付人员提前协调一致。<br>制定了标准操作程序 (SOP)，以确保每批货物从装载到交付的过程和控制。 Crane 团队提供一致的沟通和照片，订单状态每天更新两到三次。 每日更新也发送给所有参与运输的内部各方以及 Crane Worldwide 的 C-View 仪表板提供的可见性。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p paraeid="{f731314f-c66e-438d-8cdb-653ce202bc4e}{2}" paraid="1720397574">Crane Worldwide Logistics 使用精简的、与一流服务提供商直接联系的团队，促进并支持解决方案。 开发了一个可行且记录在案的流程，为交钥匙交付解决方案注入了干净的责任交接。 我们的客户之前曾在 94.7% 的准时率的 99.3 台已发货服务器中遇到过四个损坏的集成机架和三个“运输途中丢失”的情况。 在与集成机架供应商合作的五年多时间里，Crane Worldwide 在全球范围内将准时性能提高到 15,000%，并且由于可见性和过程控制，超过 XNUMX 个集成机架实现了零损失。&nbsp;</p><p paraeid="{f731314f-c66e-438d-8cdb-653ce202bc4e}{76}" paraid="1030475545" class="gt-block"><strong>在 Crane Worldwide，我们相信信任、协作和团队合作。</strong></p><p paraeid="{f731314f-c66e-438d-8cdb-653ce202bc4e}{76}" paraid="1030475545" class="gt-block">如果您需要支持 白手套物流服务，请联系下方。</p>`,
    },
    {
      id: '10',
      title: '关税回扣分析为汽车客户节省了 3 万美元以上',
      bannerDesc: '第 301 条关税豁免为我们的客户创造了附加价值',
      desc: 'Crane Worldwide 贸易咨询服务承认第 301 条下的关税豁免……我们的汽车客户受到第 301 条的严重影响……',
      descHtml: `<h3>Crane Worldwide Trade Advisory Services 承认第 301 条规定的关税豁免</h3><p>我们的汽车客户受到 301 条款关税的严重影响，该关税已适用于从中国采购的汽车零部件进口到美国。 采购成本的大幅增加成为客户的财务负担，不仅影响现金流，而且影响底线结果。</p>`,
      bannerImage: require("@/assets/images/news/case-10-banner.jpg"),
      image1: require("@/assets/images/news/case-10-01.jpg"),
      image2: require("@/assets/images/news/case-10-02.jpg"),
      image3: require("@/assets/images/news/case-10-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>2018 年 301 月开始的中美贸易战导致对原产于中国的商品征收高额关税。 1974 年《贸易法》第 XNUMX 条立法导致我们的汽车客户在从中国采购汽车零部件时面临成本增加的困境。&nbsp;</p><p>在可预见的未来，国际贸易格局将动荡不安，我们的客户面临的供应链挑战是不可预测的，我们需要一个解决方案来确定如何应对关税增加的影响。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>Crane Worldwide Logistics 贸易咨询专家开始分析我们客户进口的汽车零部件的统一关税表 (HTS)。 该团队完成了对客户海关条目的全面分析。&nbsp;</p><p>该团队与底特律站的汽车物流专家一起，确定了潜在的统一关税代码，可以免除我们客户的中国产产品。 可以提出退税申请以收回已支付的额外费用。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>使用 Crane Trade Services 团队提供的深入 HTS 分析，Crane Worldwide Logistics 确定我们的客户可以通过 CBP 的事后总结更正收回 1.6 万美元。 通过进一步分析，另外 1.7 万美元被归入了符合退税条件的额外协调关税表代码。 这个退税机会立即为客户提供了解决方案，并为未来的进口需求提供了解决方案。</p><p class="gt-block"><strong>在 Crane Worldwide，我们相信自己是客户的代言人</strong></p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“根据 301 条款改变关税法规对我们的客户产生了重大影响。 我们的贸易咨询专家对 HTS 代码的分析使我们的汽车物流客户能够收回超过 3 万美元的关税退税。”</p><footer><h3 class="c_white"></h3></footer></blockquote></div></div>`,
    },
    {
      id: '11',
      title: '汽车供应链分析可节省超过 1 万美元的成本',
      bannerDesc: '我们的汽车专家通过供应链流程分析降低运输成本',
      desc: '汽车售后物流服务……我们的汽车客户是一家领先的卡车装配和售后零部件制造商……',
      descHtml: `<h1>汽车售后物流服务</h1><p>我们的汽车客户是一家领先的组装和售后市场应用卡车零部件制造商，承认需要汽车物流专家来分析他们现有的汽车零部件运输流程。 这家货运制造商正在寻求降低来自海外汽车零部件供应商的国际供应链运输成本的改进措施。</p>`,
      bannerImage: require("@/assets/images/news/case-11-banner.jpg"),
      image1: require("@/assets/images/news/case-11-01.jpg"),
      image2: require("@/assets/images/news/case-11-02.jpg"),
      image3: require("@/assets/images/news/case-11-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>汽车客户从欧洲和亚洲到美洲的贸易航线正在用海运集装箱从供应商的门到门运输。 客户要求优先缩短运输时间并提高运输路线的可靠性。 降低成本非常重要，因为滞留和滞期费经常影响他们现有运输解决方案的成本。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>Crane Worldwide 团队确定了几个可以根据客户的优先事项改进运输流程的领域。 提议的解决方案是在到达港终止装运，将 Crane Worldwide 当地设施的材料从海运集装箱转移到国内设备，然后使用 Crane Worldwide 在美国的广泛内部网络和设备交付内容。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>结果包括通过消除在港口等待交付的集装箱的滞期费，节省了超过 600 万美元的成本。 此外，还取消了海运集装箱和底盘在等待交付期间的滞留费。 由于使用的是国产设备而不是海运设备，因此运输费用显着降低。 此外，未来的运营改进将通过将单一拖车的入库货物与内陆交付额外节省 25% 的机会相结合来减少本地交付的数量。</p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“与我们的汽车客户合作并识别挑战使我们的汽车物流团队能够提供具有成本效益的解决方案。”</p><footer><h3 class="c_white">Robert Gulyas - 汽车全球副总裁</h3><p class="c_white">Crane Worldwide Logistics</p></footer></blockquote></div></div>`,
    },
    {
      id: '12',
      title: '中欧铁路货运服务成功',
      bannerDesc: '铁路货运解决方案在实施的第一年就交付了 2.8 万元人民币',
      desc: '减少库存、关税预付款和运输时间带来了结果。 我们的客户是中国的一家家具制造商，面临着大量货物...',
      descHtml: `<h3>减少库存、关税预付款和运输时间带来了结果。&nbsp;</h3><p>我们的客户是中国的一家家具制造商，在使用海运服务时面临严重的货物延误。 他们难以计划库存，并持有大量缓冲库存来补偿海运服务延迟到达的货物。 在经历了波动的海运费用和高昂的报关费用后，客户联系了亚太地区的 Crane Worldwide Logistics，寻求更好的物流解决方案。</p>`,
      bannerImage: require("@/assets/images/news/case-12-banner.jpg"),
      image1: require("@/assets/images/news/case-12-01.jpg"),
      image2: require("@/assets/images/news/case-12-02.jpg"),
      image3: require("@/assets/images/news/case-12-03.jpg"),
      itemHtml1: `<h2>挑战</h2><p></p><p>每个季度我们的客户持有 10.8 万元人民币的缓冲滞留，总仓库需求为 19,376 平方英尺，每个集装箱的海运费成本超过 20 万元人民币。 通过现有客户的推荐，Crane Worldwide Logistics 与制造组织合作，了解确切的仓库周转时间。 从收集的数据中，Crane Worldwide 的团队认识到进行调整以改善现有挑战的潜力。</p><p></p>`,
      itemHtml2: `<h2>我们的解决方案</h2><p></p><p>我们的团队认为铁路货运是我们客户使用德国到上海门到门服务的理想物流解决方案。 通过这种运输方式，Crane Worldwide Logistics 能够将交货提前期显着缩短三十天。 通过使用铁路货运可预测的到达时间，该团队制定了一个时间表，确定在采购订单发布日期之前货物可以保留多长时间。 优化采购订单发布日期可确保更快的周转并减少缓冲库存以及整体供应链效率。</p><p></p>`,
      itemHtml3: `<h2>结果</h2><p>结果，我们的客户在使用铁路货运提议的解决方案的第一年就节省了 2.8 万元人民币。 在转移到可靠的铁路货运服务后，交货时间缩短并将过剩库存减少到最低限度。 运输效率的提高以及现金流的改善和预付关税支出的降低为客户节省了大量成本。</p><p class="gt-block"><strong>在 Crane Worldwide，我们相信创新和可能性，而不是限制。</strong></p><p>&nbsp;</p>`,
      itemHtml4: `<div class="section bg_secondary"><div class="section__container container container_size_sm"><blockquote class="spacing_lg text_lead c_white text_align_center"><p>“为客户的供应链挑战找到最佳物流解决方案对于建立信任至关重要。 铁路货运是中国到欧洲运输需求的绝佳选择。”</p><footer><h3 class="c_white">Jeff LeBlanc，亚洲区域副总裁</h3><p class="c_white">Crane Worldwide Logistics</p></footer></blockquote></div></div>`,
    },
  ]
}


export const podcastData = {}

export const guideData = {
  list: [
    {
      id: '1',
      title: 'FOB 船上免费 - Incoterms®',
      desc: '一旦货物装上船，风险和费用即转移给买方。',
      detail: `<h1>船上交货 (FOB) 的基本原理 Incoterm</h1>
          <p class="gt-block">有许多不同的国际贸易术语需要了解，有些可能会让人感到困惑。例如，有三个以单词开头的，
            <em><strong>“自由的，”</strong></em> 但它们在技术上并不是免费的！相反，它描述了买方在国际贸易中负责的内容，即进出口方面的责任。之间也存在类似的差异
            <a href="/guideDetail?id=11">船边免费
              (FAS)</a> 和 <a
                href="/guideDetail?id=5">货代承运人
              (FCA)。</a> 以下是有关 Free On Board 真正含义、何时使用它、其潜在缺点以及如何更轻松地利用这一点以及所有内容的事实
            <a href="/news?type=guide">国际贸易术语</a>
            在未来。&nbsp;</p>
          <p><img alt="FOB 船上交货 Incoterms 规则"
                  src="https://www.craneww.com/site/assets/files/3193/cww_incoterms_fob_002.1352x0-is.jpg" width="1352">
          </p>
          <h2>FOB 是什么意思？</h2>
          <p>
            FOB（即船上交货）是一种国际贸易术语解释通则，规定卖方负责将货物交付到买方指定的船上。该责任包括直至货物装上船为止的所有成本和风险。一旦货物在指定的装货港越过船舷，风险和责任就从卖方转移到买方。这种明确的责任区分使
            FOB 成为许多国际贸易商的首选术语。&nbsp;</p>
          <p>当然，需要注意的是，FOB
            的使用仅限于通过海运或内河运输的货物。这一限制强调了该术语与传统运输路线和方法的相关性，将其与可能适用于各种运输方式（包括航空、铁路和公路）的其他国际贸易术语区别开来。</p>
          <p>此外，Free On Board
            指定了一个特定的装货地点，从技术上讲，这就是交货地点。本质上，卖方负责将货物运送到交货地点——船上。这样做，买方就失去了对港口和码头或其他运输偏好的控制。</p>
          <p>港口的选择会影响运输的成本、时间和物流，使其成为双方在谈判过程中的关键考虑因素。</p>
          <blockquote><p class="gt-block"><strong>您知道吗？ </strong>使用 Free On Board Incoterms 规则的指定地点始终是装货港。
          </p></blockquote>
          <h2>在国际贸易中使用船上交货或离岸价格的缺点</h2>
          <p>虽然 FOB
            是一种广泛使用的国际贸易术语解释通则，它明确界定了国际贸易中买方和卖方的责任，但它并非没有缺点，尤其是对于买方而言。一旦货物装上船，买方就承担所有风险和责任，这可能会带来一些挑战，包括：</p>
          <ul>
            <li><strong>损坏或丢失的风险 -</strong>&nbsp;货物装船后，运输过程中的任何损坏或丢失均由买方负责。这种风险需要全面的保险，这会增加采购的总体成本。
            </li>
            <li><strong>运输延误</strong> - 买方应对货物装船后的任何延误负责。这些延误可能是由于天气、物流问题或港口拥堵造成的，可能导致成本增加和错过最后期限。
            </li>
            <li><strong>海关和合规问题 -</strong> 买方必须处理目的地国家的所有清关程序。任何合规问题，例如文件不正确或不符合进口法规，都可能导致货物延误、罚款，甚至被没收。
            </li>
            <li><strong>运输和卸货费用 -</strong> 货物装上船后，买方负责所有后续运输费用，包括在目的港卸货。这些成本差异很大，并且可能会根据外部因素发生变化，从而使预算变得困难。
            </li>
            <li><strong>环境法规的责任 -</strong> 在某些司法管辖区，进口商（买方）确保货物符合所有环境法规。不遵守规定可能会导致处罚、罚款以及未来进口的限制。
            </li>
            <li><strong>保险费用 - </strong>虽然保险对于任何货物来说都是一项审慎的措施，但买方必须特别确保保险范围足以应对离岸条款下海上运输的相关风险。这通常意味着更高的保费来弥补航行期间的潜在损失。
            </li>
            <li><strong>取决于卖方的运输选择 -</strong> 尽管买方指定船舶，但初始装载过程由卖方控制，卖方可能选择不适合买方需求或货物安全的装载方法或时间表。
            </li>
          </ul>
          <h2>通过与 Crane Worldwide Logistics 合作了解何时使用 FOB</h2>
          <p>对于所有国际贸易术语解释通则，了解买方和卖方的义务非常重要。十一项国际贸易术语解释通则涵盖了国际运输。您知道所有不同的选择吗？
            Crane Worldwide Logistics
            团队了解每种可能的国际贸易术语解释通则的多样性和复杂性，我们的团队随时帮助您为每种负载选择合适的术语。</p>
          <p class="gt-block"><a href="/quotation"><strong>请求报价</strong></a>
            从今天开始，克瑞环球物流就开始了。&nbsp;</p>
          <hr>
          <p>对于所有国际贸易术语，了解买卖双方的义务很重要。 有 XNUMX 个国际贸易术语涵盖国际运输，您知道所有不同的选择吗？
            如果您需要运输支持，请联系团队！</p>
          <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
            XNUMX 个 incoterms 的简单解释 <strong><a href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong>
          </p></blockquote>`
    },
    {
      id: '2',
      title: 'CFR 成本和运费 - Incoterms®',
      desc: 'CFR - Cost and Freight Incoterm 是 FOB 之后最常用的 Incoterm 之一',
      detail: ` <h1>CFR - 成本加运费 - Incoterms<strong>®</strong></h1>
      <p class="gt-block"><strong>CFR - 成本加运费</strong>&nbsp;- 使用 CFR Incoterm，卖方承担运往指定目的港或地点的运费。
        货物一装上船，灭失或损坏的风险就转移了。 然而，主要运输由卖方承担，包括合同义务。&nbsp;</p>
      <p><img alt="CFR 成本和运费 Incoterms 图片"
              src="https://www.craneww.com/site/assets/files/3194/cww_incoterms_cfr.1352x0-is.jpg" width="1352"></p>
      <p>注：本 Incoterms 规则的使用仅限于海运或内河运输的货物。</p>
      <blockquote><p class="gt-block"><strong>您知道吗？&nbsp; </strong>CFR - Cost and Freight Incoterm 是 FCA - Free
        Carrier 之后最常用的 Incoterm 之一</p></blockquote>
      <p>对于所有国际贸易术语，了解买卖双方的责任和义务很重要。 有 XNUMX 个国际贸易术语涵盖国际运输，您知道所有不同的选择吗？
        如果您需要发货支持，请联系团队！</p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong></p></blockquote>`
    },
    {
      id: '3',
      title: 'CIF 成本、保险和运费 - Incoterms®',
      desc: 'CIF Incoterms：卖方承担到指定目的港或地点的保险和运费。',
      detail: ` <h1>到岸价国际贸易术语<strong>®&nbsp;</strong>- 成本，保险费加运费&nbsp;</h1>
      <p class="gt-block"><strong>CIF Incoterms - 成本、保险和运费</strong>&nbsp;- CIF 运输术语的含义是什么？ 使用
        Incoterms 规则 CIF，卖方承担到指定目的港或地点的保险费和运费。</p>
      <p>货物一装上船，即装上船，风险就转移了。 卖方必须以买方的名义购买符合协会货运条款 (C)
        的最低保险范围，以防损坏或丢失。</p>
      <p><img alt="成本、保险和运费 (CIF) Incoterms 图片"
              src="https://www.craneww.com/site/assets/files/3195/cww_incoterms_cif.1352x0-is.jpg" width="1352"></p>
      <p>注意：CIF Incoterm 规则的使用仅限于海运或内河运输的货物。</p>
      <p>对于所有国际贸易术语，了解买卖双方的责任和义务非常重要。 涵盖国际货运的国际贸易术语有 XNUMX 种，您知道所有不同的选择吗？
        如果您需要运输支持，请联系我们的团队！</p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们的免费 Incoterms 2020 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong></p></blockquote>
      <h2>有关 CIF 国际贸易术语解释通则的更多信息</h2>
      <p>在全球贸易的广阔水域中航行可能是一段动荡的旅程，尤其是当文化误解和沟通障碍威胁到运输过程时。
        在这些挑战中，国际贸易术语解释通则、CIF（成本、保险和运费）成为了指路明灯。 让我们揭开 CIF
        的各个层面，重点介绍其关键组成部分，并了解如何运用其无与伦比的能力来简化全球海上或水路贸易的复杂性。</p>
      <h3>揭秘 CIF 缩写</h3>
      <p>CIF 由国际商会标准化，是简化贸易的证明。 但它究竟表示什么呢？ CIF 代表成本、保险和运费。
        卖方承担到买方目的港的所有运输费用，以及从最终交货到运输的保险。 不过，它还是有点复杂。</p>
      <p>每个词都代表着支撑CIF大厦的一根柱子：</p>
      <ul>
        <li><strong>成本。</strong> 除了单纯的货币价值之外，CIF 背景下的“成本”还涵盖了货物在海运或水路运输过程中与贸易货物相关的所有费用的本质。
          该组成部分对于交易的盈利能力和财务框架至关重要。
        </li>
        <li><strong>保险和货运</strong>。 CIF的核心是保险和货运两大支柱。 保险确保货物在运输过程中得到保护，而运费则表示运输成本和规划运输需求。
          这确保了货物运输的顺利进行。 在 CIF 下，卖方负责安排装运的各个方面。 这意味着他们安排并支付所有复杂的运输费用，确保货物到达目的地。
        </li>
      </ul>
      <h3>聚焦 CIF 的 Prime 应用</h3>
      <p>虽然用途广泛，但 CIF 在某些影响全球贸易以及责任和货物所有权预期的贸易环境中确实表现出色。 其中包括以下内容：</p>
      <ul>
        <li><strong>跨境交流。</strong> 根据CIF协议，卖方承担费用、保险和运费，直到货物在选定的目的港转移给买方为止，但买方在将此类货物装载到船上时承担责任。&nbsp;
        </li>
        <li><strong>优质商品运动。</strong> 对于奢侈品或易碎物品，CIF 是无价的。
          其固有的保险成分在运输过程中提供无与伦比的保护，对于高价值货物尤其重要，并且即使在买方承担责任后也能降低保护资产的成本。&nbsp;
        </li>
      </ul>
      <h3>CIF 驱动贸易的方方面面</h3>
      <p>CIF 提供了一些对买家和卖家都有用的额外好处，包括：</p>
      <ul>
        <li><strong>清晰的贸易蓝图。</strong> CIF 提供了一个明确的框架，确保买家和卖家了解他们的角色和责任。
          这减少了潜在的误解并简化了国际交易，包括哪些政策将涵盖索赔损失和组织下游运输的责任。&nbsp;
        </li>
        <li><strong>买家之盾。 </strong>保险是 CIF 的核心组成部分，可防止潜在的运输损坏。 风险只有在货物到达目的港后才转移。
        </li>
        <li><strong>轻松的运输动态。</strong> CIF 下卖方的责任不仅仅是成本。 他们负责支付到达买方目的港的所有相关运输费用，使买方的整个过程更加顺利。
        </li>
        <li><strong>买家的经济杠杆。</strong> 买方经常发现自己处于有利的经济地位，因为卖方根据 CIF 支付各个方面的费用。
        </li>
      </ul>
      <h3>CIF 范式中的潜在问题</h3>
      <p>尽管 CIF 有很多好处，但它也面临着挑战。 了解这些问题对于制定一个流程来了解该国际贸易术语解释通则是否适合您的货运标准至关重要。
        以下是它的一些缺点。&nbsp;</p>
      <ul>
        <li><strong>买方对运输的监督减弱。</strong> 委托卖家进行运输管理有时可能会导致不可预见的挑战和延误。</li>
        <li><strong>驾驭文化动态。 </strong>全球贸易的大熔炉有时会酿成误解，尤其是在 CIF 交易中。 意识和开放的沟通可以缓解此类问题。
        </li>
        <li><strong>信任的平衡行为。</strong> 依赖卖方提供通过目的地港口交货的所有物流意味着对其能力的极大信任。
          这强调了选择经验丰富且可靠的卖家的重要性。
        </li>
        <li><strong>集装箱货物的风险。</strong> &nbsp;CIF 通常最适合超大、超重或散装货物，但对于集装箱货物，运费和保险费付
          (CIP) 的规定更为严格。&nbsp;
        </li>
      </ul>
      <h3>掌握贸易的 CIF 蓝图</h3>
      <p>掌握 CIF 可确保企业不仅是全球贸易的参与者，而且是全球贸易的领导者。 CIF
        强调相互理解，为国际交易的透明度铺平了道路，确保全球贸易保持节奏，而不会受到文化或沟通障碍的影响。&nbsp;</p>
      <p>根据 CIF 规定，卖方还需承担以下责任：</p>
      <ul>
        <li>购买产品的出口许可证。</li>
        <li>出口货物的包装费用。</li>
        <li>清关费、关税和税金（出口）。</li>
      </ul>
      <p>同时，买方还应对以下事项承担额外责任：</p>
      <ul>
        <li>在目的港码头卸货。</li>
        <li>将产品从码头内转移至内陆交货地点。</li>
        <li>与进口货物相关的关税费用。</li>
        <li>运输、卸货以及将货物运送至最终目的地的费用。</li>
      </ul>
      <h3>让克瑞环球物流成为您的 CIF 导航器</h3>
      <p>成本、保险加运费 (CIF) 不仅仅是一个缩写词；它是一个术语。 它是高效、透明和繁荣的全球贸易的语言。 有了对 CIF
        的了解，企业就可以穿越复杂的国际水上交易路径，促进不仅有利可图而且持久的合作。</p>
      <p class="gt-block">在错综复杂的全球贸易中，熟练的合作伙伴可以将挑战转化为机遇。 <a href="/">Crane Worldwide
        Logistics</a> 作为合作伙伴，我们承诺提供专业知识和无与伦比的托管服务，指导企业完成 CIF 旅程，特别是来自 <a
          href="/industry?type=tech">高科技</a> 或高价值行业。&nbsp;<br>&nbsp;</p>`,
    },
    {
      id: '4',
      title: 'EXW 出厂 - Incoterms®',
      desc: '使用 Ex-works (EXW) Incoterm，卖方承担的责任最小。 货物必须提供并妥善包装，并在指定地点提供。',
      detail: `<h1>国际贸易术语<strong>®&nbsp;</strong>EXW - 出厂&nbsp;</h1>
      <p>使用工厂交货 (EXW)
        国际贸易术语解释通则是卖方责任最低的国际贸易术语解释通则之一。基本前提意味着卖方负责在卖方场所包装货物并提供货物。但这到底意味着什么？今天的托运人如何更好地理解这个术语？</p>
      <h2>EXW 运输条款对责任意味着什么？</h2>
      <p>使用 EXW 运输术语，卖方在指定区域（如生产场地或仓库）向买方提供货物。买方承担从那里到目的地的全部风险和费用 -
        包括货物的装载，并负责所有运输。此外，在买方收到货物的那一刻，卖方就免除了对货物的所有责任。&nbsp;</p>
      <p>然而，这并不意味着卖家可以三心二意地尝试跟进发货。毕竟，风险是由买方承担的，但如果由于卖方包装或装卸方面的疏忽而导致货物损坏，卖方仍可能有过错并需承担经济赔偿。&nbsp;</p>
      <p>
        国际贸易可能很复杂，运输条款也很复杂；确保您使用正确的贸易术语以最大限度地降低风险。如果卖方需要采取额外步骤，例如备案处理出口清关或安排运输，则这不是该交易的正确国际贸易术语解释通则。请记住，卖方没有义务提供任何进一步的要求，仅负责确保货物已包装好并可在其场所内使用。&nbsp;</p>
      <p><img alt="图表显示 Incoterms 出厂价"
              src="https://www.craneww.com/site/assets/files/3168/cww_incoterms_exw.1352x0-is.jpg" width="1352"></p>
      <h2>使用工厂交货术语的优点和缺点</h2>
      <p>
        在国际运输中使用工厂交货国际贸易术语解释通则对于卖方来说有明显的好处。在这种情况下，卖方的责任微乎其微。货物必须可供使用并适当包装，并可在指定地点使用。</p>
      <p>
        因此，买方承担大部分责任，有义务装载货物、遵守出口程序/出口许可证、管理运输成本，并解决收集货物、清关和交付货物方面的任何相关职责或需求。确定谁承担装载过程中损失或损坏的风险/责任非常重要。</p>
      <p>尽管这听起来像是卖家的理想解决方案，但该术语对买家来说有一些核心好处，包括：</p>
      <ul>
        <li>加大成本控制力度。</li>
        <li>选择承运人更加灵活。&nbsp;</li>
        <li>能够更好地协调下游或进口程序。&nbsp;</li>
      </ul>
      <p>该术语也给买方带来了一些缺点，包括：</p>
      <ul>
        <li>责任和成本增加。&nbsp;</li>
        <li>沟通不畅的风险。&nbsp;</li>
        <li>处理出口要求时出错的可能性更大。&nbsp;</li>
      </ul>
      <p class="gt-block">当然，还有另一个因素需要考虑，可能与这句格言类似：他或她内心的善良。&nbsp;<br>从技术上讲，卖方不需要按照买方指定的运输方式装载货物，但如果买方选择，可以这样做。卖方的唯一要求是在选定的地点提供产品，买方有责任支付运输费用。因此，尽管使用了本国际贸易术语解释通则，卖方仍可能装载一些负载，例如那些需要高级工程和规划技能来绑扎或固定的负载。&nbsp;
      </p>
      <h2>通过与 Crane Worldwide Logistics 合作，了解何时使用 EXW 或其他国际贸易术语解释通则</h2>
      <p class="gt-block">对于所有国际贸易术语解释通则，了解买方和卖方的义务非常重要。有 11
        种国际贸易术语解释通则涵盖国际货运，您是否了解所有不同的选项？如果您需要运输支持，免费上船和免费承运人可能会对您的运输过程感兴趣。无论如何，我们的团队可以帮助您确保在每次发货时都使用正确的国际贸易术语解释通则。
        <a href="/quotation">向 Crane Worldwide Logistics 索取报价以开始使用。&nbsp;</a></p>
`,
    },
    {
      id: '5',
      title: 'FCA 自由承运人 - Incoterms® ',
      desc: '使用运输术语 Free Carrier (FCA)，卖方必须负责出口清关和运送到指定地点。',
      detail: ` <h1>国际贸易术语<strong>®&nbsp;</strong>FCA - 自由载流子&nbsp;</h1>
      <p>在所有可能的国际贸易术语解释通则中，对于希望将大部分责任交由卖方承担的托运人来说，使用货代承运人或 FCA 是首要任务。
        但 FCA Incoterm 的具体含义是什么？使用 FCA 或 Free Carrier 含义如何帮助各方满足其需求？
        该主题可能特别令人困惑，因为有些标准似乎表明这是理想的国际贸易术语解释通则，但它可能无法完全满足买方的需求。&nbsp;</p>
      <p>让我们仔细看看基本定义、它对买方和卖方的风险和影响、它的一些实际应用，以及它与一些更广泛的国际贸易术语解释通则的比较。&nbsp;</p>
      <h2>FCA 或自由承运人是什么意思？</h2>
      <p>根据 FCA 或 Free Carrier Incoterm，卖方负责将货物运送至指定地点。 通常，指定地点是多式联运或超出始发国的运输之前的码头或仓库。&nbsp;</p>
      <p>根据货交承运人 (FCA) 国际贸易术语解释通则，卖方的责任对于确保交易顺利进行直至买方接管至关重要。
        卖方的义务可分为几个关键领域：</p>
      <h3>FCA 的影响：文件和商业发票</h3>
      <p>卖方的任务是提供所有必要的文件，包括促进货物出口所需的提单和贸易条款。 这包括获取和准备反映买方和卖方之间协议的商业发票。
        商业发票是清关和付款流程的关键文件。 它必须准确详细说明所售商品、销售条款以及与交易相关的其他协议。</p>
      <h3>FCA 影响：出口包装和处理</h3>
      <p>卖方必须确保货物正确包装以供出口。 这涉及选择能够承受严酷运输并保护货物免受损坏的适当包装。
        包装还应符合买方的规格和出口国的任何法律要求。</p>
      <h3>FCA 影响：出口清关</h3>
      <p>根据 FCA 条款，卖方最重要的责任之一是管理出口清关。
        这意味着卖方必须满足从原产国合法出口货物的所有官僚要求，包括获得任何出口许可证或许可证。</p>
      <h3>FCA 含义：交付至指定地点</h3>
      <p>卖方负责将货物运送至与买方约定的指定地点。 该位置通常是码头或仓库，但也可以是承运人运营的任何地方。
        当货物在指定地点移交给承运人或买方指定的其他人时，即视为交货完成。 该指定地点也可以是卖方在出口码头或其他目的地的经营场所。&nbsp;</p>
      <p class="gt-block">无论如何，FCA 意味着卖方将货物运送到某个地方 <strong>出口前</strong>，从技术上讲，责任将从卖方转移到买方。
        但可能会出现一些混乱和争论，因为模式之间的转换（如果发生在同一国家/地区）仍然可能涉及 FCA。 但如何呢？</p>
      <p><img alt="描述 Incoterm FCA 职责的图表"
              src="https://www.craneww.com/site/assets/files/3169/cww_incoterms_fca.1352x0-is.jpg" width="1352"></p>
      <h2>使用 FCA 或免费承运人条款时谁承担什么责任？&nbsp;</h2>
      <p>使用运输术语“Free Carrier (FCA)”，卖方必须负责出口清关。 此外，使用FCA运输术语，卖方还负责在指定地点将货物交付给承运人，这就是责任和风险开始影响对话的地方。&nbsp;</p>
      <p>FCA 运输条款下的买方需承担多项核心费用和责任或义务：</p>
      <ul>
        <li><strong>装载费和运输。 </strong>货物交付给承运人后，买方承担所有费用和风险。 这包括装载费用、主要运输费用和后续运输费用。
        </li>
        <li><strong>卸货和转发。</strong> 主运输结束后，买方负责卸货以及将货物运送至最终目的地所需的任何转运流程。</li>
        <li><strong>进口清关。</strong> 买方必须办理进口清关，确保所有货物符合目的地国家的规定，并支付所有关税和税款。&nbsp;
        </li>
      </ul>
      <h2>哪些模式可以适用FCA自由承运人国际贸易术语解释通则？</h2>
      <p>对于 FCA Incoterm 的使用没有硬性规定。 它可以在所有模式中使用，只要它管理在原籍国境内发生的移动。
        但在所有举措中，它最常应用于集装箱海运。&nbsp;</p>
      <blockquote><p class="gt-block"><strong>您知道吗？</strong> 使用 FCA
        运输条款，卖方除了办理出口报关手续外，还负责在卖方的营业地点为指定交货地点时装载货物，除非双方达成了不同的决定。</p>
      </blockquote>
      <h2>FCA 是适合您负载的国际贸易术语解释通则吗？</h2>
      <p>这是一个负载性的问题，请原谅双关语。 让我们对比两个例子，以更好地展示当使用不同的国际贸易术语解释通则“运费付至”(CPT)
        时，责任如何进一步向更远距离的卖方转移。&nbsp;</p>
      <p>根据 CPT Incoterm，卖方支付将货物运至目的地的运费。 然而，一旦货物移交给第一承运人，风险就转移给买方。
        该术语可能更适合那些希望卖方管理复杂运输的买家，特别是在不熟悉的路线或市场。
        此外，该国际贸易术语解释通则可以跨越国家/地区，并且在货物运往目的地国家/地区配送中心的中间甚至最后一英里之前，可能不会涉及到“第一承运人”的转移。&nbsp;</p>
      <p>例如，进口货物的小企业可能会选择 CPT 来简化他们在运输过程中的参与，依靠卖方的专业知识来管理到目的地的运输。
        与FCA不同的是，指定地点比出口前的指定目的地要远得多，因此买方的风险较小。 但如果买方想承担管理进口流程和多式联运管理的责任，使用
        CPT 可能比 FCA 更合适。&nbsp;</p>
      <h2>与 Crane Worldwide Logistics 合作，获得 FCA 和所有国际贸易术语解释通则使用方面的专家。&nbsp;</h2>
      <p>对于所有国际贸易术语解释通则，了解买方和卖方的义务非常重要。 有 XNUMX 种国际贸易术语解释通则涵盖国际运输，您了解所有不同的术语吗？&nbsp;</p>
      <p class="gt-block"><strong><a
          href="/quotation">立即与国际贸易术语解释通则专家联系！</a></strong></p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong></p></blockquote>`,
    },
    {
      id: '6',
      title: 'CPT 运费付至 - Incoterms®',
      desc: '使用 Incoterm CPT，卖方负责到目的地指定地点的运输和费用。 ',
      detail: `<h1>CPT - 运费付至 - Incoterms<strong>®</strong></h1>
      <p>与其他几种常见的国际贸易术语解释通则不同，例如成本、保险和运费 (CIF)，运输至对卖方承担了更大的责任。 但运费付至
        (CPT) 的含义是什么？它对全球贸易有何影响？</p>
      <p><img alt="CPT Incoterm 信息图"
              src="https://www.craneww.com/site/assets/files/3170/cww_incoterms_cpt.1352x0-is.jpg" width="1352"></p>
      <p>&nbsp;</p>
      <p>这意味着卖方承担所有风险，包括潜在的损失，直到货物安全地到达指定方手中。 承运人可以是负责货物运输的任何实体，无论是海运、铁路、公路还是空运。&nbsp;</p>
      <p>值得注意的是，CPT 合同条款的运费中可能包含码头装卸费 (THC)。 让我们仔细看看何时使用
        CPT、它的优点和缺点以及它对改进运输管理的总体影响。</p>
      <blockquote><p class="gt-block"><strong>您知道吗？ </strong>当使用多个承运人时，风险和成本在交付给第一个承运人时转移给买方。
      </p></blockquote>
      <h2>何时使用CPT</h2>
      <p>CPT对于想要降低运输风险的买家来说是理想的选择。 由于卖方承担货物移交给第一承运人之前的所有责任，因此买方在此阶段免受潜在的损坏或损失。
        此外，CPT 对于不愿处理出口要求和相关费用的买家来说是有利的，因为卖家会处理这些方面的问题。</p>
      <p>虽然 CPT 具有多种优势，但它并不适合所有场景。 例如，如果买家有特定的保险要求或需要对运输过程进行更多控制，CPT
        可能不是最佳选择。&nbsp;</p>
      <h2>CPT 的优点和缺点</h2>
      <p>在合同中使用 CPT 大大减少了责任和成本责任的混乱，但它还带来了托运人应该知道的额外好处：</p>
      <p>卖方处理出口要求和相关费用。</p>
      <p>它简化了购买流程，特别是对于不熟悉出口法规的国际买家而言。</p>
      <p class="gt-block">如果买方能够获得更便宜的运费，CPT 可能不是最具成本效益的选择。对于那些在高利基行业运营的企业来说尤其如此，例如&nbsp;<a
          href="/industry?type=car">汽车</a> 甚至 <a
          href="/industry?type=aerospace">航天</a>.&nbsp;</p>
      <p>由于买方在货物移交给第一承运人后才承担责任，因此责任的转移可能会令人困惑。 这是一个例子。&nbsp;</p>
      <p>假设买方已安排跨越多个边界和单一水路的运输。
        如果此过程使用同一承运人，即使在技术上切换模式，卖方仍然承担责任和成本责任。</p>
      <p>但是，如果承运人中途更换，则此时买方承担责任。 同时，双方都有责任就买方“收到”货物的时间点达成一致。
        因此，如果双方都同意在此过程的后期进行破产管理，则该国际贸易术语解释通则并不真正正确。</p>
      <p>相反，一个不同的术语“现场交付”(DAP) 更为合适。 显然，在很多情况下，任何国际贸易术语解释通则的规范都可能被操纵，以包含特定术语中未标准化的一定程度的责任。
        因此，与运输管理专家合作以确保在每种情况下使用正确的术语至关重要。&nbsp;</p>
      <h2>CPT 何时适合负载的示例</h2>
      <p>考虑这样一个场景：德国的一家企业从日本的供应商那里购买特种设备。</p>
      <p>买方不熟悉日本出口法规，并担心海运过程中可能造成的损坏。</p>
      <p>卖方拥有丰富的运输此类设备的经验，可以办理所有出口手续，并确保安全交付给第一家承运人（东京的一家运输公司）。</p>
      <p>考虑到买家的顾虑以及对日本出口流程的不熟悉，选择CPT是正确的选择，既保证了交易的顺利进行，又降低了风险。
        但如果买方希望买方负责货物到达目的港后运输到另一地点，则可能需要DAP或附加的Incoterms。</p>
      <h2>通过与 Crane Worldwide Logistics 合作获得正确的合同条款</h2>
      <p>运费付至是一种多功能的国际贸易术语解释通则，可带来诸多好处，特别是对于希望降低运输风险并避免复杂的出口程序的买家而言。
        虽然它在许多情况下都是一个很好的选择，但对于买家和卖家来说，在选择 CPT
        之前评估他们的具体需求、潜在成本以及所运输货物的性质至关重要。</p>
      <p class="gt-block">与所有国际贸易术语解释通则一样，了解 CPT 的复杂性对于在国际贸易中做出明智的决策至关重要。
        克瑞环球物流可以帮助实现这一目标。 <a href="/quotation">索取报价，立即开始。&nbsp;</a>
      </p>
      <p>对于所有国际贸易术语，了解买卖双方的义务很重要。 有 XNUMX 个国际贸易术语涵盖国际运输，您知道所有不同的选择吗？</p>
      <p class="gt-block">Crane Worldwide Logistics 已准备好全面概述您需要了解的有关 Incoterms
        的所有信息<strong>®</strong> 2020 年运输规则以及免费的国际贸易术语培训视频
      </p>
      <p>如果您需要运输支持，请联系团队！</p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranemarketing.microsoftcrmportals.com/cwwincoterms2020matrix/">这里。</a></strong></p>
      </blockquote>
`,
    },
    {
      id: '7',
      title: 'CIP 运费和保险费支付至 - Incoterms® ',
      desc: '使用 CIP Incoterm，卖方负责运输费用以及所有风险保险。',
      detail: `<h1>国际贸易术语<strong>®&nbsp;</strong>CIP - 运费和保险费付至&nbsp;</h1>
      <p class="gt-block"><strong>Incoterms® CIP - 运费和保险费支付给</strong>&nbsp;- CIP 运输术语的含义是什么？ 在 CIP
        Incoterm 中，卖方代表买方安排运输、费用和保险到目的地的指定地点。</p>
      <p>根据 Incoterms 2020 CIP 条款，一旦交付给第一家承运人，风险就会转移给买方。 卖方有义务以买方的名义购买符合保险货物条款
        (A) 或类似条款的广泛保险。 检查保险水平并调查是否需要额外保险非常重要。 卖方还支付保险费。</p>
      <p><img alt="" src="https://www.craneww.com/site/assets/files/3187/cww_incoterms_cip.1352x0-is.jpg" width="1352">
      </p>
      <p class="gt-block">卖方负责运输费用 <strong>以及</strong> 全险保障。
        如果您是卖家，为货物投保不是一个不容忽视的项目，检查您的最低保险和保险水平很重要，可能需要额外的保险。 与 Incoterm
        CPT 一样，货物交付发生，风险从卖方转移到买方，货物由承运人负责。 从那时起，无论运输方式如何，买方都应负责。&nbsp;</p>
      <h2>您知道出口的国际运输条款吗？</h2>
      <p>对于所有国际贸易术语，了解买卖双方的义务很重要。 有 2020 种国际贸易术语涵盖国际货运，您是否了解所有不同的选项和
        XNUMX 年国际贸易术语解释通则规则？ 国际贸易条款可能很复杂，如果您需要运输支持，请联系我们的团队！</p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong></p></blockquote>`,
    },
    {
      id: '8',
      title: 'DAP 就地交付 - Incoterms® ',
      desc: 'DAP Incoterm：买方仅负责进口货物和到达指定目的地后卸货的费用。',
      detail: `<h1>国际贸易术语<strong>®&nbsp;</strong>DAP - 现场交付&nbsp;</h1>
      <p class="gt-block"><strong>Incoterms® DAP - 就地交付</strong>&nbsp;- 通过 DAP Incoterm，卖方将货物运送到约定的目的地。
        卖方承担所有风险和费用，直到货物准备好在目的地指定地点卸货为止。 但为什么有必要以及托运人如何更好地理解其细微差别？&nbsp;<img
            alt="DAP 就地交付" src="https://www.craneww.com/site/assets/files/3189/cww_incoterms_dap.1352x0-is.jpg"
            width="1352"></p>
      <p>国际贸易受到文化期望差异和许多潜在障碍的影响。 国际贸易术语解释通则由国际商会 (ICC)
        创建，旨在保持标准到位，以确保清晰、简洁地理解处理国际货运的责任和义务。&nbsp;</p>
      <p>现场交付 (DAP) 就是这些术语之一，它的含义很简单。 然而，对于新托运人或刚刚进入国际贸易领域的托运人来说，可能很难了解其优点和缺点以及何时最好使用它。&nbsp;</p>
      <h2>Incoterm DAP 的真正含义是什么？</h2>
      <p>DAP
        国际贸易术语解释通则，即“地点交货”，是一种运输术语，其中卖方将货物交付至约定的目的地，这意味着卖方负责在交货后将货物从始发地运至约定的交货点。目的地的运输活动。</p>
      <p>换句话说，卖方承担所有风险和费用，直到货物准备好在指定交货地点卸货为止。</p>
      <p>卖方负责包装、文件、出口审批、装载费用以及最终交付到约定的目的地，虽然卖方承担此时的所有成本和责任，但销售合同可能会因使用不同的条款而再次变得混乱。
        然而，运输合同中的 DAP 条款可能有点令人困惑，特别是当一方不完全理解何时不同的国际贸易术语可能更合适时。&nbsp;</p>
      <p>不管怎样，DAP的含义仍然是一样的——在陆运后将货物运至指定目的地，并处理到达该地点的各种运输方式。
        但这种特殊性也是许多买家在进行国际贸易时更喜欢 DAP 货运条款的原因。 让我们通过探讨 DAP 交付条款的优势来更深入地了解原因。&nbsp;</p>
      <h2>使用 DAP 的优点</h2>
      <p>选择 DAP 可以是一项战略举措，可以提供一系列优势，主要是针对买家。
        对于所有相关方来说，掌握该国际贸易术语解释通则的内在好处对于更有效地驾驭国际贸易并培养积极的业务关系至关重要。</p>
      <ol>
        <li><strong>角色分配的简单性。</strong> 与 CIF 或 CPT 不同，DAP 在到达目的地后将卖方的责任进一步延伸至内陆地区。
          DAP 在定义角色方面提供的清晰度可以最大限度地减少混乱并有助于避免冲突，使交易更加顺利和直接。
        </li>
        <li><strong>卖方对运输的监督。</strong> 当卖方管理运输时，通常会加强护理并降低货物损坏的风险，确保货物以最佳状态到达买方手中。
          这对于高价值货物或需要高级护理或广泛制造的货物尤其有用，例如卖方用于处理超大设备的私人海运码头。&nbsp;
        </li>
        <li><strong>买家的经济效率。</strong> 买家通常会发现经济上的缓解，因为他们不再承受物流和运输成本的负担，从而可以专注于业务的其他方面。
          此外，他们可以更好地优先考虑其运营国家/地区的运输，这意味着他们更有可能拥有更好的关系，并可能降低从海关设施到独立进口商设施的运输成本。
          从某种意义上说，他们将唯一真正的最后一英里运送到他们的营业地点，其余的则由卖家安排。&nbsp;
        </li>
      </ol>
      <h2>DAP 运输限额是多少？&nbsp;</h2>
      <p>虽然 DAP 可以简化国际贸易的许多方面，但它也带来了一些挑战，主要影响卖家。 虽然买家享受 DAP
        的好处，但也可能存在一些问题。</p>
      <p>例如，如果买方希望更早地控制货物，例如在目的地港口进入某个国家/地区，则应使用不同的国际贸易术语解释通则。
        从某种意义上说，买方并不能真正控制最终目的地的流程（对于此特定交易并且假设货物不经过海关）。&nbsp;</p>
      <p>无论如何，对这些挑战的认识和深思熟虑对于卖家确定 DAP 是否符合其战略和运营目标至关重要。 以下是在使用运输术语 DAP
        之前需要考虑的其他一些潜在问题。&nbsp;</p>
      <ul>
        <li><strong>卖家负担增加。</strong> 卖家发现自己在交货点之前承担着巨大的责任并承担着巨大的风险，因此需要细致的管理和风险缓解策略。
          另外，了解进口国的所有法规和要求的负担由卖方承担，而且由于卖方负责卸货，因此完全有可能导致更高的成本。
          还有一点需要注意的是，这仅适用于有自由贸易区过境的地区。 请记住，如果买家必须承担处理海关的费用，但不支付海关费用，则会切换到未完税交货
          (DDU) 交易。
        </li>
        <li><strong>对卖家的成本影响。</strong> 涵盖范围广泛的责任可能会导致卖家成本增加，需要对财务影响进行彻底评估并部署具有成本效益的解决方案。
          对于通常不在目的地国家/地区开展业务的卖方来说，他们最终可能会支付比买方能够获得的更高的到买方海关设施的运输费用。
          然而，销售合同还可以规定额外的含义是否可以减轻这种负担，例如使用DDU，或&nbsp;
        </li>
        <li><strong>买方的影响力有限</strong>。 买家对运输过程的控制受到限制，要求进行精确的沟通并就期望达成一致，以防止任何潜在的不满意或偏差。
          然而，这对卖家来说也是一把双刃剑，因为他们必须格外小心，以确保在预定地点的整个交付过程中不辜负这样的期望。&nbsp;
        </li>
      </ul>
      <h2>DAP 使用的理想场景</h2>
      <p>当买方更喜欢或要求卖方管理货物运输时，例如当买方缺乏监督运输过程所需的资源或专业知识时，DAP 最合适。
        当卖家能够获得更好的运输资源或实现更具成本效益的运输解决方案时，这也是理想的选择。
        与所有国际贸易术语解释通则一样，这取决于您认识的人以及最具成本效益的运输解决方案。</p>
      <p class="gt-block">考虑这样一个场景：瑞典的一家家具制造商正在向瑞典的零售商销售桌子。 美国。 卖方可以更好地获取跨大西洋贸易的运输资源和专业知识，因此可以使用
        DAP Incoterm 将桌子运送到零售商在美国的指定海关地点。 卖方管理并承担运输费用和风险，直到桌子准备好在美国入境口岸以外的目的地卸货但在通过海关之前。
      </p>
      <h2>选择 Crane Worldwide Logistics 在处理国际贸易时充分利用 DAP</h2>
      <p class="gt-block">使用任何国际贸易术语解释通则（包括 DAP）时，了解买方和卖方的义务至关重要。
        使用国际贸易术语解释通则的失误可能会导致您的成本出现亏损。 然而，Crane Worldwide Logistics
        可以帮助您确保遵循正确的道路并选择国际贸易术语解释通则，以便在每笔交易中发挥最佳作用。&nbsp;<br>国际贸易术语解释通则有
        XNUMX 种，涵盖国际运输，每种都满足不同的需求和场景。 如果您需要运输支持或对适合您的交易的国际贸易术语解释通则有任何疑问，请联系我们的团队！
      </p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong></p></blockquote>
`,
    },
    {
      id: '9',
      title: 'DPU 在卸货地点交付 - Incoterms® ',
      desc: 'Incoterm DPU 的正式名称为 DAT，意思是“在终端交付”',
      detail: `  <h1>DPU - 卸货地点交货 - Incoterms<strong>®</strong></h1>
      <p class="gt-block"><strong>Incoterm DPU - 卸货地点交货</strong> - DPU 是什么意思？ 根据 DPU
        Incoterm，卖方承担所有费用和风险，直到货物在约定的指定目的地卸货为止。 在这种情况下，买方负责办理进口报关手续。</p>
      <p><img alt="交付到地方卸载 Incoterm 图表"
              src="https://www.craneww.com/site/assets/files/3190/cww_incoterms_dpu.1352x0-is.jpg" width="1352"></p>
      <p>DPU 可适用于任何运输方式或多种运输方式。 买方和卖方应指定并商定指定的目的地。</p>
      <blockquote><p class="gt-block"><strong>您知道吗？ </strong>Incoterm DPU“Delivered at Place Unloaded”在 2020
        版本发布之前正式称为 DAT，意思是“Delivered at Terminal”。&nbsp;</p></blockquote>
      <p>对于所有国际贸易术语，了解买卖双方的义务很重要。 有 XNUMX 个国际贸易术语涵盖国际运输，您知道所有不同的选择吗？
        如果您需要运输支持，请联系团队！</p>
      <blockquote><p class="gt-block"><strong>免费下载：</strong> 您可以下载我们免费的 Incoterms 图表，该图表提供了所有
        XNUMX 个 incoterms 的简单解释 <strong><a
            href="https://cranewwmktg.powerappsportals.com/cwwincotermsmatrix">这里。</a></strong></p></blockquote>`,
    },
    {
      id: '10',
      title: 'DDP - 完税后交货 - Incoterms® ',
      desc: '使用 Incoterm DDP 完税交货规则，卖方承担所有费用。',
      detail: `<h1>国际贸易术语<strong>®&nbsp;</strong>DDP - 已完税的交货&nbsp;</h1><p class="gt-block"><strong>Incoterms DDP - 已完税交货</strong>&nbsp;- DDP，完税交货运输术语的含义是什么？ 使用 DDP Incoterm 规则意味着卖方将货物交付到约定的地点目的地。 使用 DDP Incoterm 规则，卖方承担所有费用 - 包括进口手续和风险，直到货物准备好在指定目的地卸货。&nbsp;&nbsp;</p><p><img alt="DDP 完税交货 Incoterms 图表" src="https://www.craneww.com/site/assets/files/3191/cww_incoterms_ddp.1352x0-is.jpg" width="1352"></p><p>在某些国家/地区，进口清关程序可能很复杂，因此如果卖家不习惯当地法规，这可能会给卖家带来问题。&nbsp;</p><blockquote><p class="gt-block"><strong>您知道吗？ </strong>DDP Incoterm 规则是唯一一项规定卖方有义务进行进口清关和纳税和/或进口关税的规则。</p></blockquote><h2>您知道出口的国际运输条款吗？</h2><p>对于所有国际贸易术语，了解买卖双方的义务很重要。 有 XNUMX 个国际贸易术语涵盖国际运输，您知道所有不同的选择吗？ 如果您需要运输支持，请联系团队！</p>`,
    },
    {
      id: '11',
      title: 'FAS 随船免费 - Incoterms® ',
      desc: 'FAS - 本 Incoterms 规则的使用仅限于海运或内陆水路运输的货物。',
      detail: `<h1>FAS - 随船免费 - Incoterms<strong>®</strong></h1>
      <p>在不断发展的全球贸易格局中，了解特定的运输条款和国际贸易术语解释通则对于买家和卖家都至关重要。
        FAS（船边交货）国际贸易术语解释通则是国际航运中的一个关键要素，它在缓解谁负责什么（取决于船舶的进入和责任）的混乱水域方面发挥着重要作用。</p>
      <p>FAS规则解释说，卖方负责将货物运送到船边的港口，这标志着风险和成本责任转移给买方的时间点。让我们深入研究 FAS
        的复杂性，深入了解何时最适合使用该国际贸易术语解释通则及其对全球贸易的影响。</p>
      <p><img alt="随船免费 (FAS) Incoterms 图片"
              src="https://www.craneww.com/site/assets/files/3192/cww_incoterms_fas.1352x0-is.jpg" width="1352"></p>
      <p>注：本 Incoterms 规则的使用仅限于海运或内河运输的货物。</p>
      <blockquote><p class="gt-block"><strong>您知道吗？ </strong>该 Incoterms 规则适用于散装货物，其中卖方可以直接进入船舶。
        一般来说，当集装箱货物交付到码头时，使用 FCA Incoterms 规则。&nbsp;</p></blockquote>
      <h2>何时使用 FAS</h2>
      <p>船边交货 (FAS) 在特定情况下特别有利。最好在以下情况下使用：</p>
      <ul>
        <li>卖方可直接登船装载散装货物。</li>
        <li>货物尺寸过大或难以搬运，最好直接装船。</li>
        <li>买方更愿意控制从港口的运输，管理与港口以外运输相关的成本和风险。</li>
      </ul>
      <p>尽管如此，还有一些利用 FAS Incoterm 的其他理由</p>
      <ul>
        <li>FAS 非常适合卖方可以确保直接沿船交付的运输，从而降低移交的复杂性。</li>
        <li>它提供了清晰的成本分配，卖方负责到船的运输，买方从那里接管。</li>
        <li>由于货物需要随船运输，因此本国际贸易术语解释通则最适合海上或内河运输。</li>
        <li>买方可能还希望确保货物正确装载和装卸到船上，这对于高价值和重型货物尤其重要。</li>
      </ul>
      <h2>FAS 限制结束的地方</h2>
      <p class="gt-block">船边交货 (FAS)
        国际贸易术语解释通则仅限于通过海上或内陆水道运输的货物，例如驳船。这一限制是“船边”一词所固有的，表明货物必须直接在船舶旁边交付。如果货物在到达码头之前必须移交给另一方，则需要使用另一个国际贸易术语解释通则，例如
        <a href="/guideDetail?id=5">FCA（免费运营商）</a>，可能更合适。这确保了交接点的平稳过渡和更清晰的责任划分。
      </p>
      <p class="gt-block">FAS 国际贸易术语解释通则还明确规定了船舶出发前责任和承保范围从卖方到买方的明确转移。&nbsp;<br>虽然卖方负责直至船边交货，但所有后续费用和责任均由买方承担。这种安排对于寻求控制港口以外运输过程的买家来说是理想的选择。但是，如果买方希望承担较少的责任，并且只希望在到达指定地点时承担责任，或者希望卖方承担进口费用，则可以使用替代的国际贸易术语解释通则，例如
        <a href="/guideDetail?id=9">完税后交货
          (DDP)</a> or <a
            href="/guideDetail?id=7">送达地点
          (DAP)</a>，可能更合适。&nbsp;</p>
      <h2>通过 Crane Worldwide Logistics 获取有关 FAS 和所有国际贸易术语解释通则的帮助</h2>
      <p class="gt-block">当我们应对国际贸易的复杂性时，了解卖方和买方在各种国际贸易术语解释通则下的责任和义务至关重要。有
        XNUMX
        种不同的国际贸易术语解释通则涵盖国际货运，感觉有点像字母汤，但知道何时使用每种术语可以让您清晰、安心。&nbsp;<br>Crane
        Worldwide Logistics 在全球贸易方面提供无与伦比的专业知识，帮助各国客户满足其运输需求，并通过在每次装载时使用正确的国际贸易术语解释通则来保持您的货物畅通。
        <strong><a href="/quotation">索取报价</a></strong> 现在开始。&nbsp;<br>&nbsp;</p>`,
    },
  ]
}

export const pressData = {
  list: [
    {
      id: '1',
      time: '2024 年 8 月 20 日',
      title: '3 年南非 2024PL 仓库增长令人振奋',
      desc: '约翰内斯堡新的 3PL 仓库现已在约翰内斯堡开业，我们正在成长，了解我们！',
      detail: ` <h1>约翰内斯堡的新 3PL 仓库&nbsp;</h1>
            <p>克兰全球物流约翰内斯堡分公司正在推进其 2024 年扩张计划，我们很高兴地确认，我们在约翰内斯堡的新仓库现已开放，并有可用空间来在南非提供全套仓库运营服务。&nbsp;</p>
            <p>Crane Worldwide Logistics 已在约翰内斯堡开展业务十余年，在此期间，公司凭借经验丰富的物流团队和不断增长的客户群不断发展壮大。&nbsp;</p>
            <p>约翰内斯堡的新仓库位于肯普顿公园 (Kempton Park) 的 Glen Erasmia 的 Plumbago 商业园区。</p>
            <p class="gt-block"><img alt="" class="align_right"
                                     src="https://www.craneww.com/site/assets/files/3909/microsoftteams-image_71.320x0-is.png"
                                     width="320">波莫纳商业园地理位置优越，距离 <a
                href="https://www.johannesburg-airport.com/">约翰内斯堡奥利弗·坦博国际机场</a>&nbsp;位于比勒陀利亚和奥利弗·坦博机场之间的主要高速公路
              R21 旁。商业区 24 小时监控，现场管理和出入控制。&nbsp;</p>
            <p class="gt-block">Plumbago 商业园内的约翰内斯堡仓库对于公司的持续增长来说是一个令人兴奋的发展 南非。&nbsp;</p>
            <p class="gt-block">拥有全套货运代理和合同 约翰内斯堡的物流能力，我们的团队随时准备为您的本地和国际供应链提供支持。
            </p>
            <div class="card card_size_lg bg_primary-dark">
              <div class="card__body c_white">
                <div class="grid grid_md m_0 align-items_center">
                  <div class="grid__item spacing"><h2 class="h3 c_white">与全球物流专家取得联系</h2>
                    <p class="text_size_lg">立即联系我们，索取报价！</p></div>
                  <div class="grid__item size_auto spacing text_align_center">
                    <div><a class="button button_size_lg button_color_secondary"
                            href="https://craneww.com/request-a-quote/">联系我们</a>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h2>约翰内斯堡新 3PL 仓库的特点：</h2>
            <ul>
              <li>总建筑面积：8 平方米</li>
              <li>办公室总面积：718 平方米</li>
              <li>喷淋泵和水箱</li>
              <li>距屋檐高度13m</li>
              <li>8 x 门（4 x 装卸码头）</li>
              <li><a href="/service?type=contract">定制</a> 根据客户要求&nbsp;
              </li>
            </ul>
            <p class="gt-block">凭借约翰内斯堡的全套货运代理服务，包括海运、空运和公路运输，我们的团队随时准备提出综合解决方案来优化您的供应链。我们的
              <a href="/technology?type=wms">仓库管理系统</a>
              可以为您提供正确的数据，以便有效地管理您的库存。此外，我们的新仓库可以提供增值服务，以协助南非市场的任何临时项目或长期发展计划。&nbsp;
            </p>
            <p>&nbsp;</p>`
    },
    {
      id: '2',
      time: '2024 年 8 月 6 日',
      title: '支持当地草根足球社区',
      desc: '企业赞助对于当地草根俱乐部的成长和繁荣至关重要。',
      detail: ` <h1>克瑞环球物流赞助草根足球俱乐部&nbsp;</h1>
          <p class="gt-block">当地草根足球俱乐部受益于克瑞全球物流推广计划的赞助， 起重机关心
            支持当地社区。&nbsp;</p>
          <hr>
          <p class="gt-block">在伦敦， 英国起重机环球物流公司 最近赞助了 <a
              href="https://afcleyton.co.uk/">亚足联莱顿</a> 在东区。 AFC Leyton 成立于 2015 年，是一家完全独立的女子足球俱乐部，是一家在东伦敦运营的
            FA 认证俱乐部。莱顿足球俱乐部 (AFC Leyton) 成立的初衷是相信参与足球运动能够为女孩和年轻女性带来变革。俱乐部收到的每一分钱都会重新投入到女孩的训练、比赛和其他经历中。
            AFC Leyton 是全国最大的俱乐部之一，拥有数百名女性会员。</p>
          <p><img alt="克瑞环球草根足球衫" class="align_right"
                  src="https://www.craneww.com/site/assets/files/4036/1715956899385.320x0-is.jpg" width="320">克瑞环球物流已同意赞助下赛季
            U13 Wyverns 队，该队最近在最新的联赛决赛中获得第二名。</p>
          <p class="gt-block">还可以购买复制品球衣以继续支持俱乐部， <strong><a
              href="https://afc-leyton.pendlesportswear.co.uk/replica-products/210857-bayern-navy-white/">这里。</a></strong>
          </p>
          <p>
            “得益于最近国际足联女足世界杯的成功以及女狮队的启发，英格兰女子足球运动正在蓬勃发展，全国各地的年轻女孩都受到鼓舞，纷纷加入当地俱乐部。</p>
          <p>AFC 莱顿是支持俱乐部的绝佳选择，它致力于发展这项运动，帮助当地儿童培养信心和技能。由于运营这样一个俱乐部的最终成本很高，克瑞全球物流英国公司很荣幸能够赞助下赛季”，克瑞全球数字营销、传播和公关总监
            Kate Yates 评论道。&nbsp;</p>
          <hr>
          <p class="gt-block"><img alt="" class="align_right"
                                   src="https://www.craneww.com/site/assets/files/4036/aberdeen_logo.320x0-is.png"
                                   width="320">In 香港仔,
            苏格兰, Crane Worldwide 赞助商&nbsp;<a href="https://www.hermesbod.com/">顿河青年足球俱乐部赫尔墨斯桥</a>
            该队成立于 2020 年，此后迅速发展，已有近 300 名球员自豪地穿着黑蓝条纹。</p>
          <p>这些队伍跨越了多个年龄段，从18岁左右的发展队到2019年出生的最年轻的球员，2020年年龄段的比赛即将开始。</p>
          <p>
            “球队要感谢克瑞环球物流为男孩们提供训练上衣的赞助。如今赞助商越来越难获得，因此我们非常感谢这种支持，这意味着男孩们可以以合适的方式出现在比赛中。”</p>
          <hr>
          <p class="gt-block"><img alt="克瑞环球赞助科克女子足球队" class="align_right"
                                   src="https://www.craneww.com/site/assets/files/4036/crane_worldwide_football_team.320x0-is.jpg"
                                   width="320">In <a
              href="/%E5%9C%B0%E7%82%B9/%E7%88%B1%E5%B0%94%E5%85%B0/%E8%BD%AF%E6%9C%A8/">软木</a>, 爱尔兰, Crane
            Worldwide 赞助商 <a href="https://www.avondaleunited.com/">埃文代尔联队</a>是U16女队。&nbsp;</p>
          <p>埃文代尔联足球俱乐部 (Avondale United FC) 拥有约 300
            名会员，我们参加科克男生联赛、科克市及县青年联赛和明斯特高级联赛。该俱乐部还隶属于明斯特足球协会、爱尔兰男学生足球协会和爱尔兰足球协会</p>
          <p>“非常感谢您对埃文代尔的支持，我们努力为社区提供更好的设施并为所有人提供足球”</p>
          <hr>
          <p class="gt-block">除了我们不断增加的赞助俱乐部组合外，我们非常高兴地宣布 Crane Worldwide Logistics Aberdeen
            将赞助 <a href="https://www.longsidefc.org.uk/">朗赛德足球俱乐部</a>。位于朗赛德村的戴维森公园是朗赛德足球俱乐部的主场。场地由泛光灯比赛场和训练场组成。Crane
            Worldwide Logistics 将于 2024 年成为该俱乐部的官方赞助商。</p>
          <p class="gt-block">“作为 <a href="/industry?type=energy">能源</a> 行业在 United Kingdom，我们很高兴能够为阿伯丁当地社区提供支持”，Crane
            Worldwide Logistics 区域客户总监能源解决方案 Jamie Evans 评论道。</p>
          <p><img alt="克瑞全球物流阿伯丁赞助 Longside FC Social Club 标志"
                  src="https://www.craneww.com/site/assets/files/4036/aberdeen_football_sponsorship_crane_ww_pic1_crop_3.1358x0-is.jpg"
                  width="1358"></p>
          <p>&nbsp;</p>`
    },
    {
      id: '3',
      time: '2024 年 6 月 1 日',
      title: '卡尔加里：3PL 物流仓库。现已在加拿大开业',
      desc: '在阿尔伯塔省卡尔加里开设额外的仓库容量。 保持联系！',
      detail: ` <h1>加拿大卡尔加里的 3PL 仓库 - 现已开业！</h1>
      <p class="gt-block"><img alt="卡尔加里仓库" class="align_right"
                               src="https://www.craneww.com/site/assets/files/3921/microsoftteams-image_83.320x0-is.png"
                               width="320">加拿大起重机环球物流公司 在开设了全新仓库 卡尔加里,
        艾伯塔省。&nbsp;</p>
      <p>新仓库位于阿尔伯塔省洛基维尤县工业园的高平原，地理位置优越，为卡尔加里、埃德蒙顿和加拿大西部提供服务。</p>
      <p>Crane Worldwide Logistics 已在该地点租用了 48,000 平方英尺的仓库空间。</p>
      <p>该仓库可轻松前往 2 号高速公路 (QE2)，距离 YYC 机场仅 3 分钟路程，不仅为加拿大国内客户提供服务，还为在卡尔加里地区寻求
        XNUMXPL 服务的国际公司提供服务。&nbsp;</p>
      <p class="gt-block"><a href="https://www.calgaryeconomicdevelopment.com/sectors/energy-environment/">艾伯塔省是加拿大最大的石油和天然气生产国</a>
        也是风能、太阳能、地热等替代能源的重点开发中心。 根据其有机增长轨迹，Crane Worldwide 在客户需要额外货运代理和合同物流业务的地方进行投资。
        卡尔加里的新仓库设施将为加拿大西部工业不断增长的需求提供额外的 3PL 物流能力。</p>
      <p class="gt-block">为 3PL 物流中心的建立 <a href="/industry?type=energy">能源行业</a>，包括其总部
        休斯顿, 香港仔,阿姆斯特丹,迪拜&nbsp;及新加坡卡尔加里的仓库设施将为能源行业参与者的供应链需求提供进一步的支持。以连接卡尔加里与德克萨斯州、俄克拉荷马州和怀俄明州的整合机会为例，卡尔加里仓库和南向卡车运输服务可用于节省成本的举措。&nbsp;
      </p>
      <p>从 OOG 转移到岸基服务，加拿大 Crane Worldwide 的能源物流专家拥有支持该行业内的临时项目和持续运营的经验和能力。
        Crane Worldwide 的物流专家与我们的客户合作，可以提供综合物流解决方案，以满足客户的个性化供应链需求。&nbsp;</p>
      <blockquote><p class="gt-block">如果您想了解更多关于我们的综合物流服务（包括全程货运代理和合同物流服务）的信息，请联系我们
        <strong><a href="/quotation">这里。</a></strong> 我们团队的成员将会回复您。&nbsp;</p>
      </blockquote>`
    },
    {
      id: '4',
      time: '2024 年 5 月 14 日',
      title: '新山地点已加入马来西亚克瑞全球物流网络',
      desc: '继在吉隆坡、槟城和纳闽现有办事处的基础上，在马来西亚新山开设了新办事处。',
      detail: ` <h1>Crane Worldwide Logistics 在马来西亚新山开设新地点</h1>
      <p>
        新山毗邻新加坡，与马来西亚接壤，可轻松抵达新加坡世界一流的港口位置和国际贸易网络。新山之所以成为战略物流运营中心，原因如下：</p>
      <ul>
        <li><strong>基础设施</strong>：新山拥有发达的基础设施，包括两个港口、国际机场以及广泛的公路和铁路网络。这使其成为在马来西亚境内和东南亚其他地区分销货物的理想地点。
        </li>
        <li><strong>工业中心</strong>：新山拥有多个工业区和制造工厂，吸引了来自各个不同行业的公司。&nbsp;</li>
        <li><strong>物超所值</strong>：由于其战略位置，在新山运营比其他主要城市更具成本效益</li>
        <li><strong>熟练的劳动力</strong>：新山拥有大量熟练劳动力，包括物流和供应链管理方面的专业人士。&nbsp;</li>
      </ul>
      <p class="gt-block">位于 马来西亚新山
        是对 马来西亚吉隆坡,
        槟城&nbsp;及 纳闽 办事处已由
        Crane Worldwide Logistics Malaysia 运营。</p>
      <p>马来西亚办事处由全球网络提供支持，提供空运、海运、海关服务以及全套供应链运营和物流服务。&nbsp;</p>
      <p class="gt-block">随着围绕 柔佛-新加坡经济特区
        (JS-SEZ)，一项倡议 新加坡&nbsp;及 马来西亚> 对于业务合作而言，Crane Worldwide
        新开设的办事处将发挥优势，最大程度地扩大跨境经济连通性和国际发展的机会。</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>`
    },
    {
      id: '5',
      time: '2024 年 5 月 1 日',
      title: '自动化、创造力和尖端技术',
      desc: '欢迎加入我们在科罗拉多州丹佛市举行的 Boomi 世界会议。',
      detail: `<h1>自动化、创造力和尖端技术</h1>
      <p>通过利用自动化、创造力和尖端技术，Crane Worldwide 不仅克服了与数据输入相关的挑战，还为卓越运营制定了新标准。</p>
      <p>这一转变节省了成本并提高了客户的满意度，这表明智能技术对于推动卓越的业务流程和成果至关重要。</p>
      <ul>
        <li>每辆卡车的货运量减少 80%，优化物流运营。&nbsp;</li>
        <li>数据输入工作量减少了 4 倍，相当于四名全职员工，从而提高了工作效率和准确性。&nbsp;</li>
        <li>可靠、安全的信息管理。&nbsp;</li>
      </ul>
      <h2>Boomi Technologies 的战略解决方案</h2>
      <p><img alt="" class="align_right"
              src="https://www.craneww.com/site/assets/files/4017/microsoftteams-image_28.320x0-is.png" width="320">详细了解
        Crane Worldwide 如何利用一套 Boomi 技术实现运输流程关键部分的自动化和改进，从而实现运营转型。</p>
      <p class="gt-block">加入我们吧 <strong><strong>丹佛</strong>，科罗拉多州布米世界会议</strong>
        6 年 9 月 2024 日至 XNUMX 日期间。&nbsp;</p>
      <p>&nbsp;</p>
      <p align="center" class="gt-block">
        <a center="" class="button button_size_lg button_color_secondary"
           href="https://web.cvent.com/event/7b9e7e90-aa93-45c6-8887-66698d9993a6/summary"
           onclick="ga('send', { hitType: 'event', eventCategory: 'Button', eventAction: 'Click here to register', eventLabel: 'ULD' });">点击这里注册</a>
      </p>
      <p align="center">&nbsp;</p>`
    },
    {
      id: '6',
      time: '2024 年 3 月 25 日',
      title: 'Crane Worldwide Logistics 庆祝科克 3PL 仓库扩建',
      desc: '为了扩大其在爱尔兰的第三方物流业务，克瑞全球物流在科克开设了展示仓库设施，加强了其在爱尔兰的仓库足迹，并为该县带来了就业机会。',
      detail: `<h1>Crane Worldwide Logistics 庆祝科克 3PL 仓库扩建。&nbsp;</h1>
      <p class="gt-block">
        <em>为了扩大其在爱尔兰的第三方物流业务，克瑞全球物流在科克开设了展示仓库设施，加强了其在爱尔兰的仓库足迹，并为该县带来了就业机会。</em>
      </p>
      <p class="gt-block"><a href="https://zh-cn.craneww.com/">Crane Worldwide Logistics</a>供应链解决方案领域的领导者最近举办了一场开幕活动，庆祝其开业
        科克县的新仓库。新工厂位于
        Harbour Gate Business Park，毗邻 Waterford N25 和都柏林 M8 公路网，可轻松前往科克机场和 Ringaskiddy 港口。黄金地段是一座占地
        126,000 平方英尺的仓库设施，地理位置优越，是爱尔兰和国际客户的主要配送中心。</p>
      <p><img alt="" class="align_center"
              src="https://www.craneww.com/site/assets/files/3900/crane_cork_18.789x0-is.jpg" width="789"></p>
      <p class="gt-block"><strong>财政部长 Michael McGrath TD</strong>，参加了庆祝新设施开业的庆祝活动&nbsp;<a
          href="https://www.idaireland.com/">爱尔兰IDA</a> 并且说：<em>
        “克瑞环球物流新工厂的开业标志着这家多年来在科克经济增长中发挥着重要作用的公司又取得了里程碑式的发展。对于希望扩大业务的企业来说，轻松前往科克机场和林加斯基迪港至关重要，而克瑞全球物流的新仓库地理位置优越，可以支持国内和国际企业增强其配送能力。我祝愿克瑞环球物流的管理层和员工在未来几年取得成功。”</em>
      </p>
      <p>客户、合作伙伴和员工出席了开幕活动，庆祝克瑞环球物流在爱尔兰的持续发展，并荣获爱尔兰物流和运输奖 3 年 2023PL 成就奖。&nbsp;</p>
      <p class="gt-block">
        <em>“对于我们在爱尔兰的团队来说，这是一个开创性的庆祝活动，他们不懈地努力，让新的科克仓库在地图上名声大噪。”</em> 注释
        <strong>Gerard Ryan，Crane Worldwide 全球商务总裁。</strong></p>
      <p class="gt-block"><em>“对这一优质房地产的投资为公司提供了一个机会，可以通过量身定制的 3PL
        支持来增强其分销能力，并在该县开发就业机会。我们感谢我们的忠实客户、合作伙伴和杰出人士的所有支持，今天科克工厂正式开业。”</em>，他补充道。
      </p>
      <p>随着越来越多的公司涌入爱尔兰寻找共享和专用仓库设施，Crane Worldwide
        的投资证明了该公司继续致力于吸引新业务，不仅是在科克，而且是在香农和都柏林，该公司在这两个地区已经拥有了稳固的业务。</p>
      <p class="gt-block"><strong>爱尔兰投资发展局首席执行官 Michael Lohan</strong> 说过 <em>“克瑞环球物流决定扩大其在爱尔兰的业务并在科克建立先进的制造供应链业务，这是一个非常受欢迎的消息。这项战略投资凸显了克瑞对爱尔兰的长期承诺，也是对其爱尔兰业务投下的信任票。我祝愿克瑞环球物流的此次扩张取得圆满成功。”</em>
      </p>
      <p class="gt-block">随着其在爱尔兰和世界各地的不断发展，这家私营物流公司不断寻找高素质员工加入其不断壮大的团队。有空缺职位
        <strong><a
            href="/newsDetail?type=press&id=3">这里。</a>.</strong></p>
      <p class="gt-block"><em>（以上照片为：Faye Murphy 和 James Farrell，爱尔兰 IDA 财政部长，Michael McGrath TD，Gerard
        Ryan - Crane Worldwide 全球商业总裁 Jason Stretton，Crane Worldwide 欧洲、中东和非洲区域副总裁，Jack Lenihan -
        爱尔兰董事总经理，照片信用：ProVision）</em></p>
      <hr>
      <h2>新软木仓库的主要特点：</h2>
      <ul>
        <li>126,000 平方英尺</li>
        <li>与机场和港口的良好连接</li>
        <li>6 个装货门 / 12 个装卸平台</li>
        <li>重型车辆停车场</li>
        <li>按照 NZEB 标准建造（近零能耗建筑）</li>
      </ul>
      <p class="gt-block">在中国、德国、意大利、韩国和美国的 <a href="https://www.iltawards.ie/shortlist">2023
        年爱尔兰物流和运输奖</a>Crane Worldwide Ireland 因其为爱尔兰需要 3PL 运营的客户提供量身定制的服务而荣获 3PL 成就奖。
        去年，该公司还因其 卓越运营
        在新冠病毒危机期间，向全国各地的医院提供必要的设备。&nbsp;</p>
      <p>Crane Worldwide Logistics 在爱尔兰经历了显着的增长，新的科克仓库将为不断增长的综合物流服务需求提供额外的容量。&nbsp;<img
          alt="卓越物流奖标志" class="align_center"
          src="https://www.craneww.com/site/assets/files/3900/ireland_awards.png" width="805"></p>`
    },
    {
      id: '7',
      time: '2024 年 3 月 11 日',
      title: '2024 年运输和物流女性奖',
      desc: '物流和运输女性奖授予了 Crane Worldwide Logistics 的 Edith Denieffe。',
      detail: ` <h1>欧洲、中东和非洲地区卓越运营总监荣获 2024 年物流与运输女性奖</h1>
      <p><img alt="爱尔兰物流颁奖典礼" class="align_right"
              src="https://www.craneww.com/site/assets/files/3978/ilta_2024_edith_denieffe.320x0-is.jpg" width="320">物流和运输部门是全球商业的支柱，促进了货物在各大洲精准高效的流动。它的重要性怎么强调都不为过，因为它不仅保证了国际贸易的顺利运行，而且推动了技术和可持续发展的进步。&nbsp;
      </p>
      <p>
        认可该领域的卓越人才至关重要。它不仅庆祝那些领先者所取得的成就，还为其他人树立了榜样，鼓励货运代理、合同物流和综合物流解决方案持续改进的文化。</p>
      <p>让我们在这个国际妇女节更深入地了解一个人的历程，以及她最近在 7 月 XNUMX 日举行的爱尔兰物流和运输奖中成功赢得物流和运输女性奖——伊迪丝·德尼芙
        (Edith Denieffe)！</p>
      <h2>领导者之旅：伊迪丝·德尼芙赢得国家奖的道路。</h2>
      <p class="gt-block">克瑞全球物流欧洲、中东和非洲地区卓越运营区域总监伊迪丝·德尼芙 (Edith Denieffe) 是今年表彰的杰出人物之一
        <a href="https://www.iltawards.ie/">爱尔兰物流和运输奖</a>。她的专长在于运营，并且在运输和物流行业拥有悠久的历史。
      </p>
      <p>伊迪丝·德尼芙 (Edith Denieffe)
        在物流和运输领域的辉煌职业生涯证明了她对卓越的坚定承诺。她的成功之路充满了开创性的举措，这些举措不仅推动了克瑞全球物流向前发展，而且激励和推动了她的团队成员。她被许多人视为榜样。</p>
      <p class="gt-block">最初管理 爱尔兰业务
        对于总部位于香农、科克和都柏林的 Crane Worldwide Logistics，她通过自己的实践经验改进了流程，推动业务向前发展。最近，伊迪丝担任卓越运营总监，继续通过
        KPI 驱动的流程与欧洲、中东和非洲团队分享她的经验和知识，以实现卓越运营。从整合尖端技术到倡导可持续实践，德尼芙的贡献众多且多种多样，体现了她的创新精神和奉献精神。&nbsp;
      </p>
      <p>此外，她对企业社会责任 (CSR) 目标的承诺在她与 Crane Cares 的工作中得到了充分体现。</p>
      <h2>克瑞关怀：对社区和行业的承诺</h2>
      <p class="gt-block">在伊迪丝·德尼芙 (Edith Denieffe) 的参与和倡导下， <a
          href="/about?type=community">起重机关爱计划</a>
        堪称企业责任与行业创新完美融合的光辉典范。这一举措超越了典型的企业社会责任 (CSR) 努力，利用公司的物流能力创造社会效益，从而体现了
        Denieffe 回馈社区的根深蒂固的信念。&nbsp;</p>
      <p>例如，Crane Cares
        计划中的“扫盲物流”活动利用公司的物流网络向服务不足的社区分发书籍，展示了物流支持社区服务的潜力。</p>
      <p>
        伊迪丝自己的贡献也许最引人注目的是她支持慈善机构在乌克兰提供人道主义援助的工作，这使得爱尔兰的捐款能够凭借她的运输知识和跨境流程的经验到达乌克兰。</p>
      <h2>成功基准：卓越的标准</h2>
      <p><img alt="爱尔兰物流奖获得者" class="align_right"
              src="https://www.craneww.com/site/assets/files/3978/ilta_2024_edith_denieffe_2-1.320x0-is.jpg"
              width="320">专家评审团为颁奖典礼制定的标准非常全面，反映了物流和运输领域卓越表现的多方面性。提名者将根据一系列资格进行评估，从技术进步到领导力和创新，确保只有最值得的候选人才能获得认可。
      </p>
      <p class="gt-block">伊迪丝·德尼芙 (Edith Denieffe) 的职业生涯体现了她的创新方法，不仅优化运营，还优化超出她典型职责范围的优化。
        Crane Worldwide 希望通过国际货运代理和合同物流能力继续在全球范围内扩张，包括最近在科克，
        爱尔兰，在 哥伦布、俄亥俄州和&nbsp;约翰内斯堡
        以南非为例，她的优势和伟大将继续成为我们所有人的榜样。&nbsp;</p>
      <h2>认可的影响：超越颁奖典礼</h2>
      <p>
        在颁奖典礼上获奖是一项重大成就，其意义远远超出了活动本身。对于伊迪丝·德尼芙来说，这种认可是对她在爱尔兰国家层面的辛勤工作和奉献精神的认可。在国际妇女节前夕，这及时提醒人们，多样性和包容性对于引领增长和创新至关重要。</p>
      <p>2023 年，伊迪丝被欧洲、中东和非洲地区的同事评选为最佳员工，以表彰她从该地区同事那里获得的尊重和启发。&nbsp;</p>
      <h2>未来愿景：物流和运输领域的领先企业</h2>
      <p>像伊迪丝·德尼芙这样的领导者在塑造物流和运输行业的未来方面发挥着至关重要的作用。在庆典上庆祝伊迪丝·德尼芙 (Edith
        Denieffe)
        的成就和获得国家奖是物流和运输行业认识到她的工作所带来的变革性影响的一个机会。支持她的提名是为了庆祝她所代表的卓越，并激发该行业内的创新文化和战略远见。</p>
      <p>女性榜样对于下一代至关重要，克瑞环球物流为支持像 Deniefe 这样的领导者而感到自豪，他们的努力推动了行业向前发展，并为创新和卓越的未来铺平了道路。&nbsp;</p>`
    },
    {
      id: '8',
      time: '2024 年 2 月 28 日',
      title: '澳大利亚的 Crane Cares - 支持我们当地的社区',
      desc: 'Crane Worldwide Logistics 赞助当地 AFL 社区足球，推出一款本土设计的跳线。 珀斯的 Crane Cares 支持当地球队 Ocean Ridge Eagles。',
      detail: `<h1>与珀斯 AFL 足球队续签 2024 年赞助协议。</h1>
      <p><img alt="踢 AFL 橄榄球的女孩" class="align_right"
              src="https://www.craneww.com/site/assets/files/3769/image_1.320x0-is.jpg" width="320">克瑞环球物流很高兴以白金赞助商的身份继续对
        Ocean Ridge Eagles AFL 队提供赞助。&nbsp;</p>
      <p>作为对珀斯当地 AFL 球队的持续投资，位于珀斯的 Crane Worldwide Logistics 续签了 2024 年赛季的赞助协议。</p>
      <p>从食品捐赠活动到当地慈善支持，Crane Worldwide 的外展计划“Crane Cares”在我们开展业务的当地社区中非常活跃。</p>
      <p class="gt-block">有关起重机关怀的更多信息，请点击 <strong><a
          href="/about?type=community">这里。</a></strong>
      </p>
      <hr>
      <h1>珀斯当地 AFL 球队 Ocean Ridge Eagles 的骄傲赞助商。&nbsp;</h1>
      <p class="gt-block">作为我们对当地社区持续支持的一部分，2022 年 XNUMX 月，珀斯的 Crane Worldwide Logistics， 澳大利亚
        致力于赞助当地的 AFL 球队 Ocean
        Ridge Eagles。</p>
      <p>AFL（澳大利亚足球联赛）于 XNUMX 月中旬开始，我们的社区与当地珀斯队的参与充分展示了具有强烈本土意义的新 Crane
        Worldwide 跳线。</p>
      <p>该设计包含几个关键特征：</p>
      <ul>
        <li><strong>Waalitj</strong> - 鹰代表太阳和地球的守护者，飞得最高。 太阳搁在它的胸前，下方的万物代表着它的守护。
          跳投老鹰的位置代表了俱乐部和球员的未来。
        </li>
        <li><strong>金达&nbsp;</strong>- Djinda 是一个 Noongar 词，意思是“星星”。 生活中的明星和社区中的明星，Djinda 代表那些通过
          kanangoor ‘闪耀’来指导他们的家庭和社区的人。 Djinda 星也代表了逆境求生和保护家人安全的决心。&nbsp;
        </li>
        <li><strong>希思里奇公园 </strong>- 原住民艺术作品通常包含非常重要的地方。
          代表公园的圆形图像装饰有“U”形，这些“U”形已融入设计中以代表球员，在外缘代表支持者、志愿者和教练组。
        </li>
        <li><strong>比迪比迪</strong> ——走正道。 Noongar 艺术品通常代表穿越时间和跨越国家的旅程。
          跳投上的圆圈符号代表球队前往客场比赛的对手球队的位置。 路径上的蓝线代表俱乐部的历史时期。
        </li>
        <li><strong>诺比尼·卡南古尔——&nbsp;</strong>Waalitj 佩戴的太阳标志作为荣誉徽章代表了我们社区的一个重要故事。 20 年
          2022 月 22 日，布罗迪（伍德）肯尼去世，享年 22 岁。他的年龄由环绕太阳的 XNUMX 个点表示。
          布罗迪是莎朗·伍德·肯尼和布拉德·肯尼的儿子，是足球俱乐部和更广泛社区中一位重要且深受喜爱的成员。 他被代表为太阳和战士。
          布罗迪被他的母亲亲切地称为“Sonshine”。&nbsp;
        </li>
        <li><strong>额朗旺卡</strong> - 我们的故事，这种设计出现在球衣背面，代表了俱乐部的过去、现在和未来。
          四个波浪代表位于希思里奇公园正西的 Mullaloo 海滩。 圆圈代表 Ocean Ridge 的高级和初级俱乐部，而黑点代表我们的七个高级俱乐部。
          黄点代表俱乐部44年的历史。&nbsp;
        </li>
        <li><strong>和牛</strong> - Wagyi 是彩虹蛇的 Noongar 化身。 Wagyi 是一种像蛇一样的梦幻生物，负责创造天鹅河和坎宁河，以及西澳大利亚西南部的其他水道和景观。
          可以看到 Wagy 穿过跳线，就像它在创造球队比赛的景观时一样。
        </li>
      </ul>
      <p>在最近的赛季开始前的试赛中，新的本土设计的套头衫以一个完整的仪式发布，包括当地的土著长者。</p>
      <p>“我们希望 Ocean Ridge Eagles 在即将到来的 AFL 赛季中取得最好的成绩，并且很高兴有机会支持我们当地的俱乐部，这是我们对当地社区持续承诺的一部分，”Crane
        澳大利亚董事总经理 Peter O'Brien 评论道全球物流。</p>
      <p>“非常感谢所有支持本土跳线设计的人，这对团队具有很强的文化相关性”，他补充道。</p>`
    },
    {
      id: '9',
      time: '2024 年 2 月 28 日',
      title: '法兰克福仓库：德国 Crane Worldwide Logistics 的扩建',
      desc: '随着对法兰克福仓库空间的需求增加，Crane Worldwide 正在扩大在德国的产能。',
      detail: `<h1>德国金斯海姆-古斯塔夫斯堡（法兰克福附近）的仓库</h1>
      <p class="gt-block"><strong>法兰克福仓库——现已开业！</strong></p>
      <p class="gt-block">
        <img alt="法兰克福仓库" class="align_right"
             src="https://www.craneww.com/site/assets/files/3905/ginsheim_sr_1826-hdr_small_1.320x0-is.jpg"
             width="320">明确关注客户服务，Crane Worldwide Logistics 将在金斯海姆-古斯塔夫斯堡
        (Ginsheim-Gustavsburg) 附近开设一个新仓库 法兰克福.&nbsp;</p>
      <p class="gt-block">新仓库设施位于 VGP 商业园区内，毗邻 A60 和 A671 公路网，距离市中心仅 35 公里。 <a
          href="https://www.frankfurt-airport.com/en.html">法兰克福机场</a> 距离新工厂不到 25 公里，也很方便到达。</p>
      <p>法兰克福新仓库的黄金地段将使 Crane Worldwide 的国际客户能够利用法兰克福作为分销中心扩大其在中欧的业务。
        德国法兰克福是通往中欧的重要门户。</p>
      <h2>法兰克福新仓库的主要特点：</h2>
      <ul>
        <li>4.050 平方米仓库和 200 平方米办公室</li>
        <li>与法兰克福机场的便捷连接&nbsp;</li>
        <li>4 个带调平器的码头 / 1 个防风门</li>
        <li>8.500 个托盘容量</li>
        <li>安装了极窄通道货架系统 (VNA)</li>
      </ul>
      <p class="gt-block">通过空运、海运和报关服务，法兰克福仓库的额外容量将扩大为 Crane Worldwide 客户提供的综合物流服务。
        3PL 服务包括完整的 <a
            href="/service?type=contract">合同物流服务</a> 在新仓库。&nbsp;
      </p>`
    },
    {
      id: '10',
      time: '2023 年 8 月 7 日',
      title: 'Crane Worldwide 庆祝成立 15 周年及其在物流领域的传承',
      desc: 'Crane Worldwide 从零开始发展 3PL，庆祝成立 15 周年。',
      detail: ` <h2><em>今天，克瑞全球物流公司正在举办全球庆祝活动，以纪念其运营十五周年。</em></h2>
      <p>今天，克瑞全球物流公司正在举行全球庆祝活动，庆祝其运营十五周年。</p>
      <p>2008 年，Crane Worldwide Logistics 在德克萨斯州休斯顿开业。 如今，该公司与客户的合作伙伴关系已扩展到全球 130
        多个地点。</p>
      <p class="gt-block">主席 <a
          href="/leader?id=1">Jim
        Crane</a> Crane Worldwide Logistics的创始人利用其丰富的物流经验从零开始创办了这家全球供应链公司。
        该私营组织借鉴过去的经验，致力于根据客户需求创建灵活的综合物流解决方案。</p>
      <p>十五年来，该组织与全球客户建立了牢固的合作伙伴关系，通过有机增长，在国际上留下了足迹。 Crane Worldwide
        继续在需要额外物流支持的地方进行大量投资。</p>
      <p>在当今世界，先进技术对于卓越的客户体验至关重要。
        该公司继续投资于其技术方法，包括一个全球平台、灵活快速的数据库结构以及多用途集成，以提高各方之间的效率和强有力的协作。</p>
      <p class="gt-block">“我们非常幸运，我们的组织内拥有敬业、充满热情且经验丰富的员工，其中许多人从一开始就和我们在一起，”评论道
        <a href="/leader?id=2">贾里德·克兰（Jared
          Crane）</a>Crane Worldwide 总裁，“我们的员工发挥着重要作用，十五年是庆祝我们从头开始发展业务所取得的成就的一个重要里程碑，”他补充道。
      </p>
      <p>
        “随着我们的不断发展，我们将继续吸引最优秀的人才加入我们的业务；关系至关重要，因为我们专注于客户的体验和卓越的服务。我们衷心感谢我们的客户、合作伙伴和员工的信任、协作和团队合作，我们对持续投资以进一步发展公司以满足全球客户的需求感到兴奋。”&nbsp;</p>`
    },
  ]
}
export const exitData = {
  list: [
    {
      id: '1',
      time: '2023 年 3 月 31 日',
      title: '英国 CPTPP 贸易协定',
      desc: '英国与跨太平洋伙伴关系全面进步协定 (CPTPP) 贸易协议得到确认',
      detail: ` <h1>英国 - 跨太平洋伙伴关系更新的全面和渐进协议</h1>
        <p>今天，即 31 月 XNUMX 日星期五，贸易谈判结束后，英国已被正式接纳为印度-太平洋贸易集团或跨太平洋伙伴全面进步协定
          (CPTPP) 的加入成员，这是最重要的自英国离开欧盟以来的贸易协定。 目前的成员包括澳大利亚、文莱、加拿大、智利、日本。
          马来西亚、墨西哥、新西兰、秘鲁、新加坡和越南，英国将成为伙伴关系中唯一的欧洲国家。</p>
        <p>英国与其他 11 个成员之间的贸易将变得更加容易，提供进入印度洋-太平洋地区的机会，该地区的总 GDP 为 9
          万亿英镑，随着英国的加入，增长到 11 万亿英镑，如果科斯塔已正式申请加入的黎加、厄瓜多尔和乌拉圭被接纳。 该地区目前的人口约为
          13 亿。</p>
        <p>英国可以预期英国对欧盟的出口将增加 1.7 亿英镑，其中 99% 的关税将被取消。</p>
        <blockquote><p class="gt-block">您在英国出口方面需要帮助吗？ 请求报价 <strong><a
            href="/quotation">这里。</a></strong></p></blockquote>`
    },
    {
      id: '2',
      time: '2022 年 11 月 15 日',
      title: '英国产品符合性 - CE 标志将在未来 2 年内获得认可',
      desc: '企业将获得英国产品标记的灵活性',
      detail: `<h1>UKCA 产品符合性延迟</h1>
      <p>1985 年，欧盟引入了一项要求，即在欧洲经济区 (EEA) 内销售的某些受监管产品必须具有 CE 标志（The Conformitè
        Europëenne Mark）形式的强制性合格标志，以证明商品符合欧盟指令中规定的某些标准，涵盖产品合规性和安全性。</p>
      <p class="gt-block">英国一直承认该标准，但是，随着英国在 2020 年退出欧盟，英国政府一直热衷于摆脱 CE
        标志，取而代之的是英国合格标志，称为英国合格评定（<em>英国商会</em>) 标志，尽管英国各地的企业强烈支持保留 CE 标准。
      </p>
      <p class="gt-block">31 年 2020 月 2019 日，《XNUMX 年产品安全和计量等（修正案等）（欧盟出口）条例》生效，该条例规定受管制产品必须标有新的英国合格标准标志
        UKCA，但是， CE 标志仍将被视为符合要求，直到 <strong>1st一月2023 </strong>因此，两年被认为是企业调整的足够时间。</p>
      <p>自立法出台以来，英国和全球许多其他国家在过去两年中经历了一些艰难的贸易条件，从 Covid
        大流行到最近由于乌克兰战争和由此导致的高能源成本导致市场放缓.
        许多在英国和欧洲交易受影响产品的企业担心的是，必须遵守两套标准的成本会很高，并且在困难时期会产生繁琐的繁文缛节。</p>
      <p class="gt-block">为了给企业带来一些缓解，英国商务大臣于 14 月 XNUMX 日星期一宣布，政府已采取<strong> 决定继续承认
        CE 标志 24 个月</strong>，提供在 2025 年之前使用任一标准的灵活性，并允许企业有更多时间进行调整并集中精力发展各自的业务和支持人员。
      </p>
      <p>政府还采取了措施来降低重新测试产品和标签的成本，这些措施是：</p>
      <ul>
        <li>为降低标签成本，在 31 年 2027 月 XNUMX 日之前，企业将被允许贴上 UKCA 标志，并将来自 EEA
          国家的产品的进口商信息包含在随附文件或标签上。
        </li>
        <li>在 31 年 2024 月 31 日之前进行的 CE 标志合格评定活动也将被允许被制造商用作 UKCA 标志的基础，直到 2027 年
          XNUMX 月 XNUMX 日
        </li>
      </ul>
      <p class="gt-block"><strong>友情链接：</strong><br><a
          href="https://www.gov.uk/government/news/businesses-to-be-given-uk-product-marking-flexibility">格兰特沙普斯议员的公告</a><br><a
          href="https://www.gov.uk/uk-market-conformity-assessment-bodies">英国市场合格评定机构名单</a><br><a
          href="https://www.gov.uk/guidance/product-safety-for-businesses-a-to-z-of-industry-guidance">受管制产品清单</a><br><a
          href="https://www.gov.uk/guidance/product-safety-law-compliance-advice-for-manufacturers-and-importers">英国政府对制造商和进口商的指导</a>
      </p>
      <blockquote><p class="gt-block">UKCA代表英国合格评定（<em>英国商会</em>)&nbsp;<em>马克，您有任何欧盟/英国贸易合规问题吗？
        请随时与团队联系。</em></p></blockquote>`
    },
    {
      id: '3',
      time: '2022 年 11 月 7 日',
      title: '欧盟货运 - 更新',
      desc: '欧盟的驾驶时间和行驶记录仪立法 - 更新',
      detail: `<h1>欧洲货运更新 - 移动包</h1>
      <p>请参阅以下欧盟货运法规更新。</p>
      <h2>驾驶时间和行驶记录仪规则</h2>
      <p>自 2 年 2022 月 XNUMX 日起，您必须在过境时将您进入的国家/地区记录在行车记录仪上。 该规定的目的是使沿海航行更加可控。
        较新的行驶记录仪将自动记录过境点，但值得检查您是否需要手动进行更改。</p>
      <p class="gt-block">从 31 年 2024 月 56 日起，司机必须携带当天和过去 XNUMX 天的司机工作时间证明（工作、驾驶、待命和休息时间）。
        这是为了提高每周休息时间的控制和质量。<br>从 2026 年起，超过 2.5 吨的车辆还必须配备行驶记录仪并遵守驾驶时间规定。
        这是为了防止带有卧铺驾驶室的货车引起的竞争问题。 它还将提高道路安全性。<br>从 21 年 2023 月 3.5 日起，所有超过 2
        吨的新商用车都必须配备下一代（第 XNUMX 版）智能行驶记录仪。 这包括新的行驶记录卡。</p>
      <h2>进入欧盟的外国司机</h2>
      <p>所有欧盟工人，无论在哪个国家，都有权享有相同的工作条件。
        跨境货运和沿海运输规则对所有人都一样，以确保公平竞争和同工同酬</p>
      <h2>市场准入——附加沿海航行规则</h2>
      <p class="gt-block">从 21 年 2022 月 XNUMX 日起，在沿海运输工作量用尽后，必须遵守四天的冷静期。<br>防止非法沿海航行。
        司机和车辆必须在离开该成员国后至少八周内返回到该成员国的运营中心之一。</p>
      <h2>欧盟法规 561/2006 修正案</h2>
      <p>从 21 年 2022 月 2.5 日起，XNUMX 吨以上的跨境货运车辆现在必须遵守职业准入要求。</p>
      <p class="gt-block">可以找到详细说明这些更改的 IRU 页面的链接 <a
          href="https://www.irumobilitypackages.org/">这里。</a></p>
      <blockquote><p class="gt-block">Crane Worldwide Logistics 顾问可根据您的欧盟货运要求提供支持，请不要犹豫与我们联系
        <strong><a href="/quotation">这里。</a></strong></p></blockquote>`
    },
    {
      id: '4',
      time: '2022 年 11 月 7 日',
      title: '欧洲贸易咨询课程 - 现已推出',
      desc: '',
      detail: `<h1>欧洲贸易咨询课程</h1>
      <p class="gt-block">我们很高兴能够为您的企业提供以下欧洲贸易咨询课程，所有课程均由克瑞环球物流贸易咨询专家提供，请随时与我们联系以获取更多信息
        <strong><a href="/quotation">这里。</a></strong></p>
      <p>所有课程都可以通过 Teams 电话或现场进行演示，并且可以根据您的业务需求进行定制，其中高度鼓励委托互动。</p>
      <h3>海关——基础</h3>
      <ul>
        <li>报关</li>
        <li>文件要求</li>
        <li>法律要求</li>
        <li>了解您的商品</li>
        <li>清关后义务</li>
      </ul>
      <h3>海关估价</h3>
      <ul>
        <li>为海关目的增值</li>
        <li>必须包含的估值要素</li>
        <li>不包含</li>
        <li>海关估价方法</li>
      </ul>
      <h3>海关分类</h3>
      <ul>
        <li>解释规则</li>
      </ul>
      <h3>原产地规则</h3>
      <ul>
        <li>优惠</li>
        <li>非优惠</li>
      </ul>
      <h3>出口管制</h3>
      <ul>
        <li>背景</li>
        <li>为什么它们很重要</li>
        <li>分类</li>
        <li>授权计划</li>
      </ul>
      <h3>制裁</h3>
      <ul>
        <li>概述</li>
        <li>合规性</li>
        <li>当它出错时</li>
      </ul>
      <blockquote><p class="gt-block">需要更多信息？ 请不要犹豫与我们联系 <strong><a
          href="/%E5%92%A8%E8%AF%A2%E6%8A%A5%E4%BB%B7/">这里。</a></strong></p></blockquote>`
    },
    {
      id: '5',
      time: '2022 年 7 月 13 日',
      title: '英国和欧盟海关——重要变化',
      desc: '欧盟和英国海关流程即将发生变化的时间表。',
      detail: `<h1>英国和欧盟海关变更&nbsp;</h1>
      <p>从现在到明年 XNUMX 月，有一些变化将影响我们通知海关的方式，下面我们对这些变化进行了简要说明。</p>
      <p class="gt-block"><strong>2022 年 6 月</strong><br>自 12 年 2022 月 3
        日起，沙特阿拉伯王国政府提高了从第三国进口的各种商品的关税，包括活体动物、食品、矿产、化学品、塑料、玻璃制品、铝以及机械、设备和电气商品和汽车。
        提高关税税率的目的是保护和鼓励国内制造业和农业。</p>
      <p class="gt-block"><strong>2022 年 7 月</strong><br>1 年 2022 月 2022 日，英国政府计划引入下一阶段的边境管制，其中包括安全和安保
        (S&amp;S) 申报以及来自欧盟的货物的卫生和植物检疫 (SPS) 检查和文件，但是，这部分边境管制的实施已被推迟。 预计将在
        XNUMX 年秋季进行更新。</p>
      <p>从 5 年 2022 月 XNUMX 日星期二起，海关将不再允许新进入 CHIEF（进出口货物的海关处理）。 任何希望开始处理报关单的人现在必须请求在
        CDS（海关申报系统）中进行设置。</p>
      <p>通过 CHIEF 培训设施提交报关单的能力将于 26 年 2022 月 XNUMX
        日结束。过去，通过该设施预先提交条目非常有用，无论是在学习如何准备某些报关单方面，还是在预在不提交实时数据的情况下确定关税和税收影响。
        展望未来，经纪人现在必须依靠其海关软件的完整性或通过手动方式在提交实时数据之前预先确定某些信息。</p>
      <p class="gt-block"><strong>2022 年 9 月</strong><br>30 年 2022 月 25 日，XNUMX 年历史的英国海关系统 CHIEF 将开始逐步淘汰。
        该日期关闭的第一阶段将是终止进口系统，希望从该日期起仍希望向英国海关提交进口申报的每个人都可以通过 CDS 提交。
        使用海关代理代表他们提交数据的贸易商也将被要求注册 CDS，以便他们可以审查以其名义提交的条目并管理授权，例如延期、延期增值税会计和其他海关便利。
      </p>
      <p class="gt-block"><strong>秋季2022的</strong><br>预计英国海关 (HMRC) 将宣布下一阶段边境管制的实施时间，预计要到 4
        年第四季度才能实施</p>
      <p class="gt-block"><strong>2023 年 3 月</strong><br>1 年 2023 月 2 日，ICS2（Import Control System Version
        3）第二阶段将实施，这意味着从第三个国家安排货物进入欧盟并提出 House Air Way Bill 的货运代理将需要提前提交将安全信息导入新的
        ICS2 系统。&nbsp;</p>
      <p>CHIEF分阶段关闭的最后阶段发生在31年2023月XNUMX日，届时将无法再通过该平台提交出口申报。
        在此日期之后，所有出口报关单，就像它已经用于进口报关单一样，现在必须传输到 CDS。</p>
      <blockquote><p class="gt-block">如果您需要任何进一步的信息，请联系您当地的 Crane Worldwide 代表或联系 <strong><a
          href="/quotation">这里。</a></strong></p></blockquote>`
    },
    {
      id: '6',
      time: '2022 年 5 月 20 日',
      title: '英国的陆地边界争端 - 最新更新',
      desc: '在与欧盟达成协议导致英国退出欧盟之前，导致许多问题的主要障碍之一与保留爱尔兰共和国和英国北爱尔兰之间开放边界的解决方案有关',
      detail: `<h1>北爱尔兰议定书法案</h1>
      <p>如前所述，导致英国退出欧盟之前与欧盟达成协议的主要障碍之一与保留爱尔兰共和国和英国北爱尔兰之间开放边界的解决方案有关。
        1998 年，欧盟和英国签订了耶稣受难日协议，在经历了 30 年的“麻烦”宗派暴力之后，最终为北方带来了和平。</p>
      <p>
        该解决方案似乎包含在《北爱尔兰议定书》中，该议定书实质上将在与欧盟的陆地边界进行边境检查的要求转移到了爱尔兰海，这意味着某些从英国进入北爱尔兰的货物随后将受到文件要求的约束和物理检查，这也意味着北爱尔兰将被要求遵守欧盟法规，而不是能够放弃对英国的欧盟法规的某些要素。</p>
      <p>民主统一党（DUP）反对该议定书，理由是它在爱尔兰海实施边界并破坏北爱尔兰在英国的地位。 因此，在 5 年 2022 月 XNUMX
        日最近的 NI 议会选举之后，DUP
        拒绝在北爱尔兰与新芬党组成权力分享政府。盛芬党现在在议会中拥有更高的席位份额，但不是总体多数。</p>
      <h2>英国政府提议修改议定书</h2>
      <p>一项名为“北爱尔兰议定书法案”的新拟议英国立法中包含对议定书的单方面修改，如果实施，将取消对运往北爱尔兰的所有英国货物的所有文件和检验要求，因此取消部分最初由英国政府同意的北爱尔兰议定书。
        英国外交大臣丽兹·特拉斯向英国议会概述，该议定书自正式签署以来就造成了无法预料的问题。</p>
      <h2>会不会有什么后果？</h2>
      <p>欧盟已经明确表示，任何单方面的调整都是不可能的，如果英国决定走这条路，就会产生后果，很可能是一场可能的贸易战，这将是对目前在欧盟和英国之间进行贸易的许多企业造成的打击尤其严重。
        欧盟提供了一些可能的解决方案，其中包括放宽要求，例如大幅减少食品检查和放宽对冷冻肉的规定（见 15 年 2021 月 XNUMX
        日英国脱欧更新）</p>
      <h2>英国自脱欧以来谈判达成的贸易协议</h2>
      <p class="gt-block">可以找到 5 年 2022 月 XNUMX 日更新的英国贸易协定 <strong><a
          href="https://www.gov.uk/guidance/uk-trade-agreements-with-non-eu-countries">这里。</a></strong></p>`
    },
    {
      id: '7',
      time: '2022 年 4 月 30 日',
      title: '英国边境管制 2022',
      desc: '英国脱欧机会和政府效率部长 Jacob Rees-Mogg 先生的最新公告',
      detail: `<h1>英国对来自欧盟的货物的边境管制更新</h1>
      <p>原定于 1 年 2022 月 XNUMX 日实施的控制措施现已推迟到至少明年秋季。 拟采取的措施如下：</p>
      <ul>
        <li>对目前在目的地的欧盟进口产品进行进一步的卫生和植物检疫 (SPS) 检查的要求将转移到边境管制站 (BCP)。</li>
        <li>对欧盟进口产品的安全和安保声明的要求。</li>
        <li>对欧盟进口产品进行进一步健康认证和 SPS 检查的要求。</li>
        <li>禁止和限制从欧盟进口冰鲜肉。</li>
      </ul>
      <p class="gt-block">&nbsp;<br>政府将在今年秋季发布目标运营模式，该模式将制定英国新的边境进口管制制度，目标是 2023 年底
        <br>&nbsp;
        <br>您可以阅读英国退欧机会和政府效率部长
        Jacob Rees-Mogg 先生的公告 <strong><a
            href="https://questions-statements.parliament.uk/written-statements/detail/2022-04-28/hcws796">这里。</a></strong>
      </p>`
    },
    {
      id: '8',
      time: '2022 年 3 月 23 日',
      title: '英国报关行 - 报关服务',
      desc: '我们的英国贸易咨询和海关服务可在有关英国与欧盟过渡期的持续讨论中提供建议。 英国海关服务和保税仓储可在英国退欧的下一阶段为您提供支持。',
      detail: `<h1>提供英国海关经纪和贸易咨询 <strong>现在</strong>!&nbsp;</h1>
      <p>英国的起重机全球物流团队可为我们的客户提供与英国退欧相关的咨询，并提供英国进出口海关服务。</p>
      <p>
        我们的目标是通过合作伙伴关系的贸易咨询和海关服务，为我们在英国和国际上的客户提供持续的英国海关和物流支持。&nbsp;</p>
      <h2>在英国需要报关解决方案吗？</h2>
      <p class="gt-block"><strong>英国海关经纪</strong><br>• 英国直接代表海关申报服务<br>•进出口<br>•与英国所有主要港口和机场的海关EDI连接<br>•海关规则指导<br>•清理后的行动：责任追回，上诉等…<br>•随身携带出勤和通关
      </p>
      <p class="gt-block"><strong>无税货物移动</strong><br>•联合和公共交通<br>•未清关货物的国际运输<br>•ATA证章证：用于商品，展览，演示等…<br>•处理，储存和加快通行证<br>•组织凭证归属<br>•海关，客户和交货收集点之间的协调
      </p>
      <p class="gt-block"><strong>一般国际贸易咨询</strong><br>•有关货物进出口的文件咨询<br>•具体的定期性建议，例如市场要求，禁止和限制<br>•可能影响贸易的政治或法规变化<br>&nbsp;
      </p>
      <p class="gt-block"><strong>海关简化和授权</strong><br>•研究和建议海关申报程序，旨在节省不必要的关税/税款成本并提高效率<br>•AEO认证准备和维护<br>•简化第三国货物的加工<br>•临时进口制度<br>•临时出口制度<br>•质量体系外部审核
      </p>
      <p class="gt-block"><strong>咨询服务</strong><br>• 原产地证书<br>•生产，认证和合法化协调<br>•文件合法化</p>
      <p class="gt-block"><strong>免税存储</strong><br>•英国海关保税仓库服务<br>•英国海关临时存储（设施边检）</p>
      <p class="gt-block"><strong>关税分类</strong><br>•提供贸易商商品分类指导<br>•获得贸易商对商品具有约束力的关税裁定（eBTI）
      </p>
      <p>作为您的英国报关行和贸易咨询服务，我们将在英国退欧过渡期为您提供支持，联系我们获取有关我们现在提供的英国海关解决方案的更多信息。&nbsp;</p>
      <p class="gt-block" style="text-align: center;"><a center="" class="button button_size_lg button_color_secondary"
                                                         href="/quotation">联系我们</a></p>
      <hr>
      <h2>英国海关关于向乌克兰出口人道主义援助的指南</h2>
      <p class="gt-block">如果您正在考虑从英国向乌克兰提供援助，请查看英国税务海关总署发布的指南，其中包含有关程序的宝贵信息，包括您个人行李中的手提物品，包含的详细信息
        <strong><a
            href="https://www.gov.uk/guidance/taking-humanitarian-aid-out-of-great-britain-to-support-ukraine?utm_medium=email&amp;utm_campaign=govuk-notifications-topic&amp;utm_source=aed64ff8-7de6-4e18-a54a-4138198f9548&amp;utm_content=daily">这里。</a></strong>
      </p>
      <blockquote><p class="gt-block">Crane Worldwide Logistics 与波兰医疗团合作，为其向乌克兰医院提供医疗援助的使命提供支持，您也可以提供帮助，阅读更多
  
      </p></blockquote>`
    },
    {
      id: '9',
      time: '2022 年 3 月 4 日',
      title: '北爱尔兰协议更新 - 英国脱欧',
      desc: 'Crane Worldwide Logistics 对北爱尔兰协议“支持”协议的最新更新。',
      detail: `<h1>北爱尔兰协议更新</h1>
      <p>当英国于 2020 年 1999 月退出欧盟的单一市场和关税同盟时，英国政府和欧盟有义务维持耶稣受难日协议，其中包含北爱尔兰多部分协议和为和平带来和平的英爱协议XNUMX
        年的北爱尔兰。除了文本中的几个关键条款，例如公民身份和南北合作，英国和爱尔兰政府有义务维持共同旅行区并避免对南北边界进行控制。</p>
      <h2>北爱尔兰议定书的背景</h2>
      <p>2019 年 XNUMX 月，达成了北爱尔兰协议，这是确保欧盟-英国协议能够敲定的最后一步。
        基本上，该议定书将北爱尔兰置于欧盟的单一市场，从而消除了在爱尔兰共和国和北方之间建立硬边界的要求。
        然而，控制对于确保欧盟内部市场的安全至关重要，因此，控制是在爱尔兰海边界实施的。
        尽管某些没有进入欧盟风险的商品可以或多或少地从英国自由进入北爱尔兰，但所有商品仍然受到一定程度的繁文缛节和文件的约束，特别是被禁止的高风险食品，生加工肉类（香肠）的情况下，或在边境受到卫生控制。
        这些控制在北爱尔兰的统一派内部造成了政治摩擦，因为人们认为英国的主权正在受到侵蚀，并且该地区正在向爱尔兰共和国和欧盟靠拢。</p>
      <h2>温莎框架</h2>
      <p>自英国退欧以来，在爱尔兰陆地边界问题上的分歧持续了两年，这非常接近潜在的贸易战，英国考虑单方面取消所有控制，因为它陷入了遵守协议或冒着与反对派政治进一步破裂的风险之间的困境北方的团体。
        在与布鲁塞尔进行多次讨论后，27 年 2023 月 XNUMX 日，英国政府和欧盟委员会最终就修改议定书达成原则性协议。
        该协议被称为温莎框架，旨在大幅减少英国与北爱尔兰贸易的繁文缛节和文件，据此，没有进入欧盟风险的货物将使用绿色通道，提供几乎无摩擦的交叉。
        相反，运往欧盟的货物将进入红色通道，文件和控制仍将适用。</p>
      <h3>进一步的要点：</h3>
      <ul>
        <li>Stormont Brake 使 NI 能够在实施前决定欧盟立法的变化，但只有在北爱尔兰议会重新建立后才会适用</li>
        <li>使增值税和消费税规则在北方和南方之间出现差异成为可能</li>
        <li>新的 EU ICS2 出发前和到达前协议仍将适用于所有 GB-NI 移动&nbsp;</li>
        <li>必须维持与动植物健康相关的欧盟标准。</li>
        <li>在整个英国，药品将由英国药品和保健品监管机构监管。</li>
        <li>运往北方的植物和种子将根据英国植物护照计划进行运输，该计划无需获得欧盟植物证书</li>
      </ul>
      <blockquote><p class="gt-block">如果您对我们在英国的团队有任何疑问，请联系我们 </p></blockquote>
      <hr>
      <p>更新：2022 年 XNUMX 月</p>
      <h1>北爱尔兰议定书法案</h1>
      <p>13 年 2022 月 2018 日，英国政府提出了《北爱尔兰议定书》法案，旨在“修复”英国和欧盟在 XNUMX
        年达成的协议的某些部分，他们表示允许这样做，以便维护基本利益。</p>
      <p>该协议或“后盾”得到了爱尔兰政府和北爱尔兰政治组织 Sinn Féin、SDLP、联盟党和绿党的支持，但相反，反对任何安排的工会政党
        DUP、UUP 和 TUV将北爱尔兰与英国其他地区分开表示反对。</p>
      <p>为了避免任何会给 NI 带来麻烦的情况，于 2019 年成为首相的鲍里斯·约翰逊（Boris
        Johnson）已寻求更换保障措施，理由是这将导致政治动荡并因此违反《耶稣受难日协议》。&nbsp;</p>
      <p>英国提议改变向北爱尔兰运送货物的方法，他们认为这将保留爱尔兰共和国之间的开放边界。 哪个是：</p>
      <p>从英国到北爱尔兰的货物分为两条通道；</p>
      <p>留在北爱尔兰的货物将进入绿色通道，不会进行任何检查</p>
      <p>注定要进入欧盟的货物将被放置在红巷，在放行前将在那里进行海关和其他常规检查。</p>
      <p>尽管该法案仍处于通过英国议会的早期过渡阶段，尚未通过二读，但欧盟现已重新启动先前暂停的针对英国未能对抵达北方的货物实施边境检查的法律行动来自英国的爱尔兰对该法案的一读作出回应。
        如果民主统一党 (DUP) 没有承诺返回北爱尔兰的权力分享执行机构，该法案甚至可能不会进入二读，而北爱尔兰的权力分享执行机构于
        9 年 2022 月 XNUMX 日被他们阻止。</p>
      <p class="gt-block"><em>进一步的更新将在这里发布，如果您有任何问题，请与我们联系！</em></p>`
    },
    {
      id: '10',
      time: '2022 年 1 月 13 日',
      title: '贸易 - 英国脱欧谈判：英国和印度',
      desc: '英国脱欧最新消息：印度和英国正在讨论未来的贸易协议。',
      detail: `<h1>英印贸易谈判开始</h1>
      <p>13 年 2022 月 2 日星期四，英国和印度在新德里开始谈判，最终目标是达成一项“雄心勃勃的”自由贸易协定。 英国热衷于进入印度
        XNUMX 万亿英镑的经济，并且向 CPTPP 成员迈进了一步。</p>
      <p class="gt-block">可获得英国政府关于英国和印度之间贸易谈判的新闻稿 <strong><a
          href="https://www.gov.uk/government/news/uk-launches-india-negotiations-to-kick-off-5-star-year-of-trade?utm_medium=email&amp;utm_campaign=govuk-notifications-topic&amp;utm_source=9f836900-d249-492d-9d4a-3ca14e5e428c&amp;utm_content=daily">这里。</a></strong>
      </p>
      <p class="gt-block"><strong>在截至 2 年第二季度的四个季度中：</strong><br>• 商品和服务贸易总额为 19.8 亿英镑<br>•
        印度是英国的第 15 大贸易伙伴<br>• 英国对印度的出口总额为 7.3 亿英镑</p>
      <blockquote><p class="gt-block">如果您在英国需要海关和物流支持，请随时联系我们的专家<br>&nbsp;</p></blockquote>`
    },
  ]
}